import CoinIcon from '../components/CoinIcon';
import WalletIcon from '../components/WalletIcon';
import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import api from '../api';
import useIsMobile from '../hooks/useIsMobile';
import { FiLogOut, FiEdit, FiCheck, FiX, FiMessageCircle, FiUpload, FiSave, FiImage, FiSend, FiCreditCard, FiFileText, FiBell, FiChevronRight, FiTrash2, FiClock, FiCheckCircle, FiAlertCircle, FiAlertTriangle, FiArrowRight, FiArrowDown, FiArrowUp, FiCalendar, FiStar, FiChevronLeft, FiPlus, FiList, FiMic, FiSettings, FiLock, FiUser, FiShield, FiMail, FiMessageSquare, FiMapPin, FiUsers, FiInfo, FiExternalLink, FiTruck, FiArchive, FiEdit2, FiShoppingBag, FiCompass, FiSearch, FiFilter, FiArrowLeft, FiHelpCircle } from 'react-icons/fi';
import { playNotificationSound } from '../utils/notificationSound';
import { subscribeToPush, unsubscribeFromPush } from '../utils/pushNotifications';
import GigiBot from '../components/GigiBot';
import LoadingScreen from '../components/LoadingScreen';

import { CITY_AREAS, SA_AREAS } from '../utils/locationData';
import cleanAiText from '../utils/cleanAiText';

const CATEGORIES = ['Catering','Decor','Photography','Makeup Artists','Venues','Car Hire','Entertainment','Event Planners','Gift Packages','Gifts & Gift Shops','Other'];
const PRICE_RANGES = ['R50 - R500','R500 - R1,000','R1,000 - R5,000','R5,000 - R15,000','R15,000 - R50,000','R50,000+','Custom'];
const EVENT_TYPES = ['Wedding','Birthday','Corporate','Baby Shower','Lobola','Funeral','Other'];
const SA_BANKS = ['ABSA','Capitec','FNB (First National Bank)','Nedbank','Standard Bank','TymeBank','African Bank','Investec','Discovery Bank'];
export default function VendorDashboard() {
  const { user, logout, showToast } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState('overview');
  const [searchParams, setSearchParams] = useSearchParams();
  const [isMobile] = useIsMobile();
  const urlTab = searchParams.get('tab');
  const urlDrivenRef = useRef(false);

  // Sync URL ?tab= → internal tab state (e.g. from AppLayout bottom tabs / sidebar)
  useEffect(() => {
    if (urlTab && urlTab !== tab) {
      urlDrivenRef.current = true;
      setTab(urlTab);
    }
    // eslint-disable-next-line
  }, [urlTab]);

  // Sync internal tab state → URL (e.g. from GiGi chips, notification quick actions)
  useEffect(() => {
    if (urlDrivenRef.current) {
      urlDrivenRef.current = false;
      return;
    }
    const currentUrlTab = searchParams.get('tab');
    const desiredTab = tab === 'overview' ? null : tab;
    if (desiredTab !== currentUrlTab) {
      setSearchParams(desiredTab ? { tab: desiredTab } : {}, { replace: true });
    }
    // eslint-disable-next-line
  }, [tab]);

  // Open overlay panels when tab is set from sidebar/drawer navigation
  useEffect(() => {
    if (tab === 'browse-events') openBrowseEvents();
    else if (tab === 'community') openCommunity();
    // eslint-disable-next-line
  }, [tab]);
  const [cityGroupsExpanded, setCityGroupsExpanded] = useState(new Set());
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  // Data states
  const [bookings, setBookings] = useState([]);
  const [cancelBookingId, setCancelBookingId] = useState(null);
  const [disputes, setDisputes] = useState([]);
  const [reportModal, setReportModal] = useState(null); // { booking_id, event_title }
  const [reportSubject, setReportSubject] = useState('');
  const [reportDescription, setReportDescription] = useState('');
  const [reporting, setReporting] = useState(false);
  const [cancelReason, setCancelReason] = useState('');
  const [cancelCustomReason, setCancelCustomReason] = useState('');
  const [cancelling, setCancelling] = useState(false);
  const [rescheduleRespondDate, setRescheduleRespondDate] = useState({});
  const [deliveries, setDeliveries] = useState([]);
  const [deliveryForm, setDeliveryForm] = useState({ booking_id: null, availability_date: '', availability_start_time: '', availability_end_time: '', notes: '' });
  const [portfolio, setPortfolio] = useState([]);
  const [wallet, setWallet] = useState(null);
  const [walletMeta, setWalletMeta] = useState({});
  const [transactions, setTransactions] = useState([]);
  const [banking, setBanking] = useState(null);
  const [conversations, setConversations] = useState([]);
  const [activeChat, setActiveChat] = useState(null);
  const [chatMessages, setChatMessages] = useState([]);
  const [chatInput, setChatInput] = useState('');
  const [eventChatData, setEventChatData] = useState(null);
  const [isRecording, setIsRecording] = useState(false);
  const [recordingTime, setRecordingTime] = useState(0);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const recordingTimerRef = useRef(null);
  const [editingMessageId, setEditingMessageId] = useState(null);
  const [editContent, setEditContent] = useState('');
  const [notifications, setNotifications] = useState([]);
  const [notifToast, setNotifToast] = useState(null);
  const [notifToastExiting, setNotifToastExiting] = useState(false);
  const knownNotifIds = useRef(new Set());
  const notifToastTimer = useRef(null);
  const [profile, setProfile] = useState({});
  const [editing, setEditing] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [schedule, setSchedule] = useState([]);
  const [calMonth, setCalMonth] = useState(new Date());
  const [reviews, setReviews] = useState([]);
  const [rateCards, setRateCards] = useState([]);
  const [rateCardForm, setRateCardForm] = useState({ title: '', description: '', category: '', card_type: 'single', image_url: '', price: '', unit: 'per event', delivery_type: 'free', delivery_fee: '', booking_fee: '', booking_fee_description: '', is_quotation: false, items: [{ service_name: '', description: '', price: '', unit: 'per event', image_url: '' }] });
  const [editingRateCard, setEditingRateCard] = useState(null);
  const [showRateCardForm, setShowRateCardForm] = useState(false);
  const [savingRateCard, setSavingRateCard] = useState(false);
  const [showRateCardPicker, setShowRateCardPicker] = useState(false);
  const [showQuotationModal, setShowQuotationModal] = useState(false);
  const [quotationForm, setQuotationForm] = useState({ title: '', description: '', delivery_type: 'free', delivery_fee: '', booking_fee: '', booking_fee_description: '', expiry_date: '', notes: '', items: [{ service_name: '', description: '', price: '', unit: 'per event' }] });
  const [savingQuotation, setSavingQuotation] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [dateDetail, setDateDetail] = useState(null);
  const [vendorStats, setVendorStats] = useState({ plan: 'free', bookings_this_month: 0, total_bookings: 0, revenue_this_month: 0, total_revenue: 0 });
  const [settingsTab, setSettingsTab] = useState('');
  const [soundOn, setSoundOn] = useState(localStorage.getItem('ggr_sound') !== 'off');
  const [pushEnabled, setPushEnabled] = useState(localStorage.getItem('ggr_push') !== 'off');
  const [pushSupported, setPushSupported] = useState(false);
  const [pushPermission, setPushPermission] = useState('default');
  const [spamDismissed, setSpamDismissed] = useState(() => localStorage.getItem('ggr_spam_dismissed') === 'true');
  const [quoteEdits, setQuoteEdits] = useState({}); // booking_id → editable quote amount
  const [passwordForm, setPasswordForm] = useState({ current: '', new_password: '', confirm: '' });
  const [feedbackForm, setFeedbackForm] = useState({ rating: 5, category: 'general', message: '' });
  const [feedbackList, setFeedbackList] = useState([]);
  // Browse Events panel
  const [showBrowseEvents, setShowBrowseEvents] = useState(false);
  const [outreachEvents, setOutreachEvents] = useState([]);
  const [outreachEventsLoading, setOutreachEventsLoading] = useState(false);
  const [outreachFilters, setOutreachFilters] = useState({ event_type: '', location: '', date_from: '', date_to: '' });
  // Community Board
  const [showCommunity, setShowCommunity] = useState(false);
  const [communityPosts, setCommunityPosts] = useState([]);
  const [communityLoading, setCommunityLoading] = useState(false);
  const [newPostContent, setNewPostContent] = useState('');
  const [postingCommunity, setPostingCommunity] = useState(false);
  // Outreach compose modal
  const [showOutreachModal, setShowOutreachModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [outreachMessage, setOutreachMessage] = useState('');
  const [outreachRateCardId, setOutreachRateCardId] = useState(null);
  const [sendingOutreach, setSendingOutreach] = useState(false);
  // Message templates
  const [showTemplates, setShowTemplates] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [deactivateConfirm, setDeactivateConfirm] = useState({ password: '', reason: '' });
  const [showDeactivate, setShowDeactivate] = useState(false);
  const [bookingsFilter, setBookingsFilter] = useState('active');

  // Form states
  const [applyForm, setApplyForm] = useState({ business_name: '', business_category: '', business_description: '', business_location: '', business_price_range: '', phone: '', whatsapp_number: '', business_address: '', service_areas: '', social_facebook: '', social_instagram: '', social_tiktok: '', social_website: '', served_event_types: [] });
  const [bankForm, setBankForm] = useState({ bank_name: '', account_holder: '', account_number: '', branch_code: '', account_type: 'cheque' });
  const [withdrawAmount, setWithdrawAmount] = useState('');
  const [idNumber, setIdNumber] = useState(user?.id_number || '');
  const [savedIdNumber, setSavedIdNumber] = useState(user?.id_number || '');
  const [savingIdNumber, setSavingIdNumber] = useState(false);
  const [kycFrontFile, setKycFrontFile] = useState(null);
  const [kycBackFile, setKycBackFile] = useState(null);
  const [kycDocType, setKycDocType] = useState('id_book');
  const [uploadingKyc, setUploadingKyc] = useState(false);
  const [kycStatus, setKycStatus] = useState(user?.kyc_status || 'none');
  const [kycRejectionReason, setKycRejectionReason] = useState(user?.kyc_rejection_reason || '');
  const [galleryFiles, setGalleryFiles] = useState([]); // { file, preview } for apply form
  const galleryRef = useRef(galleryFiles);
  galleryRef.current = galleryFiles;

  const chatEndRef = useRef(null);
  const chatPollRef = useRef(null);

  useEffect(() => { checkStatus(); }, []);
  // Check push notification support
  useEffect(() => {
    const supported = !!(('Notification' in window) && ('serviceWorker' in navigator) && ('PushManager' in window));
    setPushSupported(supported);
    if (supported) setPushPermission(Notification.permission);
    // Auto-subscribe by default (unless user explicitly opted out)
    const pushOff = localStorage.getItem('ggr_push') === 'off';
    if (supported && !pushOff) {
      if (Notification.permission === 'granted') {
        navigator.serviceWorker.ready.then(reg => reg.pushManager.getSubscription().then(sub => {
          if (!sub) subscribeToPush(); // re-subscribe
        }));
      } else if (Notification.permission === 'default') {
        // Never asked — prompt automatically so push works out of the box
        subscribeToPush().then(() => setPushPermission(Notification.permission));
      }
    }
  }, []);
  // Cleanup gallery preview URLs on unmount
  useEffect(() => {
    return () => galleryRef.current.forEach(f => { if (f.preview) URL.revokeObjectURL(f.preview); });
  }, []);

  // Listen for GiGi quick-chip navigation events
  useEffect(() => {
    const handler = (e) => {
      const { action, tab: targetTab, filter } = e.detail || {};
      if (action === 'navigate' && targetTab) {
        setTab(targetTab);
        if (filter) {
          sessionStorage.setItem('ggr_vendor_filter', filter);
        }
      }
    };
    window.addEventListener('gigi-action', handler);
    return () => window.removeEventListener('gigi-action', handler);
  }, []);

  // Listen for notification bell clicks from AppLayout
  useEffect(() => {
    const handler = () => setTab('notifications');
    window.addEventListener('open-notifications', handler);
    return () => window.removeEventListener('open-notifications', handler);
  }, []);

  const checkStatus = async () => {
    try {
      const r = await api.get('/vendor/application-status');
      setStatus(r.data);
      if (r.data.vendor_status === 'approved' && r.data.terms_accepted_at) {
        loadAllData();
      }
    } catch {} finally { setLoading(false); }
  };

  const loadAllData = async () => {
    try {
      const [b, p, w, bank, conv, notif, prof, sched, rc, delv, dis] = await Promise.all([
        api.get('/vendor/bookings').catch(() => ({ data: [] })),
        api.get('/vendor/portfolio').catch(() => ({ data: [] })),
        api.get('/vendor/wallet').catch(() => ({ data: { wallet: null, transactions: [] } })),
        api.get('/vendor/banking').catch(() => ({ data: null })),
        api.get('/chat/conversations', { params: { role: 'vendor' } }).catch(() => ({ data: [] })),
        api.get('/notifications').catch(() => ({ data: [] })),
        api.get('/auth/me').catch(() => ({ data: {} })),
        api.get('/vendor/schedule').catch(() => ({ data: [] })),
        api.get('/vendor/rate-cards').catch(() => ({ data: [] })),
        api.get('/vendor/deliveries').catch(() => ({ data: [] })),
        api.get('/disputes').catch(() => ({ data: [] })),
      ]);
      setBookings(b.data);
      // Initialize editable quotes from bookings
      setQuoteEdits(prev => {
        const next = { ...prev };
        (b.data || []).forEach(bk => {
          if (bk.quote_amount && !(bk.id in next)) next[bk.id] = Number(bk.quote_amount);
        });
        return next;
      });
      setPortfolio(p.data);
      setWallet(w.data.wallet);
      setWalletMeta({ is_founding_vendor: w.data.is_founding_vendor, free_threshold: w.data.free_threshold, gross_earnings: w.data.gross_earnings, free_remaining: w.data.free_remaining, in_free_zone: w.data.in_free_zone, plan: w.data.plan || 'free', loyalty: w.data.loyalty || { total_points: 0, lifetime_points: 0, tier: null, next_tier: 'silver', next_tier_points: 250 } });
      setTransactions(w.data.transactions);
      // Keep KYC + ID state in sync with the server so an admin approval shows
      // up without the vendor having to log out and back in.
      if (w.data.kyc_status) setKycStatus(w.data.kyc_status);
      if (w.data.id_number) { setSavedIdNumber(w.data.id_number); setIdNumber(w.data.id_number); }
      setBanking(bank.data);
      if (bank.data) setBankForm(bank.data);
      setConversations(conv.data);
      setNotifications(notif.data);
      const unreadBadge = notif.data.filter(n => !n.read).length;
      try { if (navigator.setAppBadge) { if (unreadBadge > 0) navigator.setAppBadge(unreadBadge); else navigator.clearAppBadge(); } } catch {}
      // Normalize service_areas — backend may return array (PG array) or string
      const normAreas = prof.data.service_areas;
      setProfile({ ...prof.data, service_areas: Array.isArray(normAreas) ? normAreas.join(', ') : (normAreas || '') });
      setSchedule(sched.data);
      setRateCards(rc.data);
      setDeliveries(delv.data);
      setDisputes(dis.data);
      // Load reviews for this vendor
      if (prof.data?.id) {
        api.get(`/vendors/${prof.data.id}/reviews`).then(r => setReviews(r.data)).catch(() => {});
      }
      // Load vendor plan stats
      api.get('/vendor/my-stats').then(r => setVendorStats(r.data)).catch(() => {});
    } catch {}
  };

  const addGalleryFile = (file) => {
    if (galleryFiles.length >= 5) return;
    const preview = URL.createObjectURL(file);
    setGalleryFiles([...galleryFiles, { file, preview }]);
  };

  const removeGalleryFile = (index) => {
    const updated = [...galleryFiles];
    if (updated[index].preview) URL.revokeObjectURL(updated[index].preview);
    updated.splice(index, 1);
    setGalleryFiles(updated);
  };

  const submitApplication = async () => {
    try {
      const formData = { ...applyForm };
      if (formData.business_category === 'Other' && formData.other_category) {
        formData.business_category = `Other: ${formData.other_category}`;
      }
      delete formData.other_category;
      await api.post('/vendor/apply', formData);
      // Upload business gallery images
      const files = galleryRef.current;
      for (const f of files) {
        try {
          const fd = new FormData();
          fd.append('image', f.file);
          await api.post('/vendor/business-gallery', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
        } catch { /* silently skip failed uploads */ }
      }
      showToast('Application submitted!');
      checkStatus();
    } catch (e) { showToast(e.response?.data?.error || 'Failed', 'error'); }
  };

  const acceptTerms = async () => {
    try {
      await api.post('/vendor/terms/accept');
      showToast('Terms accepted! Welcome aboard!');
      checkStatus();
    } catch { showToast('Failed', 'error'); }
  };

  const updateProfile = async () => {
    try {
      await api.put('/auth/profile', profile);
      showToast('Profile updated!');
      setEditing(false);
    } catch (e) { showToast(e.response?.data?.error || e.message || 'Update failed', 'error'); }
  };

  const changePassword = async () => {
    if (passwordForm.new_password.length < 6) return showToast('Password must be at least 6 characters', 'error');
    if (passwordForm.new_password !== passwordForm.confirm) return showToast('Passwords do not match', 'error');
    try {
      await api.put('/auth/change-password', { current_password: passwordForm.current, new_password: passwordForm.new_password });
      showToast('Password updated!');
      setPasswordForm({ current: '', new_password: '', confirm: '' });
    } catch (e) { showToast(e.response?.data?.error || 'Failed', 'error'); }
  };

  const submitFeedback = async () => {
    if (!feedbackForm.message.trim()) return showToast('Please write your feedback', 'error');
    if (!profile?.id) return showToast('Profile not loaded', 'error');
    try {
      await api.post(`/vendors/${profile.id}/feedback`, { ...feedbackForm, page: 'vendor-dashboard' });
      showToast('Thank you for your feedback!');
      setFeedbackForm({ rating: 5, category: 'general', message: '' });
      loadFeedback();
    } catch { showToast('Failed', 'error'); }
  };

  const loadFeedback = async () => {
    try { const r = await api.get('/feedback'); setFeedbackList(r.data); } catch {}
  };

  const deactivateAccount = async () => {
    if (!deactivateConfirm.password) return showToast('Enter password to confirm', 'error');
    try {
      await api.post('/auth/deactivate', deactivateConfirm);
      showToast('Account deactivated');
      logout();
    } catch (e) { showToast(e.response?.data?.error || 'Failed', 'error'); }
  };

  const updateBooking = async (bid, st, quote) => {
    try {
      await api.put(`/vendor/bookings/${bid}`, { status: st, quote_amount: quote });
      showToast('Booking updated!');
      const r = await api.get('/vendor/bookings');
      setBookings(r.data);
    } catch { showToast('Update failed', 'error'); }
  };

  const sortedBookings = React.useMemo(() => {
    if (!Array.isArray(bookings)) return [];
    const filtered = bookingsFilter === 'all' ? bookings
      : bookingsFilter === 'archived' ? bookings.filter(b => b.is_archived)
      : bookingsFilter === 'paid' ? bookings.filter(b => b.status === 'confirmed' && b.payment_status === 'paid' && !b.is_archived)
      : bookingsFilter === 'confirmed' ? bookings.filter(b => b.status === 'confirmed' && b.payment_status !== 'paid' && !b.is_archived)
      : bookingsFilter === 'pending' ? bookings.filter(b => b.status === 'pending' && !b.is_archived)
      : bookingsFilter === 'cancelled' ? bookings.filter(b => (b.status === 'cancelled' || b.status === 'declined') && !b.is_archived)
      : /* active */ bookings.filter(b => !b.is_archived && !['cancelled', 'declined'].includes(b.status));
    const priority = { pending: 0, confirmed: 1, cancelled: 2, declined: 3 };
    return [...filtered].sort((a, b) => {
      const pa = priority[a.status] ?? 4;
      const pb = priority[b.status] ?? 4;
      if (pa !== pb) return pa - pb;
      return new Date(b.created_at) - new Date(a.created_at);
    });
  }, [bookings, bookingsFilter]);

  const toggleArchive = async (id) => {
    try {
      await api.post(`/vendor/bookings/${id}/archive`);
      setBookings(prev => prev.map(b => b.id === id ? { ...b, is_archived: !b.is_archived } : b));
      showToast('Booking archived');
    } catch { showToast('Failed to archive', 'error'); }
  };

  // Auto-archive bookings that are paid with completed delivery
  React.useEffect(() => {
    const autoArchiveEligible = async () => {
      if (!Array.isArray(bookings) || !Array.isArray(deliveries)) return;
      const eligible = bookings.filter(b =>
        b.status === 'confirmed' &&
        b.payment_status === 'paid' &&
        !b.is_archived &&
        deliveries.some(d => d.booking_id === b.id && d.status === 'completed')
      );
      for (const b of eligible) {
        try {
          await api.post(`/vendor/bookings/${b.id}/archive`);
          setBookings(prev => prev.map(x => x.id === b.id ? { ...x, is_archived: true } : x));
        } catch { /* skip — booking may already be archived on server */ }
      }
    };
    autoArchiveEligible();
    const interval = setInterval(autoArchiveEligible, 30000);
    return () => clearInterval(interval);
  }, [bookings, deliveries]);

  const loadDeliveries = async () => {
    try { const r = await api.get('/vendor/deliveries'); setDeliveries(r.data); } catch {}
  };
  const saveDelivery = async (bookingId, eventId, hostId) => {
    if (!deliveryForm.availability_date) return showToast('Please set an availability date', 'error');
    try {
      await api.post('/vendor/deliveries', { booking_id: bookingId, event_id: eventId, host_id: hostId, ...deliveryForm });
      showToast('Delivery schedule saved!');
      loadDeliveries();
      setDeliveryForm({ booking_id: null, availability_date: '', availability_start_time: '', availability_end_time: '', notes: '' });
    } catch (e) { showToast(e.response?.data?.error || 'Failed to save delivery', 'error'); }
  };
  const updateDeliveryStatus = async (deliveryId, newStatus) => {
    try {
      await api.put(`/vendor/deliveries/${deliveryId}/status`, { status: newStatus });
      showToast(newStatus === 'on_the_way' ? 'Host has been notified you\'re on the way!' : newStatus === 'arrived' ? 'Host has been notified of your arrival!' : 'Status updated!');
      loadDeliveries();
    } catch (e) { showToast(e.response?.data?.error || 'Failed to update status', 'error'); }
  };

  const uploadPortfolio = async (file) => {
    try {
      const fd = new FormData();
      fd.append('image', file);
      await api.post('/vendor/portfolio', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      const r = await api.get('/vendor/portfolio');
      setPortfolio(r.data);
      showToast('Image uploaded!');
    } catch (e) { showToast(e.response?.data?.error || 'Upload failed', 'error'); }
  };

  const deletePortfolio = async (id) => {
    try {
      await api.delete(`/vendor/portfolio/${id}`);
      setPortfolio(portfolio.filter(p => p.id !== id));
      showToast('Image removed');
    } catch { showToast('Failed', 'error'); }
  };

  const saveBanking = async () => {
    try {
      const r = await api.post('/vendor/banking', bankForm);
      setBanking(r.data);
      showToast('Banking details saved!');
    } catch { showToast('Failed', 'error'); }
  };

  const saveIdNumber = async () => {
    if (!idNumber) return;
    setSavingIdNumber(true);
    try {
      const r = await api.post('/vendor/save-id-number', { id_number: idNumber });
      showToast(r.data?.message || 'ID number saved');
      setSavedIdNumber(idNumber);
      // Keep the cached user in sync so the rest of the app sees the ID number
      const updated = { ...user, id_number: idNumber };
      localStorage.setItem('ggr_user', JSON.stringify(updated));
    } catch (e) { showToast(e.response?.data?.error || 'Invalid ID number', 'error'); }
    setSavingIdNumber(false);
  };

  const submitKycDocuments = async () => {
    if (!kycFrontFile) return showToast('Please select a front document image', 'error');
    setUploadingKyc(true);
    try {
      const formData = new FormData();
      formData.append('front', kycFrontFile);
      if (kycBackFile) formData.append('back', kycBackFile);
      formData.append('document_type', kycDocType);
      const r = await api.post('/user/upload-kyc', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setKycStatus('pending');
      setKycRejectionReason('');
      showToast(r.data?.message || 'Documents uploaded for review!');
    } catch (e) { showToast(e.response?.data?.error || 'Upload failed', 'error'); }
    setUploadingKyc(false);
  };

  const requestWithdrawal = async () => {
    try {
      await api.post('/vendor/wallet/withdraw', { amount: Number(withdrawAmount) });
      showToast('Withdrawal requested!');
      setWithdrawAmount('');
      const w = await api.get('/vendor/wallet');
      setWallet(w.data.wallet);
      setWalletMeta({ is_founding_vendor: w.data.is_founding_vendor, free_threshold: w.data.free_threshold, gross_earnings: w.data.gross_earnings, free_remaining: w.data.free_remaining, in_free_zone: w.data.in_free_zone, plan: w.data.plan || 'free', loyalty: w.data.loyalty || { total_points: 0, lifetime_points: 0, tier: null, next_tier: 'silver', next_tier_points: 250 } });
      setTransactions(w.data.transactions);
    } catch (e) { showToast(e.response?.data?.error || 'Failed', 'error'); }
  };

  const redeemLoyalty = async (tier) => {
    try {
      const r = await api.post('/vendor/loyalty/redeem', { tier });
      showToast(`Redeemed! ${r.data.description || tier + ' tier reward'}`);
      const w = await api.get('/vendor/wallet');
      setWallet(w.data.wallet);
      setWalletMeta({ is_founding_vendor: w.data.is_founding_vendor, free_threshold: w.data.free_threshold, gross_earnings: w.data.gross_earnings, free_remaining: w.data.free_remaining, in_free_zone: w.data.in_free_zone, plan: w.data.plan || 'free', loyalty: w.data.loyalty || { total_points: 0, lifetime_points: 0, tier: null, next_tier: 'silver', next_tier_points: 250 } });
      setTransactions(w.data.transactions);
    } catch (e) { showToast(e.response?.data?.error || 'Failed', 'error'); }
  };

  const openChat = async (convId) => {
    try {
      const r = await api.get(`/chat/conversations/${convId}/messages`);
      setActiveChat(r.data.conversation);
      setChatMessages(r.data.messages);
      setEventChatData(r.data.event || null);
      // Refresh conversations for unread counts
      const c = await api.get('/chat/conversations', { params: { role: 'vendor' } });
      setConversations(c.data);
    } catch { showToast('Failed to load chat', 'error'); }
  };

  const sendChatMessage = async () => {
    if (!chatInput.trim() || !activeChat) return;
    try {
      const r = await api.post(`/chat/conversations/${activeChat.id}/messages`, { content: chatInput });
      setChatMessages(prev => [...prev, { ...r.data, sender_name: user?.name }]);
      setChatInput('');
      if (r.data.off_platform_warning) {
        showToast(r.data.off_platform_warning, 'warning');
      }
      setTimeout(() => chatEndRef.current?.scrollIntoView({ behavior: 'smooth' }), 100);
    } catch { showToast('Failed to send', 'error'); }
  };

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mediaRecorder = new MediaRecorder(stream, { mimeType: MediaRecorder.isTypeSupported('audio/webm') ? 'audio/webm' : 'audio/mp4' });
      mediaRecorderRef.current = mediaRecorder;
      audioChunksRef.current = [];
      mediaRecorder.ondataavailable = (e) => { if (e.data.size > 0) audioChunksRef.current.push(e.data); };
      mediaRecorder.onstop = async () => {
        stream.getTracks().forEach(t => t.stop());
        const blob = new Blob(audioChunksRef.current, { type: mediaRecorder.mimeType });
        if (blob.size < 1000) { showToast('Recording too short', 'error'); return; }
        try {
          const fd = new FormData();
          fd.append('audio', blob, `voice-${Date.now()}.webm`);
          const upload = await api.post('/chat/voice-note', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
          const r = await api.post(`/chat/conversations/${activeChat.id}/messages`, { content: upload.data.url, message_type: 'voice_note' });
          setChatMessages(prev => [...prev, { ...r.data, sender_name: user?.name }]);
          setTimeout(() => chatEndRef.current?.scrollIntoView({ behavior: 'smooth' }), 100);
        } catch { showToast('Failed to send voice note', 'error'); }
      };
      mediaRecorder.start();
      setIsRecording(true);
      setRecordingTime(0);
      recordingTimerRef.current = setInterval(() => setRecordingTime(t => t + 1), 1000);
    } catch { showToast('Microphone access denied', 'error'); }
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current && mediaRecorderRef.current.state === 'recording') mediaRecorderRef.current.stop();
    setIsRecording(false);
    clearInterval(recordingTimerRef.current);
  };

  const cancelRecording = () => {
    if (mediaRecorderRef.current && mediaRecorderRef.current.state === 'recording') {
      mediaRecorderRef.current.ondataavailable = null;
      mediaRecorderRef.current.onstop = () => { mediaRecorderRef.current.stream?.getTracks().forEach(t => t.stop()); };
      mediaRecorderRef.current.stop();
    }
    setIsRecording(false);
    setRecordingTime(0);
    clearInterval(recordingTimerRef.current);
  };

  // Poll for new messages when chat is open
  useEffect(() => {
    if (activeChat && tab === 'chats') {
      let prevMsgCount = 0;
      chatPollRef.current = setInterval(async () => {
        try {
          const r = await api.get(`/chat/conversations/${activeChat.id}/messages`);
          if (r.data.messages.length !== prevMsgCount) {
            setChatMessages(r.data.messages);
            prevMsgCount = r.data.messages.length;
          }
        } catch {}
      }, 5000);
    }
    return () => clearInterval(chatPollRef.current);
  }, [activeChat, tab]);

  useEffect(() => {
    setTimeout(() => chatEndRef.current?.scrollIntoView({ behavior: 'smooth' }), 100);
  }, [chatMessages]);

  useEffect(() => { if (tab === 'settings') loadFeedback(); }, [tab]);

  // Poll for new notifications every 30s, show WhatsApp-style toast for new ones
  useEffect(() => {
    let prevCount = 0;
    const poll = setInterval(async () => {
      try {
        const r = await api.get('/notifications');
        const newUnread = r.data.filter(n => !n.read).length;

        // Show WhatsApp-style toast for genuinely new notifications
        const newOnes = r.data.filter(n => !knownNotifIds.current.has(n.id) && !n.read);
        if (newOnes.length > 0 && prevCount > 0) {
          const latest = newOnes[0];
          setNotifToastExiting(false);
          setNotifToast(latest);
          clearTimeout(notifToastTimer.current);
          notifToastTimer.current = setTimeout(() => {
            setNotifToastExiting(true);
            setTimeout(() => { setNotifToast(null); setNotifToastExiting(false); }, 300);
          }, 5000);
        }
        r.data.forEach(n => knownNotifIds.current.add(n.id));

        if (newUnread > prevCount && prevCount > 0 && localStorage.getItem('ggr_sound') !== 'off') {
          playNotificationSound();
          try { if (navigator.setAppBadge) navigator.setAppBadge(newUnread); } catch {}
        } else if (newUnread !== prevCount) {
          try { if (navigator.setAppBadge) { if (newUnread > 0) navigator.setAppBadge(newUnread); else navigator.clearAppBadge(); } } catch {}
        }
        prevCount = newUnread;
        setNotifications(r.data);
      } catch {}
    }, 30000);
    return () => clearInterval(poll);
  }, []);

  const markNotificationsRead = async () => {
    try {
      await api.put('/notifications/read-all');
      setNotifications(n => n.map(x => ({...x, read: true})));
      try { if (navigator.clearAppBadge) navigator.clearAppBadge(); } catch {}
    } catch {}
  };

  // Rate card functions
  const defaultRateCardForm = { title: '', description: '', category: '', card_type: 'single', image_url: '', price: '', unit: 'per event', delivery_type: 'free', delivery_fee: '', booking_fee: '', booking_fee_description: '', is_quotation: false, items: [{ service_name: '', description: '', price: '', unit: 'per event', image_url: '' }] };
  const saveRateCard = async () => {
    const isSingle = rateCardForm.card_type === 'single';
    if (!rateCardForm.title) { showToast('Add a title', 'error'); return; }
    if (isSingle && !rateCardForm.price) { showToast('Add a price', 'error'); return; }
    if (!isSingle) {
      const validItems = rateCardForm.items.filter(i => i.service_name && i.price);
      if (!validItems.length) { showToast('Add at least one item to your package', 'error'); return; }
    }
    if (savingRateCard) return;
    setSavingRateCard(true);
    try {
      const payload = isSingle
        ? { ...rateCardForm, items: [] }
        : { ...rateCardForm, items: rateCardForm.items.filter(i => i.service_name && i.price) };
      if (editingRateCard) {
        await api.put(`/vendor/rate-cards/${editingRateCard}`, payload);
      } else {
        await api.post('/vendor/rate-cards', payload);
      }
      // Refresh rate cards list
      try {
        const r = await api.get('/vendor/rate-cards');
        setRateCards(r.data);
      } catch {
        // Save succeeded but refresh failed — still show success
        console.error('Rate card saved but list refresh failed');
      }
      showToast(editingRateCard ? 'Rate card updated!' : 'Rate card created!');
      setShowRateCardForm(false);
      setEditingRateCard(null);
      setRateCardForm(defaultRateCardForm);
    } catch (e) {
      showToast(e.response?.data?.error || 'Failed to save rate card', 'error');
    } finally {
      setSavingRateCard(false);
    }
  };

  // Quotation functions
  const saveQuotation = async () => {
    if (!quotationForm.title) { showToast('Add a title', 'error'); return; }
    const validItems = quotationForm.items.filter(i => i.service_name && i.price);
    if (!validItems.length) { showToast('Add at least one item to the quotation', 'error'); return; }
    if (savingQuotation) return;
    setSavingQuotation(true);
    try {
      const payload = {
        title: quotationForm.title,
        description: quotationForm.description,
        delivery_type: quotationForm.delivery_type || 'free',
        delivery_fee: quotationForm.delivery_fee || 0,
        booking_fee: quotationForm.booking_fee || 0,
        booking_fee_description: quotationForm.booking_fee_description || '',
        expiry_date: quotationForm.expiry_date || null,
        notes: quotationForm.notes || '',
        items: validItems.map(i => ({ service_name: i.service_name, description: i.description || '', price: Number(i.price), unit: i.unit || 'per event' })),
        conversation_id: activeChat?.id || null,
        event_id: activeChat?.event_id || null,
        host_id: activeChat?.host_id || null
      };
      const r = await api.post('/vendor/quotations', payload);
      showToast('Quotation sent!');
      setShowQuotationModal(false);
      setQuotationForm({ title: '', description: '', delivery_type: 'free', delivery_fee: '', booking_fee: '', booking_fee_description: '', expiry_date: '', notes: '', items: [{ service_name: '', description: '', price: '', unit: 'per event' }] });
      // Refresh chat to show the new quotation message
      if (activeChat?.id) {
        try { const m = await api.get(`/vendor/chats/${activeChat.id}/messages`); setChatMessages(m.data); } catch {}
      }
    } catch (e) {
      showToast(e.response?.data?.error || 'Failed to send quotation', 'error');
    } finally {
      setSavingQuotation(false);
    }
  };

  const deleteRateCard = async (id) => {
    try {
      await api.delete(`/vendor/rate-cards/${id}`);
      setRateCards(rateCards.filter(c => c.id !== id));
      showToast('Rate card deleted');
    } catch (e) { showToast(e.response?.data?.error || 'Failed to delete rate card', 'error'); }
  };

  const editRateCard = (card) => {
    const type = card.card_type || (card.items?.length > 0 ? 'package' : 'single');
    setRateCardForm({
      title: card.title, description: card.description || '', category: card.category || '',
      card_type: type, image_url: card.image_url || '', price: card.price || '', unit: card.unit || 'per event',
      delivery_type: card.delivery_type || 'free', delivery_fee: card.delivery_fee || '', booking_fee: card.booking_fee || '', booking_fee_description: card.booking_fee_description || '', is_quotation: card.is_quotation || false,
      items: (card.items || []).map(i => ({ service_name: i.service_name, description: i.description || '', price: i.price, unit: i.unit || 'per event', image_url: i.image_url || '' }))
    });
    if (type === 'package' && (!card.items || card.items.length === 0)) {
      setRateCardForm(prev => ({ ...prev, items: [{ service_name: '', description: '', price: '', unit: 'per event', image_url: '' }] }));
    }
    setEditingRateCard(card.id);
    setShowRateCardForm(true);
  };

  const uploadRateCardMainImage = async (file) => {
    try {
      const fd = new FormData();
      fd.append('image', file);
      const r = await api.post('/vendor/rate-card-image', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setRateCardForm(prev => ({ ...prev, image_url: r.data.url }));
      showToast('Image uploaded!');
    } catch { showToast('Image upload failed', 'error'); }
  };

  const uploadRateCardImage = async (file, idx) => {
    try {
      const fd = new FormData();
      fd.append('image', file);
      const r = await api.post('/vendor/rate-card-image', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      const items = [...rateCardForm.items];
      items[idx].image_url = r.data.url;
      setRateCardForm({ ...rateCardForm, items });
      showToast('Image uploaded!');
    } catch { showToast('Image upload failed', 'error'); }
  };

  const uploadLogo = async (file) => {
    try {
      const fd = new FormData();
      fd.append('logo', file);
      const r = await api.post('/vendor/logo', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setProfile({ ...profile, logo_url: r.data.logo_url });
      showToast('Logo uploaded!');
    } catch { showToast('Upload failed', 'error'); }
  };

  const uploadGalleryImage = async (file) => {
    try {
      const fd = new FormData();
      fd.append('image', file);
      const r = await api.post('/vendor/business-gallery', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setProfile({ ...profile, business_gallery: r.data.business_gallery });
      showToast('Image added!');
    } catch (e) { showToast(e.response?.data?.error || 'Upload failed', 'error'); }
  };

  const removeGalleryImage = async (index) => {
    try {
      const r = await api.delete(`/vendor/business-gallery/${index}`);
      setProfile({ ...profile, business_gallery: r.data.business_gallery });
      showToast('Image removed');
    } catch { showToast('Failed to remove image', 'error'); }
  };

  const sendRateCardMessage = async (cardId) => {
    if (!activeChat) return;
    try {
      const r = await api.post(`/chat/conversations/${activeChat.id}/messages`, { message_type: 'rate_card', rate_card_id: cardId });
      const msg = r.data;
      // Use backend-returned rate_card_data (includes items, prices, etc.)
      // Fall back to local state lookup if backend didn't attach it
      const rateCardData = msg.rate_card_data || rateCards.find(c => c.id === cardId);
      setChatMessages(prev => [...prev, { ...msg, sender_name: user?.name, message_type: 'rate_card', rate_card_data: rateCardData }]);
      setShowRateCardPicker(false);
      setTimeout(() => chatEndRef.current?.scrollIntoView({ behavior: 'smooth' }), 100);
    } catch (err) {
      showToast(err.response?.data?.error || 'Failed to send rate card', 'error');
    }
  };

  // ── Browse Events ──
  const loadOutreachEvents = async (filters = {}) => {
    setOutreachEventsLoading(true);
    try {
      const params = new URLSearchParams();
      if (filters.event_type) params.append('event_type', filters.event_type);
      if (filters.location) params.append('location', filters.location);
      if (filters.date_from) params.append('date_from', filters.date_from);
      if (filters.date_to) params.append('date_to', filters.date_to);
      const r = await api.get(`/vendor/outreach-events?${params.toString()}`);
      setOutreachEvents(r.data);
    } catch (e) {
      showToast('Failed to load events', 'error');
    } finally {
      setOutreachEventsLoading(false);
    }
  };

  const openBrowseEvents = () => {
    setShowBrowseEvents(true);
    loadOutreachEvents(outreachFilters);
  };

  // ── Community Board ──
  const openCommunity = () => {
    setShowCommunity(true);
    loadCommunityPosts();
  };

  const loadCommunityPosts = async () => {
    setCommunityLoading(true);
    try {
      const res = await api.get('/community/posts');
      setCommunityPosts(res.data || []);
    } catch (e) {
      console.error('Failed to load community posts:', e);
    } finally {
      setCommunityLoading(false);
    }
  };

  const submitCommunityPost = async () => {
    if (!newPostContent.trim()) return;
    setPostingCommunity(true);
    try {
      await api.post('/community/posts', { content: newPostContent.trim() });
      setNewPostContent('');
      await loadCommunityPosts();
    } catch (e) {
      console.error('Failed to create community post:', e);
    } finally {
      setPostingCommunity(false);
    }
  };

  const deleteCommunityPost = async (postId) => {
    try {
      await api.delete(`/community/posts/${postId}`);
      setCommunityPosts(prev => prev.filter(p => p.id !== postId));
    } catch (e) {
      console.error('Failed to delete post:', e);
    }
  };

  const applyOutreachFilters = (updates) => {
    const merged = { ...outreachFilters, ...updates };
    setOutreachFilters(merged);
    loadOutreachEvents(merged);
  };

  // ── One-Click Outreach ──
  const openOutreachModal = (event) => {
    setSelectedEvent(event);
    const businessName = profile?.business_name || 'A vendor';
    const preMsg = `Hi ${event.host_name}! I noticed you're planning a ${event.event_type} on ${event.event_date}. I'd love to offer my services for your event. Here's my rate card:`;
    setOutreachMessage(preMsg);
    setOutreachRateCardId(rateCards.length > 0 ? rateCards[0].id : null);
    setShowOutreachModal(true);
  };

  const sendOutreach = async () => {
    if (!selectedEvent) return;
    setSendingOutreach(true);
    try {
      const r = await api.post('/vendor/outreach', {
        eventId: selectedEvent.id,
        message: outreachMessage,
        rateCardId: outreachRateCardId || undefined,
      });
      showToast(r.data.message || 'Outreach sent!');
      setShowOutreachModal(false);
      // If a conversation was created, navigate to it
      if (r.data.conversationId) {
        loadAllData();
        setTab('chats');
      }
      // Refresh outreach events
      loadOutreachEvents(outreachFilters);
    } catch (e) {
      showToast(e.response?.data?.error || 'Failed to send outreach', 'error');
    } finally {
      setSendingOutreach(false);
    }
  };

  // ── Message Templates ──
  const loadTemplates = async () => {
    try {
      const r = await api.get('/message-templates?role=vendor');
      setTemplates(r.data);
    } catch (e) { /* silent */ }
  };
  const insertTemplate = (tpl) => {
    setChatInput(tpl.body);
    setShowTemplates(false);
    // If template hints at rate card, auto-open the picker
    if (rateCards.length > 0 && (tpl.category === 'quote' || tpl.category === 'inquiry') && (tpl.body.toLowerCase().includes('rate card') || tpl.body.toLowerCase().includes('quotation'))) {
      setTimeout(() => setShowRateCardPicker(true), 150);
    }
  };

  const archiveConversation = async (conv) => {
    if (!conv) return;
    try {
      await api.put(`/chat/conversations/${conv.id}/archive`, { archived: !conv.archived });
      showToast(conv.archived ? 'Chat unarchived' : 'Chat archived', 'success');
      loadAllData();
    } catch { showToast('Failed', 'error'); }
  };

  const deleteConversation = async (conv) => {
    if (!conv || !window.confirm('Delete this conversation and all messages? This cannot be undone.')) return;
    try {
      await api.delete(`/chat/conversations/${conv.id}`);
      showToast('Conversation deleted', 'success');
      setActiveChat(null);
      setChatMessages([]);
      loadAllData();
    } catch { showToast('Failed to delete', 'error'); }
  };

  const editMessage = async (msg, newContent) => {
    if (!newContent.trim() || newContent.trim() === (msg.content || '')) return;
    try {
      const r = await api.put(`/chat/conversations/${activeChat.id}/messages/${msg.id}`, { content: newContent });
      setChatMessages(prev => prev.map(m => m.id === msg.id ? { ...m, content: r.data.content, edited_at: r.data.edited_at } : m));
    } catch { showToast('Failed to edit message', 'error'); }
  };

  if (loading) return <LoadingScreen />;

  const unreadNotifs = notifications.filter(n => !n.read).length;
  const unreadChats = conversations.reduce((a, c) => a + (parseInt(c.unread_count) || 0), 0);

  // ─── APPLICATION / PENDING ───
  if (!status?.vendor_status || status.vendor_status === 'pending') {
    const applied = status?.vendor_status === 'pending';
    const currentStep = applied ? 2 : 1;
    return (
      <div style={{ minHeight: '100vh', background: 'var(--cream)' }}>
        <div style={{ padding: '12px 24px', borderBottom: '1px solid var(--cream-dark)', background: 'var(--white)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Link to="/"><img src="/ggr-logo-deck.png" alt="Grand Gather Registry" style={{ height: '28px' }} /></Link>
          <button onClick={() => logout()} style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '8px 14px', borderRadius: '8px', background: 'none', border: '1px solid var(--cream-dark)', cursor: 'pointer', color: 'var(--red)', fontSize: '13px', fontWeight: 600 }}><FiLogOut size={14} /> Log Out</button>
        </div>
        <div className="container" style={{ padding: '40px 20px', maxWidth: '650px', margin: '0 auto' }}>
          {/* Progress Tracker */}
          <div style={{ marginBottom: '32px' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0', marginBottom: '12px' }}>
              {[
                { step: 1, label: 'Register' },
                { step: 2, label: 'Under Review' },
                { step: 3, label: 'Terms' },
                { step: 4, label: 'Dashboard' },
              ].map((s, i) => (
                <React.Fragment key={s.step}>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: '70px' }}>
                    <div style={{
                      width: '36px', height: '36px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                      background: s.step < currentStep ? 'var(--green)' : s.step === currentStep ? 'var(--rose)' : 'var(--cream-dark)',
                      color: s.step <= currentStep ? 'white' : 'var(--gray)',
                      fontWeight: 700, fontSize: '14px', transition: 'all 0.3s'
                    }}>
                      {s.step < currentStep ? <FiCheckCircle size={18} /> : s.step}
                    </div>
                    <span style={{ fontSize: '11px', color: s.step <= currentStep ? 'var(--dark)' : 'var(--gray)', marginTop: '6px', fontWeight: s.step === currentStep ? 600 : 400, textAlign: 'center' }}>{s.label}</span>
                  </div>
                  {i < 3 && <div style={{ flex: 1, height: '2px', background: s.step < currentStep ? 'var(--green)' : 'var(--cream-dark)', marginBottom: '20px', minWidth: '30px' }} />}
                </React.Fragment>
              ))}
            </div>
          </div>

          {applied ? (
            <div className="card" style={{ textAlign: 'center', padding: '50px 40px' }}>
              <div style={{ width: '80px', height: '80px', borderRadius: '50%', background: 'rgba(234,179,8,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
                <FiClock size={36} style={{ color: 'var(--gold-dark)' }} />
              </div>
              <h2 style={{ marginBottom: '12px', fontSize: '24px' }}>Application Under Review</h2>
              <p style={{ color: 'var(--gray)', marginBottom: '8px', lineHeight: 1.6 }}>Your vendor application for <strong>{status.business_name}</strong> ({status.business_category}) is being reviewed by our team.</p>
              <p style={{ color: 'var(--gray)', fontSize: '14px', lineHeight: 1.6 }}>You'll receive a notification once your application has been processed. This usually takes 1-2 business days.</p>
              <div style={{ marginTop: '24px', padding: '16px', background: 'rgba(234,179,8,0.06)', borderRadius: '12px', border: '1px solid rgba(234,179,8,0.12)' }}>
                <p style={{ fontSize: '13px', color: 'var(--gray)' }}>Submitted: {new Date(status.vendor_applied_at).toLocaleDateString('en-ZA', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
              </div>
              <div style={{ marginTop: '24px', padding: '20px', background: 'var(--cream)', borderRadius: '12px', textAlign: 'left' }}>
                <h4 style={{ fontSize: '14px', marginBottom: '10px' }}>While you wait:</h4>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '13px', color: 'var(--gray)' }}>
                  <span>• Prepare your portfolio images (up to 5 on Starter; upgrade for more)</span>
                  <span>• Have your banking details ready</span>
                  <span>• Think about your pricing packages</span>
                </div>
              </div>
            </div>
          ) : (
            <>
              <h2 style={{ marginBottom: '8px', fontSize: '28px' }}>Register Your Business</h2>
              <p style={{ color: 'var(--gray)', marginBottom: '32px' }}>Tell us about your business to start receiving bookings from event planners across South Africa.</p>
              <div className="card" style={{ padding: '32px' }}>
                <div className="form-group"><label>Business Name *</label><input value={applyForm.business_name} onChange={e => setApplyForm({...applyForm, business_name: e.target.value})} placeholder="Your Business Name" /></div>
                <div className="form-group"><label>Category *</label>
                  <select value={applyForm.business_category} onChange={e => setApplyForm({...applyForm, business_category: e.target.value, ...(e.target.value !== 'Other' ? { other_category: '' } : {})})}>
                    <option value="">Select category</option>
                    {CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
                  </select>
                </div>
                {applyForm.business_category === 'Other' && (
                  <div className="form-group"><label>Please specify your category *</label><input value={applyForm.other_category || ''} onChange={e => setApplyForm({...applyForm, other_category: e.target.value})} placeholder="e.g., Cakes & Baking, Event Equipment Hire, Stationery, etc." /></div>
                )}
                <div className="form-group"><label>Full Business Address *</label><input value={applyForm.business_address} onChange={e => setApplyForm({...applyForm, business_address: e.target.value})} placeholder="e.g., 123 Main Road, Braamfontein, Johannesburg, 2001" />
                  <span style={{ fontSize: '11px', color: 'var(--gray)', marginTop: '4px', display: 'block' }}>Full physical address for verification purposes</span>
                </div>
                <div className="form-group"><label>City / Area</label><input value={applyForm.business_location} onChange={e => setApplyForm({...applyForm, business_location: e.target.value})} placeholder="e.g., Johannesburg, Gauteng" /></div>
                <div className="form-group" style={{ position: 'relative' }}><label>Areas You Serve</label>
                  <div onClick={() => setApplyForm(f => ({...f, _areasOpen: !f._areasOpen}))} style={{ padding: '10px 14px', border: '1px solid var(--cream-dark)', borderRadius: '10px', background: 'var(--white)', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', minHeight: '42px' }}>
                    <span style={{ fontSize: '14px', color: applyForm.service_areas ? 'var(--dark)' : 'var(--gray)' }}>
                      {applyForm.service_areas ? `${(applyForm.service_areas).split(',').length} area${(applyForm.service_areas).split(',').length > 1 ? 's' : ''} selected` : 'Select areas you serve'}
                    </span>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--gray)" strokeWidth="2"><path d={applyForm._areasOpen ? "M18 15l-6-6-6 6" : "M6 9l6 6 6-6"} /></svg>
                  </div>
                  {applyForm._areasOpen && (
                    <div style={{ position: 'absolute', zIndex: 50, top: '100%', left: 0, right: 0, marginTop: '4px', background: 'var(--white)', border: '1px solid var(--cream-dark)', borderRadius: '12px', boxShadow: '0 8px 32px rgba(0,0,0,0.12)', maxHeight: '360px', overflowY: 'auto', paddingBottom: '4px' }}>
                      {Object.entries(CITY_AREAS).map(([cityName, cityData]) => {
                        const isExpanded = cityGroupsExpanded.has(cityName);
                        const allCityAreas = cityData.areas;
                        const selected = (applyForm.service_areas || '').split(',').map(s => s.trim()).filter(Boolean);
                        const selectedInCity = allCityAreas.filter(a => selected.includes(a));
                        const allSelected = selectedInCity.length === allCityAreas.length;
                        return (
                          <div key={cityName}>
                            <div onClick={() => {
                              const next = new Set(cityGroupsExpanded);
                              if (isExpanded) next.delete(cityName);
                              else next.add(cityName);
                              setCityGroupsExpanded(next);
                            }} style={{ padding: '10px 14px', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', borderBottom: '1px solid var(--cream-dark)', background: 'var(--cream)', position: 'sticky', top: 0, zIndex: 1 }}>
                              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="var(--gray)" strokeWidth="2" style={{ transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)', transition: 'transform 0.15s', flexShrink: 0 }}><path d="M9 18l6-6-6-6"/></svg>
                              <div onClick={e => { e.stopPropagation();
                                const current = (applyForm.service_areas || '').split(',').map(s => s.trim()).filter(Boolean).filter(a => a !== 'Nationwide');
                                const updated = allSelected ? current.filter(a => !allCityAreas.includes(a)) : [...current, ...allCityAreas];
                                setApplyForm(f => ({...f, service_areas: updated.join(', ')}));
                              }} style={{ width: '18px', height: '18px', borderRadius: '3px', border: allSelected ? '2px solid var(--rose)' : (selectedInCity.length > 0 ? '2px solid var(--rose)' : '2px solid var(--cream-dark)'), background: allSelected ? 'var(--rose)' : (selectedInCity.length > 0 ? 'rgba(227,66,92,0.5)' : 'white'), display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                {allSelected && <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3"><path d="M20 6L9 17l-5-5"/></svg>}
                                {!allSelected && selectedInCity.length > 0 && <span style={{ fontSize: '8px', color: 'white', fontWeight: 700, lineHeight: 1 }}>{selectedInCity.length}</span>}
                              </div>
                              <div style={{ flex: 1 }}>
                                <span style={{ fontSize: '13px', fontWeight: 600, color: 'var(--dark)' }}>{cityName}</span>
                                <span style={{ fontSize: '10px', color: 'var(--gray)', marginLeft: '4px' }}>{cityData.province}</span>
                              </div>
                              <span style={{ fontSize: '10px', color: 'var(--gray)' }}>{selectedInCity.length}/{allCityAreas.length}</span>
                            </div>
                            {isExpanded && allCityAreas.map(area => {
                              const isAreaSelected = selected.includes(area);
                              return (
                                <div key={area} onClick={() => {
                                  const current = (applyForm.service_areas || '').split(',').map(s => s.trim()).filter(Boolean);
                                  const withoutNationwide = current.filter(a => a !== 'Nationwide');
                                  const updated = isAreaSelected ? withoutNationwide.filter(a => a !== area) : [...withoutNationwide, area];
                                  setApplyForm(f => ({...f, service_areas: updated.join(', ')}));
                                }} style={{ padding: '7px 14px 7px 44px', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', borderBottom: '1px solid var(--cream)', background: isAreaSelected ? 'rgba(227,66,92,0.03)' : 'white' }}>
                                  <div style={{ width: '16px', height: '16px', borderRadius: '3px', border: isAreaSelected ? '2px solid var(--rose)' : '2px solid var(--cream-dark)', background: isAreaSelected ? 'var(--rose)' : 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                    {isAreaSelected && <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3"><path d="M20 6L9 17l-5-5"/></svg>}
                                  </div>
                                  <span style={{ fontSize: '13px', color: isAreaSelected ? 'var(--rose)' : 'var(--dark)', fontWeight: isAreaSelected ? 500 : 400 }}>{area}</span>
                                </div>
                              );
                            })}
                          </div>
                        );
                      })}
                      <div style={{ borderTop: '2px solid var(--cream-dark)', marginTop: '4px' }}>
                        {(() => {
                          const selected = (applyForm.service_areas || '').split(',').map(s => s.trim()).filter(Boolean);
                          const isNationwide = selected.includes('Nationwide');
                          return (
                            <div onClick={() => {
                              const current = (applyForm.service_areas || '').split(',').map(s => s.trim()).filter(Boolean);
                              setApplyForm(f => ({...f, service_areas: isNationwide ? '' : 'Nationwide'}));
                            }} style={{ padding: '10px 14px', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', background: isNationwide ? 'rgba(227,66,92,0.05)' : 'white' }}>
                              <div style={{ width: '18px', height: '18px', borderRadius: '3px', border: isNationwide ? '2px solid var(--rose)' : '2px solid var(--cream-dark)', background: isNationwide ? 'var(--rose)' : 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                {isNationwide && <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3"><path d="M20 6L9 17l-5-5"/></svg>}
                              </div>
                              <span style={{ fontSize: '13px', fontWeight: 600, color: isNationwide ? 'var(--rose)' : 'var(--dark)' }}>Nationwide</span>
                              <span style={{ fontSize: '10px', color: 'var(--gray)', marginLeft: 'auto' }}>All areas</span>
                            </div>
                          );
                        })()}
                      </div>
                    </div>
                  )}
                  {applyForm.service_areas && (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginTop: '8px' }}>
                      {(applyForm.service_areas || '').split(',').map(s => s.trim()).filter(Boolean).map(area => (
                        <span key={area} style={{ padding: '3px 10px', borderRadius: '12px', background: 'rgba(227,66,92,0.08)', color: 'var(--rose)', fontSize: '11px', fontWeight: 500, display: 'flex', alignItems: 'center', gap: '4px' }}>
                          {area}
                          <span onClick={() => {
                            const updated = (applyForm.service_areas || '').split(',').map(s => s.trim()).filter(a => a !== area).join(', ');
                            setApplyForm({...applyForm, service_areas: updated});
                          }} style={{ cursor: 'pointer', fontWeight: 700, fontSize: '13px', lineHeight: 1 }}>&times;</span>
                        </span>
                      ))}
                    </div>
                  )}
                </div>
                <div className="form-group"><label>Event Types You Serve</label>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 14px', border: '1px solid var(--cream-dark)', borderRadius: '10px', cursor: 'pointer', background: applyForm.serves_all_events !== false ? 'rgba(227,66,92,0.04)' : 'white' }}>
                      <input type="checkbox" checked={applyForm.serves_all_events !== false} onChange={e => setApplyForm({...applyForm, serves_all_events: e.target.checked, served_event_types: e.target.checked ? [] : (applyForm.served_event_types || [])})} style={{ accentColor: 'var(--rose)' }} />
                      <span style={{ fontSize: '14px', fontWeight: 600 }}>I serve ALL event types</span>
                      <span style={{ fontSize: '11px', color: 'var(--gray)' }}>— Your business will appear for every event category</span>
                    </label>
                    {applyForm.serves_all_events === false && (
                      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', padding: '4px 0' }}>
                        {EVENT_TYPES.map(et => {
                          const selected = (applyForm.served_event_types || []).includes(et);
                          return (
                            <button type="button" key={et} onClick={() => {
                              const current = applyForm.served_event_types || [];
                              const updated = selected ? current.filter(e => e !== et) : [...current, et];
                              setApplyForm({...applyForm, served_event_types: updated});
                            }} style={{
                              padding: '6px 14px', borderRadius: '20px', border: '1px solid',
                              borderColor: selected ? 'var(--rose)' : 'var(--cream-dark)',
                              background: selected ? 'var(--rose)' : 'white',
                              color: selected ? 'white' : 'var(--dark)',
                              cursor: 'pointer', fontSize: '12px', fontWeight: selected ? 600 : 400,
                              transition: 'all 0.15s'
                            }}>
                              {selected && '✓ '}{et}
                            </button>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
                <div className="form-group"><label>Price Range</label>
                  <select value={applyForm._customPrice ? 'Custom' : (PRICE_RANGES.includes(applyForm.business_price_range) ? applyForm.business_price_range : (applyForm.business_price_range ? 'Custom' : ''))} onChange={e => { if (e.target.value === 'Custom') { setApplyForm({...applyForm, business_price_range: '', _customPrice: true}); } else { setApplyForm({...applyForm, business_price_range: e.target.value, _customPrice: false}); } }}>
                    <option value="">Select range</option>
                    {PRICE_RANGES.map(r => <option key={r} value={r}>{r}</option>)}
                  </select>
                </div>
                {applyForm._customPrice && (
                  <div className="form-group"><label>Enter your price range</label><input value={applyForm.business_price_range || ''} onChange={e => setApplyForm({...applyForm, business_price_range: e.target.value})} placeholder="e.g., R50 - R200 per item, R150 per hour" /></div>
                )}
                <div className="form-group">
                  <label>Description</label>
                  <textarea value={applyForm.business_description} onChange={e => setApplyForm({...applyForm, business_description: e.target.value})} rows={4} placeholder="Describe your services, experience, and what makes you unique..." />
                  <button type="button" onClick={async () => {
                    if (!applyForm.business_name || !applyForm.business_category) {
                      alert('Please fill in your Business Name and Category first so Gigi can write a relevant description.');
                      return;
                    }
                    setApplyForm(f => ({...f, _gigiLoading: true}));
                    try {
                      const res = await api.post('/ai/vendor-description', { business_name: applyForm.business_name, business_category: applyForm.business_category, business_location: applyForm.business_location, business_price_range: applyForm.business_price_range });
                      setApplyForm(f => ({...f, business_description: cleanAiText(res.data.description), _gigiLoading: false}));
                    } catch { setApplyForm(f => ({...f, _gigiLoading: false})); }
                  }} disabled={applyForm._gigiLoading} style={{ marginTop: '10px', width: '100%', padding: '10px 16px', background: 'linear-gradient(135deg, var(--rose), var(--rose-deep))', color: 'white', border: 'none', borderRadius: '10px', fontSize: '13px', fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', opacity: applyForm._gigiLoading ? 0.6 : 1, transition: 'all 0.2s' }}>
                    ✨ {applyForm._gigiLoading ? 'Gigi is writing your description...' : 'AI Generate Description — Let Gigi write it for you'}
                  </button>
                  <span style={{ fontSize: '11px', color: 'var(--gray)', marginTop: '6px', display: 'block', textAlign: 'center' }}>Optional — Gigi will craft a professional description based on your business details. You can edit it afterwards.</span>
                </div>
                <div className="vendor-form-2col" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                  <div className="form-group"><label>Phone Number</label><input value={applyForm.phone} onChange={e => setApplyForm({...applyForm, phone: e.target.value})} placeholder="012 345 6789" /></div>
                  <div className="form-group"><label>WhatsApp Number</label><input value={applyForm.whatsapp_number} onChange={e => setApplyForm({...applyForm, whatsapp_number: e.target.value})} placeholder="012 345 6789" /></div>
                </div>

                <div style={{ borderTop: '1px solid #eee', paddingTop: '20px', marginTop: '8px' }}>
                  <label style={{ fontSize: '14px', fontWeight: 600, marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>Social Media & Online Presence <span style={{ fontSize: '11px', fontWeight: 400, color: 'var(--gray)' }}>(helps with verification)</span></label>
                  <div className="vendor-form-2col" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                    <div className="form-group"><label style={{ display: 'flex', alignItems: 'center', gap: '6px' }}><svg width="14" height="14" viewBox="0 0 24 24" fill="#1877F2"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg> Facebook</label><input value={applyForm.social_facebook} onChange={e => setApplyForm({...applyForm, social_facebook: e.target.value})} placeholder="facebook.com/yourbusiness" /></div>
                    <div className="form-group"><label style={{ display: 'flex', alignItems: 'center', gap: '6px' }}><svg width="14" height="14" viewBox="0 0 24 24" fill="#E4405F"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg> Instagram</label><input value={applyForm.social_instagram} onChange={e => setApplyForm({...applyForm, social_instagram: e.target.value})} placeholder="instagram.com/yourbusiness" /></div>
                    <div className="form-group"><label style={{ display: 'flex', alignItems: 'center', gap: '6px' }}><svg width="14" height="14" viewBox="0 0 24 24" fill="#000"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.27 6.27 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.34-6.34V8.69a8.16 8.16 0 004.77 1.52V6.79a4.85 4.85 0 01-1.01-.1z"/></svg> TikTok</label><input value={applyForm.social_tiktok} onChange={e => setApplyForm({...applyForm, social_tiktok: e.target.value})} placeholder="tiktok.com/@yourbusiness" /></div>
                    <div className="form-group"><label style={{ display: 'flex', alignItems: 'center', gap: '6px' }}><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--gray)" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg> Website</label><input value={applyForm.social_website} onChange={e => setApplyForm({...applyForm, social_website: e.target.value})} placeholder="www.yourbusiness.co.za" /></div>
                  </div>
                </div>

                <div style={{ borderTop: '1px solid #eee', paddingTop: '20px', marginTop: '8px' }}>
                  <div className="form-group">
                    <label style={{ fontWeight: 600 }}>Is your business registered? <span style={{ color: '#e65100', fontSize: '12px' }}>*</span></label>
                    <select value={applyForm.business_registered || ''} onChange={e => setApplyForm({...applyForm, business_registered: e.target.value})} required style={{ padding: '12px 14px', borderRadius: '10px', border: '1px solid var(--cream-dark)', fontSize: '14px', width: '100%', background: 'var(--white)' }}>
                      <option value="">— Please select —</option>
                      <option value="yes">Yes — Registered</option>
                      <option value="no">No — Operating informally</option>
                    </select>
                  </div>
                </div>

                {/* Business Gallery — upload up to 5 photos for review */}
                <div style={{ borderTop: '1px solid #eee', paddingTop: '20px', marginTop: '8px' }}>
                  <div style={{ marginBottom: '12px' }}>
                    <label style={{ fontSize: '14px', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '6px' }}>
                      Business Photos <span style={{ fontSize: '12px', fontWeight: 400, color: 'var(--gray)' }}>({galleryFiles.length}/5) — optional</span>
                    </label>
                    <p style={{ fontSize: '11px', color: 'var(--gray)', margin: '4px 0 0' }}>Upload up to 5 photos of your work, products, or venue for admin review before your profile goes live.</p>
                  </div>
                  {galleryFiles.length > 0 && (
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(90px, 1fr))', gap: '10px', marginBottom: '12px' }}>
                      {galleryFiles.map((f, i) => (
                        <div key={i} style={{ position: 'relative', aspectRatio: '1', borderRadius: '10px', overflow: 'hidden', border: '1px solid var(--cream-dark)' }}>
                          <img src={f.preview} alt={`Upload ${i + 1}`} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                          <button type="button" onClick={() => removeGalleryFile(i)} style={{
                            position: 'absolute', top: '4px', right: '4px',
                            width: '22px', height: '22px', borderRadius: '50%',
                            background: 'rgba(220, 38, 38, 0.85)', color: 'white', border: 'none',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            cursor: 'pointer', fontSize: '12px', lineHeight: 1
                          }}><FiX size={12} /></button>
                        </div>
                      ))}
                    </div>
                  )}
                  {galleryFiles.length < 5 && (
                    <label style={{ cursor: 'pointer', padding: '10px 18px', background: 'rgba(227,66,92,0.06)', border: '1px dashed var(--rose)', borderRadius: '10px', fontSize: '13px', fontWeight: 600, color: 'var(--rose)', display: 'inline-flex', alignItems: 'center', gap: '8px', transition: 'all 0.2s' }}>
                      <FiPlus size={14} /> Add Photos
                      <input type="file" accept="image/*" onChange={e => { if (e.target.files[0]) { addGalleryFile(e.target.files[0]); } e.target.value = ''; }} style={{ display: 'none' }} />
                    </label>
                  )}
                </div>

                <button className="btn btn-primary btn-full btn-lg" onClick={submitApplication} disabled={!applyForm.business_name || !applyForm.business_category || !applyForm.business_registered || (applyForm.business_category === 'Other' && !applyForm.other_category)} style={{ marginTop: '16px' }}>Submit Application</button>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }

  // ─── REJECTED ───
  if (status?.vendor_status === 'rejected') {
    return (
      <div style={{ minHeight: '100vh', background: 'var(--cream)' }}>
        <div style={{ padding: '12px 24px', borderBottom: '1px solid var(--cream-dark)', background: 'var(--white)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Link to="/"><img src="/ggr-logo-deck.png" alt="Grand Gather Registry" style={{ height: '28px' }} /></Link>
          <button onClick={() => logout()} style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '8px 14px', borderRadius: '8px', background: 'none', border: '1px solid var(--cream-dark)', cursor: 'pointer', color: 'var(--red)', fontSize: '13px', fontWeight: 600 }}><FiLogOut size={14} /> Log Out</button>
        </div>
        <div className="container" style={{ padding: '40px 20px', maxWidth: '600px', margin: '0 auto' }}>
          <div className="card" style={{ textAlign: 'center', padding: '50px 40px' }}>
            <div style={{ width: '80px', height: '80px', borderRadius: '50%', background: 'rgba(239,68,68,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
              <FiAlertCircle size={36} style={{ color: 'var(--red)' }} />
            </div>
            <h2 style={{ marginBottom: '12px' }}>Application Not Approved</h2>
            <p style={{ color: 'var(--gray)', lineHeight: 1.6 }}>Unfortunately your vendor application was not approved at this time.</p>
            <p style={{ color: 'var(--gray)', fontSize: '14px', marginTop: '12px', lineHeight: 1.6 }}>Please contact support at <a href="mailto:support@grandgatherregistry.co.za" style={{ color: 'var(--rose)', fontWeight: 600 }}>support@grandgatherregistry.co.za</a> for more information or to resubmit your application.</p>
          </div>
        </div>
      </div>
    );
  }

  // ─── TERMS & CONDITIONS ───
  if (status?.vendor_status === 'approved' && !status?.terms_accepted_at) {
    return (
      <div style={{ minHeight: '100vh', background: 'var(--cream)' }}>
        <div style={{ padding: '12px 24px', borderBottom: '1px solid var(--cream-dark)', background: 'var(--white)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Link to="/"><img src="/ggr-logo-deck.png" alt="Grand Gather Registry" style={{ height: '28px' }} /></Link>
          <button onClick={() => logout()} style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '8px 14px', borderRadius: '8px', background: 'none', border: '1px solid var(--cream-dark)', cursor: 'pointer', color: 'var(--red)', fontSize: '13px', fontWeight: 600 }}><FiLogOut size={14} /> Log Out</button>
        </div>
        <div className="container" style={{ padding: '40px 20px', maxWidth: '700px', margin: '0 auto' }}>
          {/* Progress Tracker */}
          <div style={{ marginBottom: '32px' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0' }}>
              {[
                { step: 1, label: 'Register' },
                { step: 2, label: 'Approved' },
                { step: 3, label: 'Terms' },
                { step: 4, label: 'Dashboard' },
              ].map((s, i) => (
                <React.Fragment key={s.step}>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: '70px' }}>
                    <div style={{
                      width: '36px', height: '36px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                      background: s.step < 3 ? 'var(--green)' : s.step === 3 ? 'var(--rose)' : 'var(--cream-dark)',
                      color: s.step <= 3 ? 'white' : 'var(--gray)',
                      fontWeight: 700, fontSize: '14px'
                    }}>
                      {s.step < 3 ? <FiCheckCircle size={18} /> : s.step}
                    </div>
                    <span style={{ fontSize: '11px', color: s.step <= 3 ? 'var(--dark)' : 'var(--gray)', marginTop: '6px', fontWeight: s.step === 3 ? 600 : 400, textAlign: 'center' }}>{s.label}</span>
                  </div>
                  {i < 3 && <div style={{ flex: 1, height: '2px', background: s.step < 3 ? 'var(--green)' : 'var(--cream-dark)', marginBottom: '20px', minWidth: '30px' }} />}
                </React.Fragment>
              ))}
            </div>
          </div>

          <div className="card" style={{ padding: '40px' }}>
            <div style={{ textAlign: 'center', marginBottom: '32px' }}>
              <div style={{ width: '80px', height: '80px', borderRadius: '50%', background: 'rgba(34,197,94,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
                <FiCheckCircle size={36} style={{ color: 'var(--green)' }} />
              </div>
              <h2>Application Approved!</h2>
              <p style={{ color: 'var(--gray)' }}>One more step — please read and accept the Terms & Conditions to access your dashboard.</p>
            </div>
            <div style={{ maxHeight: '400px', overflowY: 'auto', padding: '24px', background: 'var(--cream)', borderRadius: '12px', border: '1px solid var(--cream-dark)', marginBottom: '24px', fontSize: '13px', lineHeight: 1.8, color: 'var(--gray)' }}>
              <h3 style={{ color: 'var(--dark)', marginBottom: '16px' }}>Grand Gather Registry — Vendor Terms & Conditions</h3>
              <p><strong>1. Service Agreement</strong><br/>By accepting these terms, you agree to provide services as described in your vendor profile. You must maintain accurate and up-to-date information about your business, services, and pricing.</p>
              <p><strong>2. Booking & Payment</strong><br/>All bookings made through Grand Gather Registry are subject to confirmation between you and the client. Payments processed through the platform will be held in your vendor wallet. Your first R5,000 in earnings is commission-free. After that, a service fee of 8% will be deducted from each transaction.</p>
              <p><strong>3. Communication Policy</strong><br/>All client communication must happen through the Grand Gather platform chat system. Sharing personal contact details (phone numbers, email addresses, social media) through the chat is prohibited and will be automatically filtered for security.</p>
              <p><strong>4. Portfolio & Content</strong><br/>Portfolio limits depend on your plan: Starter (5 items), Pro (15 items), Premium (unlimited). All content must be original or you must have rights to use it. Grand Gather reserves the right to remove inappropriate content.</p>
              <p><strong>5. Cancellation Policy</strong><br/>Vendors must provide at least 7 days notice for any booking cancellations. Repeated cancellations may result in account suspension.</p>
              <p><strong>6. Withdrawals</strong><br/>Funds in your wallet can be withdrawn to your registered bank account. Withdrawals are processed within 3-5 business days. Minimum withdrawal amount is R100.</p>
              <p><strong>7. Conduct</strong><br/>Vendors must maintain professional conduct at all times. Discrimination, harassment, or unprofessional behaviour will result in immediate account termination.</p>
              <p><strong>8. Liability</strong><br/>Grand Gather Registry acts as a marketplace platform. We are not liable for disputes between vendors and clients. However, we provide mediation support when needed.</p>
              <p><strong>9. Termination</strong><br/>Either party may terminate this agreement with 30 days written notice. Outstanding wallet balances will be transferred to your bank account upon termination.</p>
              <p><strong>10. Updates</strong><br/>Grand Gather reserves the right to update these terms. You will be notified of any changes and may be required to accept updated terms to continue using the platform.</p>
            </div>
            <label style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px', cursor: 'pointer' }}>
              <input type="checkbox" checked={showTerms} onChange={e => setShowTerms(e.target.checked)} style={{ accentColor: 'var(--rose)', width: '18px', height: '18px' }} />
              <span style={{ fontSize: '14px' }}>I have read and agree to the Terms & Conditions</span>
            </label>
            <button className="btn btn-primary btn-full btn-lg" onClick={acceptTerms} disabled={!showTerms}>Accept & Continue</button>
          </div>
        </div>
      </div>
    );
  }

  // ─── FULL DASHBOARD ───
  const stats = {
    bookings: bookings.length,
    pending: bookings.filter(b => b.status === 'pending').length,
    confirmed: bookings.filter(b => b.status === 'confirmed').length,
    revenue: bookings.filter(b => b.status === 'confirmed').reduce((a, b) => a + Number(b.quote_amount || 0), 0),
    walletBalance: Number(wallet?.balance || 0),
    portfolioCount: portfolio.length,
    chatCount: conversations.length,
  };

  const planTier = (walletMeta.plan || 'free').toLowerCase(); // starter/free, pro, premium
  const maxPortfolio = planTier === 'premium' ? 100 : planTier === 'pro' ? 15 : 5;
  const maxGallery = planTier === 'premium' ? 100 : planTier === 'pro' ? 15 : 5;

  const cs = {
    page: { minHeight: '100vh', background: 'var(--cream)' },
    main: { display: 'flex', flexDirection: 'column' },
    content: { padding: '24px' },
  };

  {/* ── SettingsRow — reused in settings list ── */}
  function SettingsRow({ icon, iconBg, iconColor, label, onClick, danger, isLast }) {
    const coloredIcon = React.cloneElement(icon, { color: iconColor });
    return (
      <button
        onClick={onClick}
        style={{
          display: 'flex', alignItems: 'center', gap: '14px', padding: '14px 20px',
          width: '100%', border: 'none', background: 'transparent', cursor: 'pointer',
          fontFamily: 'Inter, sans-serif',
          borderBottom: isLast ? 'none' : '1px solid rgba(0,0,0,0.04)',
        }}
      >
        <div style={{ width: '40px', height: '40px', borderRadius: '12px', background: iconBg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          {coloredIcon}
        </div>
        <span style={{ flex: 1, textAlign: 'left', fontSize: '15px', fontWeight: 500, color: danger ? '#DC2626' : 'var(--dark)' }}>{label}</span>
        <FiChevronRight size={18} color="var(--gray)" />
      </button>
    );
  }

  return (
    <div style={cs.page}>
      {/* WhatsApp-style notification toast */}
      {notifToast && (
        <div
          onClick={() => { if (notifToast.link) { navigate(notifToast.link); setNotifToast(null); } }}
          style={{
            position: 'fixed', top: 0, left: 0, right: 0, zIndex: 250,
            background: 'var(--white)', boxShadow: '0 2px 12px rgba(0,0,0,0.15)',
            padding: '12px 16px', display: 'flex', alignItems: 'flex-start', gap: '12px',
            transform: notifToastExiting ? 'translateY(-100%)' : 'translateY(0)',
            transition: 'transform 0.3s ease',
            cursor: notifToast.link ? 'pointer' : 'default',
          }}
        >
          <div style={{ width: '36px', height: '36px', borderRadius: '50%', background: 'var(--rose)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <FiBell size={16} color="#fff" />
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontWeight: 600, fontSize: '14px', marginBottom: '2px' }}>{notifToast.title}</div>
            <div style={{ fontSize: '13px', color: 'var(--gray)', lineHeight: 1.4, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{notifToast.message}</div>
          </div>
          <button
            onClick={(e) => { e.stopPropagation(); setNotifToastExiting(true); setTimeout(() => { setNotifToast(null); setNotifToastExiting(false); }, 300); }}
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--gray)', padding: '4px', flexShrink: 0 }}
          >
            <FiX size={16} />
          </button>
        </div>
      )}
      <style>{`
        @keyframes rsvpPulse {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.06); opacity: 0.85; }
        }
        @media (max-width: 600px) {
          .vendor-rate-card-items { grid-template-columns: 1fr 1fr !important; }
          .vendor-rate-card-items input, .vendor-rate-card-items select { font-size: 12px !important; }
          .vendor-calendar-grid { grid-template-columns: 1fr !important; }
          .vendor-form-2col { grid-template-columns: 1fr !important; }
          .vendor-booking-detail-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>

      {/* ─── CONTENT ─── */}
      <div style={cs.main}>
        <div style={cs.content}>

          {/* Spam folder notice — dismissible */}
          {!spamDismissed && (
            <div style={{
              background: 'var(--rose-light)', borderLeft: '4px solid var(--rose)', borderRadius: '0 8px 8px 0',
              padding: '12px 16px', marginBottom: '20px', display: 'flex', alignItems: 'flex-start',
              justifyContent: 'space-between', gap: '12px', fontSize: '13px', color: '#555', lineHeight: 1.6
            }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                <FiBell size={16} color="var(--rose)" style={{ marginTop: '2px', flexShrink: 0 }} />
                <div>
                  <strong style={{ color: 'var(--rose)' }}>Check your spam folder!</strong>{' '}
                  Important emails from Grand Gather Registry (booking alerts, payment confirmations, withdrawal updates) may land in your spam or junk folder.{' '}
                  Please mark us as <strong>"Not Spam"</strong> or add <strong>noreply@grandgatherregistry.co.za</strong> to your contacts to ensure you never miss an update.
                </div>
              </div>
              <button
                onClick={() => { setSpamDismissed(true); localStorage.setItem('ggr_spam_dismissed', 'true'); }}
                style={{
                  background: 'none', border: 'none', cursor: 'pointer', padding: '4px',
                  color: 'var(--gray)', flexShrink: 0, borderRadius: '4px'
                }}
                title="Dismiss"
              >
                <FiX size={16} />
              </button>
            </div>
          )}

          {/* ═══ OVERVIEW ═══ */}
        {tab === 'overview' && (
          <div>
            {/* Your Plan Section */}
            {(() => {
              const plan = (vendorStats.plan || 'free').toLowerCase();
              const planColors = { free: { bg: '#F3F4F6', text: '#6B7280', border: '#D1D5DB' }, growth: { bg: '#ECFDF5', text: '#059669', border: '#6EE7B7' }, pro: { bg: '#EEF2FF', text: '#4F46E5', border: '#A5B4FC' }, premium: { bg: '#FEF3C7', text: '#D97706', border: '#FCD34D' } };
              const pc = planColors[plan] || planColors.free;
              const commissionRates = { free: 8, growth: 8, pro: 3, premium: 0 };
              const commission = commissionRates[plan] || 5;
              const planLabels = { free: 'Starter', growth: 'Starter', pro: 'Pro', premium: 'Premium' };
              const monthlyBookings = Number(vendorStats.bookings_this_month) || 0;
              const showUpgrade = plan === 'free' && monthlyBookings >= 5;
              return (
                <div style={{ marginBottom: '24px' }}>
                  <div className="card" style={{ padding: '24px', display: 'flex', flexWrap: 'wrap', gap: '20px', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
                      <div>
                        <div style={{ fontSize: '12px', color: 'var(--gray)', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '1px', fontWeight: 600 }}>Your Plan</div>
                        <span style={{ display: 'inline-block', padding: '6px 16px', borderRadius: '20px', background: pc.bg, color: pc.text, border: `1.5px solid ${pc.border}`, fontWeight: 700, fontSize: '14px' }}>{planLabels[plan] || plan}</span>
                      </div>
                      <div style={{ borderLeft: '1px solid var(--cream-dark)', paddingLeft: '16px' }}>
                        <div style={{ fontSize: '12px', color: 'var(--gray)', marginBottom: '4px' }}>Commission Rate</div>
                        <div style={{ fontSize: '28px', fontWeight: 700, color: commission === 0 ? '#059669' : commission <= 3 ? '#059669' : commission <= 5 ? '#D97706' : 'var(--rose)' }}>{commission}%</div>
                      </div>
                      <div style={{ borderLeft: '1px solid var(--cream-dark)', paddingLeft: '16px' }}>
                        <div style={{ fontSize: '12px', color: 'var(--gray)', marginBottom: '4px' }}>Bookings This Month</div>
                        <div style={{ fontSize: '28px', fontWeight: 700, color: 'var(--dark)' }}>{monthlyBookings}</div>
                      </div>
                    </div>
                    <div style={{ fontSize: '12px', color: 'var(--gray)' }}>
                      <Link to="/terms" style={{ color: 'var(--gold-dark)', textDecoration: 'underline' }}>View our commission structure in our Terms &amp; Conditions</Link>
                    </div>
                  </div>
                  {showUpgrade && (
                    <div className="card" style={{ padding: '20px', marginTop: '12px', border: '2px solid #F59E0B', background: 'linear-gradient(135deg, #FFFBEB, #FEF3C7)' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                          <span style={{ fontSize: '28px' }}>&#127775;</span>
                          <div>
                            <div style={{ fontWeight: 700, fontSize: '15px', color: '#92400E', marginBottom: '2px' }}>You qualify for Pro plan!</div>
                            <div style={{ fontSize: '13px', color: '#B45309' }}>Upgrade to reduce your commission from 8% to 3%. You have {monthlyBookings} bookings this month.</div>
                          </div>
                        </div>
                        <Link to="/upgrade?type=vendor" style={{ padding: '8px 20px', borderRadius: '10px', background: '#F59E0B', color: '#fff', fontWeight: 700, fontSize: '13px', textDecoration: 'none', whiteSpace: 'nowrap', display: 'inline-flex', alignItems: 'center', gap: '6px' }}>Upgrade Now &rarr;</Link>
                      </div>
                    </div>
                  )}

                  {/* Upgrade prompt for free tier vendors — always visible */}
                  {planTier === 'free' && !showUpgrade && (
                    <div className="card" style={{ padding: '16px', marginTop: '12px', border: '1px solid rgba(232,160,191,0.2)', background: 'rgba(232,160,191,0.04)', borderRadius: '12px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap', justifyContent: 'space-between' }}>
                        <div>
                          <div style={{ fontWeight: 600, fontSize: '13px', color: 'var(--dark)', marginBottom: '2px' }}>Unlock more features</div>
                          <div style={{ fontSize: '12px', color: 'var(--gray)' }}>Upgrade to Pro or Premium for lower commissions, more portfolio space, community access, and higher search ranking.</div>
                        </div>
                        <Link to="/upgrade?type=vendor" style={{ padding: '8px 20px', borderRadius: '10px', background: 'linear-gradient(135deg, var(--rose), var(--rose-deep))', color: '#fff', fontWeight: 700, fontSize: '13px', textDecoration: 'none', whiteSpace: 'nowrap' }}>View Plans</Link>
                      </div>
                    </div>
                  )}
                </div>
              );
            })()}

            {/* Founding Vendor Badge */}
            {walletMeta.is_founding_vendor && (
              <div style={{ background: 'linear-gradient(135deg, #FFF7ED, #FEF3C7)', border: '1px solid #F59E0B44', borderRadius: '14px', padding: '16px 20px', marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '14px' }}>
                <div style={{ fontSize: '28px' }}>&#x1F31F;</div>
                <div>
                  <div style={{ fontWeight: 700, fontSize: '15px', color: '#92400E' }}>Founding Vendor</div>
                  <div style={{ fontSize: '12px', color: '#B45309', opacity: 0.8 }}>You're one of the first 50 vendors on Grand Gather — this badge is yours forever!</div>
                </div>
              </div>
            )}

            {/* Free Threshold Progress */}
            {walletMeta.in_free_zone && (
              <div className="card" style={{ padding: '20px', marginBottom: '20px', background: 'linear-gradient(135deg, #ECFDF5, #D1FAE5)', border: '1px solid #10B98133' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                  <div style={{ fontWeight: 600, fontSize: '14px', color: '#065F46' }}>0% Commission — Free Zone</div>
                  <div style={{ fontSize: '13px', color: '#047857' }}>R{Number(walletMeta.gross_earnings || 0).toLocaleString()} / R{Number(walletMeta.free_threshold || 5000).toLocaleString()}</div>
                </div>
                <div style={{ background: '#A7F3D0', borderRadius: '8px', height: '10px', overflow: 'hidden' }}>
                  <div style={{ background: '#059669', height: '100%', borderRadius: '8px', width: `${Math.min(100, ((walletMeta.gross_earnings || 0) / (walletMeta.free_threshold || 5000)) * 100)}%`, transition: 'width 0.5s ease' }} />
                </div>
                <div style={{ fontSize: '12px', color: '#047857', marginTop: '8px' }}>
                  Earn your first R{Number(walletMeta.free_threshold || 5000).toLocaleString()} commission-free! R{Number(walletMeta.free_remaining || 5000).toLocaleString()} remaining.
                </div>
              </div>
            )}
            {walletMeta.in_free_zone === false && (
              <div className="card" style={{ padding: '16px 20px', marginBottom: '20px', background: 'var(--rose-light)', border: '1px solid var(--rose-light)' }}>
                <div style={{ fontSize: '13px', color: '#9B1C31' }}>{planTier === 'premium' ? '0%' : planTier === 'pro' ? '3%' : '8%'} platform commission active — <span style={{ fontWeight: 600 }}>thank you for growing with us!</span></div>
              </div>
            )}

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '16px', marginBottom: '24px' }}>
              {[
                { label: 'Wallet Balance', value: `R${stats.walletBalance.toLocaleString()}`, color: 'var(--green)', icon: <WalletIcon size={24} /> },
                { label: 'Pending Bookings', value: stats.pending, color: 'var(--gold-dark)', icon: <FiClock /> },
                { label: 'Confirmed', value: stats.confirmed, color: 'var(--blue, #3B82F6)', icon: <FiCheckCircle /> },
                { label: 'Revenue', value: `R${stats.revenue.toLocaleString()}`, color: 'var(--rose)', icon: <CoinIcon /> },
                { label: 'Portfolio', value: `${stats.portfolioCount}/${maxPortfolio}`, color: 'var(--gray)', icon: <FiImage /> },
                { label: 'Rating', value: Number(profile.avg_rating || 0).toFixed(1), color: '#F59E0B', icon: <FiStar /> },
                { label: 'Active Chats', value: stats.chatCount, color: 'var(--gray)', icon: <FiMessageCircle /> },
              ].map((s, i) => (
                <div key={i} className={`card card-enter card-stagger-${i + 1}`} style={{ textAlign: 'center', padding: '20px' }}>
                  <div style={{ fontSize: '14px', color: s.color, marginBottom: '8px' }}>{s.icon}</div>
                  <div style={{ fontSize: '28px', fontWeight: 700, color: s.color }}>{s.value}</div>
                  <div style={{ color: 'var(--gray)', fontSize: '12px', marginTop: '4px' }}>{s.label}</div>
                </div>
              ))}
            </div>
            {/* Notification badges */}
            {(() => {
              const pendingPayment = bookings.filter(b => b.status === 'confirmed' && b.payment_status !== 'paid').length;
              const rescheduleCount = bookings.filter(b => b.reschedule_requested).length;
              const activeDeliveries = deliveries.filter(d => d.status !== 'delivered' && d.status !== 'cancelled').length;
              const badges = [
                { label: 'Pending Bookings', count: stats.pending, color: 'var(--gold-dark)', bg: 'rgba(245,158,11,0.1)', icon: <FiClock size={14}/>, tab: 'bookings', show: stats.pending > 0 },
                { label: 'Awaiting Payment', count: pendingPayment, color: '#10B981', bg: 'rgba(16,185,129,0.1)', icon: <CoinIcon size={14}/>, tab: 'bookings', show: pendingPayment > 0 },
                { label: 'Reschedule Requests', count: rescheduleCount, color: '#F59E0B', bg: 'rgba(245,158,11,0.1)', icon: <FiCalendar size={14}/>, tab: 'bookings', show: rescheduleCount > 0, pulse: true },
                { label: 'Active Deliveries', count: activeDeliveries, color: '#3B82F6', bg: 'rgba(59,130,246,0.1)', icon: <FiTruck size={14}/>, tab: 'deliveries', show: activeDeliveries > 0 },
                { label: 'Unread Chats', count: unreadChats, color: 'var(--rose)', bg: 'rgba(227,66,92,0.1)', icon: <FiMessageCircle size={14}/>, tab: 'chats', show: unreadChats > 0, pulse: true },
                { label: 'Alerts', count: unreadNotifs, color: '#8B5CF6', bg: 'rgba(139,92,246,0.1)', icon: <FiBell size={14}/>, tab: 'notifications', show: unreadNotifs > 0 },
              ].filter(b => b.show);
              if (badges.length === 0) return null;
              return (
                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: '20px' }}>
                  {badges.map((b, i) => (
                    <button key={i} onClick={() => setTab(b.tab)}
                      style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 16px', borderRadius: '12px', background: b.bg, border: `1.5px solid ${b.color}33`, cursor: 'pointer', fontSize: '13px', fontWeight: 600, color: b.color, animation: b.pulse ? 'rsvpPulse 1.2s ease-in-out infinite' : undefined }}>
                      {b.icon}
                      <span style={{ fontWeight: 700, fontSize: '16px' }}>{b.count}</span>
                      <span style={{ fontWeight: 500, fontSize: '12px', opacity: 0.85 }}>{b.label}</span>
                    </button>
                  ))}
                </div>
              );
            })()}
            {/* Quick actions */}
            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
              <button className="btn btn-primary btn-sm" onClick={() => setTab('portfolio')}><FiUpload /> Add Portfolio Image</button>
              <button className="btn btn-secondary btn-sm" onClick={() => setTab('bookings')}><FiFileText /> View Bookings</button>
              <button className="btn btn-secondary btn-sm" onClick={() => setTab('chats')}><FiMessageCircle /> Open Chats</button>
              <button className="btn btn-secondary btn-sm" onClick={() => setTab('calendar')}><FiCalendar /> Manage Schedule</button>
            </div>
          </div>
        )}

        {/* ═══ BOOKINGS ═══ */}
        {tab === 'bookings' && (
          <div>
            {bookings.length === 0 ? (
              <div className="card" style={{ textAlign: 'center', padding: '60px', color: 'var(--gray)' }}>No booking inquiries yet.</div>
            ) : (
              <div>
                {/* Filter dropdown + counts */}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px', flexWrap: 'wrap', gap: '12px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <select
                      value={bookingsFilter || 'active'}
                      onChange={e => setBookingsFilter(e.target.value)}
                      style={{ padding: '8px 14px', fontSize: '13px', fontWeight: 600, borderRadius: '8px', border: '1px solid var(--cream-dark)', background: 'var(--white)', color: 'var(--text)', cursor: 'pointer' }}
                    >
                      <option value="active">Active Bookings</option>
                      <option value="pending">Pending</option>
                      <option value="confirmed">Confirmed</option>
                      <option value="paid">Paid</option>
                      <option value="cancelled">Cancelled / Declined</option>
                      <option value="archived">Archived</option>
                      <option value="all">All</option>
                    </select>
                  </div>
                  <div style={{ display: 'flex', gap: '12px', fontSize: '12px', color: 'var(--gray)' }}>
                    <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}><span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#F59E0B' }} /> {sortedBookings.filter(b => b.status === 'pending').length} pending</span>
                    <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}><span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#10B981' }} /> {sortedBookings.filter(b => b.status === 'confirmed').length} confirmed</span>
                  </div>
                </div>
                <div style={{ display: 'grid', gap: '16px' }}>
                  {sortedBookings.map((b, i) => (
                  <div key={b.id} className={`card card-enter card-stagger-${(i % 12) + 1}`} style={{ padding: '24px', opacity: b.is_archived ? 0.7 : 1, borderLeft: b.status === 'pending' ? '4px solid #F59E0B' : b.status === 'confirmed' && b.payment_status !== 'paid' ? '4px solid #3B82F6' : b.is_archived ? '4px solid #9CA3AF' : '4px solid transparent' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '12px', marginBottom: '12px' }}>
                      <div>
                        <h4 style={{ marginBottom: '4px', fontSize: '17px' }}>{b.event_title}</h4>
                        <div style={{ fontSize: '13px', color: 'var(--gray)' }}>Requested by: <strong>{b.host_name}</strong></div>
                      </div>
                      <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
                        <span className={`tag ${b.status === 'confirmed' ? 'tag-green' : b.status === 'declined' ? 'tag-red' : b.status === 'cancelled' ? 'tag-red' : 'tag-gold'}`}>{b.status}</span>
                        {b.payment_status === 'paid' && (
                          <span className="tag" style={{ background: 'rgba(16,185,129,0.12)', color: '#059669', fontSize: '11px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <FiCheck size={12} /> Paid
                          </span>
                        )}
                        {b.status === 'confirmed' && b.payment_status !== 'paid' && (
                          <span className="tag" style={{ background: 'rgba(245,158,11,0.12)', color: '#D97706', fontSize: '11px' }}>
                            Awaiting Payment
                          </span>
                        )}
                        {b.is_archived && (
                          <span className="tag" style={{ background: 'rgba(156,163,175,0.12)', color: '#6B7280', fontSize: '11px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <FiArchive size={11} /> Archived
                          </span>
                        )}
                      </div>
                      {b.refund_status && (
                        <span className="tag" style={{
                          background: b.refund_status === 'processed' ? 'rgba(16,185,129,0.1)' : 'rgba(245,158,11,0.1)',
                          color: b.refund_status === 'processed' ? '#10B981' : '#D97706',
                          fontSize: '11px'
                        }}>Refund: {b.refund_status === 'processed' ? 'Processed' : 'Processing'}</span>
                      )}
                    </div>
                    {/* Rate card source badge */}
                    {b.rate_card_title && (
                      <div style={{ marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '6px', padding: '6px 12px', background: 'rgba(227,66,92,0.06)', borderRadius: '6px', width: 'fit-content' }}>
                        <FiShoppingBag size={13} style={{ color: 'var(--rose)' }} />
                        <span style={{ fontSize: '12px', color: 'var(--gray)' }}>From rate card:</span>
                        <strong style={{ fontSize: '12px', color: 'var(--rose)' }}>{b.rate_card_title}</strong>
                      </div>
                    )}
                    {/* Items being delivered — for confirmed package bookings */}
                    {b.status === 'confirmed' && b.items && b.items.length > 0 && (
                      <div style={{ marginBottom: '12px', padding: '10px 14px', background: 'rgba(16,185,129,0.06)', borderRadius: '8px', borderLeft: '3px solid #10B981' }}>
                        <div style={{ fontSize: '11px', fontWeight: 600, color: '#10B981', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                          Items Being Prepared
                        </div>
                        {b.items.map((item, i) => (
                          <div key={i} style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', padding: '4px 0', borderBottom: i < b.items.length - 1 ? '1px dashed rgba(0,0,0,0.06)' : 'none' }}>
                            <span>{item.service_name}{item.unit ? ` (${item.unit})` : ''}</span>
                            <span style={{ fontWeight: 600, color: 'var(--green)' }}>R{Number(item.price).toLocaleString()}</span>
                          </div>
                        ))}
                      </div>
                    )}
                    {/* Event details */}
                    <div style={{ padding: '14px 16px', background: 'var(--cream)', borderRadius: '10px', marginBottom: '12px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '10px', fontSize: '13px' }}>
                      {b.event_type && <div><span style={{ color: 'var(--gray)' }}>Type:</span> <strong>{b.event_type}</strong></div>}
                      {b.event_date && <div><span style={{ color: 'var(--gray)' }}>Date:</span> <strong>{new Date(b.event_date).toLocaleDateString('en-ZA', { day: 'numeric', month: 'short', year: 'numeric' })}</strong></div>}
                      {b.event_location && <div><span style={{ color: 'var(--gray)' }}>Location:</span> <strong>{b.event_location}</strong></div>}
                      {b.estimated_guests && <div><span style={{ color: 'var(--gray)' }}>Guests:</span> <strong>{b.estimated_guests}</strong></div>}
                    </div>
                    {/* Delivery info */}
                    {b.delivery_type && (() => {
                      const isVendorDelivers = b.delivery_type === 'flat_fee' || b.delivery_type === 'free';
                      const isComeToProvider = b.delivery_type === 'come_to_provider';
                      return (
                        <div style={{ marginBottom: '12px', padding: '12px', background: 'rgba(227,66,92,0.03)', borderRadius: '8px', borderLeft: '3px solid var(--rose)' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                            <FiTruck size={14} color="var(--rose)" />
                            <span style={{ fontSize: '12px', fontWeight: 600, color: 'var(--charcoal)' }}>
                              {isVendorDelivers
                                ? `You Deliver${b.delivery_type === 'flat_fee' ? ` — R${Number(b.delivery_fee || 0).toLocaleString()} delivery fee` : ' — Free Delivery'}`
                                : 'Client Collects'}
                            </span>
                          </div>
                          {isVendorDelivers && b.delivery_address ? (
                            <div style={{ padding: '8px 12px', background: 'rgba(16,185,129,0.06)', borderRadius: '6px' }}>
                              <div style={{ fontSize: '11px', fontWeight: 600, color: '#10B981', marginBottom: '4px' }}>Delivery Address</div>
                              <div style={{ fontSize: '13px', color: 'var(--charcoal)', whiteSpace: 'pre-wrap' }}>{b.delivery_address}</div>
                            </div>
                          ) : isVendorDelivers && !b.delivery_address ? (
                            <div style={{ padding: '6px 12px', background: 'rgba(245,158,11,0.06)', borderRadius: '6px', fontSize: '12px', color: '#D97706', fontStyle: 'italic' }}>
                              Awaiting delivery address from client...
                            </div>
                          ) : null}
                          {isComeToProvider && (
                            <div style={{ padding: '6px 12px', background: 'rgba(59,130,246,0.05)', borderRadius: '6px', fontSize: '12px', color: '#3B82F6' }}>
                              Client will collect from your business location.
                            </div>
                          )}
                        </div>
                      );
                    })()}
                    {b.event_description && <p style={{ fontSize: '13px', color: 'var(--gray)', marginBottom: '12px', lineHeight: 1.6 }}>{b.event_description.substring(0, 200)}{b.event_description.length > 200 ? '...' : ''}</p>}
                    {b.message && <div style={{ padding: '10px 14px', background: 'rgba(227,66,92,0.06)', borderRadius: '8px', fontSize: '14px', marginBottom: '12px', borderLeft: '3px solid var(--rose)' }}><span style={{ fontSize: '12px', color: 'var(--gray)', display: 'block', marginBottom: '4px' }}>Client's message:</span>{b.message}</div>}
                    {/* Reschedule request panel */}
                    {b.reschedule_requested && (
                      <div style={{ marginBottom: '12px', padding: '14px', background: 'rgba(245,158,11,0.06)', borderRadius: '8px', borderLeft: '3px solid #F59E0B' }}>
                        <div style={{ fontSize: '12px', fontWeight: 600, color: '#D97706', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                          Reschedule Requested
                        </div>
                        {b.reschedule_new_date && (
                          <div style={{ fontSize: '13px', marginBottom: '4px', color: 'var(--gray)' }}>
                            Requested date: <strong>{new Date(b.reschedule_new_date).toLocaleDateString('en-ZA', { day: 'numeric', month: 'short', year: 'numeric' })}</strong>
                          </div>
                        )}
                        {b.reschedule_notes && (
                          <div style={{ fontSize: '13px', marginBottom: '10px', color: 'var(--gray)', fontStyle: 'italic' }}>"{b.reschedule_notes}"</div>
                        )}
                        <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
                          <button className="btn btn-sm" style={{ background: 'var(--green)', color: 'white' }}
                            onClick={() => {
                              const date = rescheduleRespondDate[b.id] || b.reschedule_new_date;
                              api.put(`/vendor/bookings/${b.id}/reschedule`, { accepted: true, new_date: date })
                                .then(() => { api.get('/vendor/bookings').then(r => setBookings(r.data)); })
                                .catch(err => alert(err.response?.data?.error || 'Failed'));
                            }}
                          >Accept</button>
                          <button className="btn btn-sm" style={{ background: 'var(--gray)', color: 'white' }}
                            onClick={() => {
                              api.put(`/vendor/bookings/${b.id}/reschedule`, { accepted: false })
                                .then(() => { api.get('/vendor/bookings').then(r => setBookings(r.data)); })
                                .catch(err => alert(err.response?.data?.error || 'Failed'));
                            }}
                          >Decline</button>
                        </div>
                      </div>
                    )}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                      {b.status === 'pending' && (
                        <>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <span style={{ fontSize: '13px', fontWeight: 500, color: 'var(--gray)' }}>R</span>
                            <input
                              type="number"
                              value={quoteEdits[b.id] ?? Number(b.quote_amount || 0)}
                              onChange={e => setQuoteEdits(prev => ({ ...prev, [b.id]: Number(e.target.value) }))}
                              placeholder="Quote amount"
                              style={{ width: '130px', padding: '8px 12px', fontSize: '13px', borderRadius: '8px', border: '1px solid var(--cream-dark)', fontWeight: 600 }}
                            />
                          </div>
                          <button className="btn btn-sm" style={{ background: 'var(--green)', color: 'white' }} onClick={() => updateBooking(b.id, 'confirmed', quoteEdits[b.id] || b.quote_amount)}><FiCheck /> Accept</button>
                          <button className="btn btn-sm" style={{ background: 'var(--red)', color: 'white' }} onClick={() => updateBooking(b.id, 'declined')}><FiX /> Decline</button>
                        </>
                      )}
                      {b.status !== 'pending' && b.quote_amount > 0 && <span style={{ fontWeight: 600, color: 'var(--green)' }}>Quoted: R{Number(b.quote_amount).toLocaleString()}{Number(b.booking_fee || 0) > 0 ? <span style={{ fontSize: '11px', fontWeight: 400, color: 'var(--gray)', marginLeft: '6px' }}>(incl. R{Number(b.booking_fee).toLocaleString()} booking fee)</span> : null}</span>}
                      {b.status === 'confirmed' && (
                        <>
                          <button
                            onClick={() => { setCancelBookingId(b.id); setCancelReason(''); setCancelCustomReason(''); }}
                            style={{ padding: '6px 14px', fontSize: '12px', fontWeight: 600, borderRadius: '6px', border: '1px solid var(--red)', color: 'var(--red)', background: 'transparent', cursor: 'pointer' }}
                          >Cancel Booking</button>
                          {b.payment_status === 'paid' && (
                            <button
                              onClick={() => { setTab('deliveries'); }}
                              style={{ padding: '6px 14px', fontSize: '12px', fontWeight: 600, borderRadius: '6px', border: '1px solid #10B981', color: '#10B981', background: 'transparent', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px' }}
                            ><FiTruck size={13} /> Set Up Delivery</button>
                          )}
                          {['confirmed'].includes(b.status) && (
                            disputes.some(d => d.booking_id === b.id) ? (
                              <span style={{ padding: '5px 12px', fontSize: '11px', fontWeight: 600, borderRadius: '6px', background: 'rgba(245,158,11,0.12)', color: '#D97706' }}><FiAlertTriangle size={12} /> Issue Reported</span>
                            ) : (
                              <button
                                onClick={() => setReportModal({ booking_id: b.id, vendor_name: b.host_name || b.host_id })}
                                style={{ padding: '6px 14px', fontSize: '12px', fontWeight: 600, borderRadius: '6px', border: '1px solid #F59E0B', color: '#D97706', background: 'transparent', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px' }}
                              ><FiAlertTriangle size={12} /> Report Issue</button>
                            )
                          )}
                        </>
                      )}
                      {/* Archive toggle — shown for confirmed & paid or cancelled/declined */}
                      {(b.status === 'declined' || b.status === 'cancelled' || (b.status === 'confirmed' && b.payment_status === 'paid')) && (
                        <button
                          onClick={() => toggleArchive(b.id)}
                          style={{ padding: '6px 14px', fontSize: '12px', fontWeight: 600, borderRadius: '6px', border: '1px solid #9CA3AF', color: '#6B7280', background: 'transparent', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px', marginLeft: 'auto' }}
                          title={b.is_archived ? 'Unarchive this booking' : 'Archive this booking'}
                        >
                          <FiArchive size={12} /> {b.is_archived ? 'Unarchive' : 'Archive'}
                        </button>
                      )}
                    </div>
                  </div>
                ))}
                </div>
              </div>
            )}
          </div>
        )}

        {/* Cancel Booking Modal */}
        {cancelBookingId && (() => {
          const reasonTemplates = [
            'Unable to fulfill order',
            'Schedule conflict',
            'Pricing error',
            'Out of service area',
            'Other'
          ];
          const doCancel = async () => {
            const reason = cancelReason === 'Other' ? cancelCustomReason : cancelReason;
            if (!reason || !reason.trim()) return alert('Please select or enter a reason');
            setCancelling(true);
            try {
              await api.post(`/vendor/bookings/${cancelBookingId}/cancel`, { reason });
              alert('Booking cancelled');
              setCancelBookingId(null);
              api.get('/vendor/bookings').then(r => setBookings(r.data)).catch(() => {});
            } catch (err) {
              alert(err.response?.data?.error || 'Failed to cancel booking');
            } finally { setCancelling(false); }
          };
          return (
            <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => setCancelBookingId(null)}>
              <div style={{ background: 'var(--white)', borderRadius: '16px', padding: '28px', maxWidth: '460px', width: '90%', maxHeight: '80vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
                <h3 style={{ fontSize: '18px', marginBottom: '6px' }}>Cancel Booking</h3>
                <p style={{ fontSize: '13px', color: 'var(--gray)', marginBottom: '20px' }}>Please select a reason for cancellation:</p>
                <div style={{ display: 'grid', gap: '8px', marginBottom: '16px' }}>
                  {reasonTemplates.map(r => (
                    <label key={r} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 14px', borderRadius: '8px', border: cancelReason === r ? '2px solid var(--rose)' : '1px solid var(--cream-dark)', cursor: 'pointer', fontSize: '14px', background: cancelReason === r ? 'rgba(227,66,92,0.04)' : 'transparent' }}>
                      <input type="radio" name="cancelReason" value={r} checked={cancelReason === r} onChange={() => setCancelReason(r)} style={{ accentColor: 'var(--rose)' }} />
                      {r}
                    </label>
                  ))}
                </div>
                {cancelReason === 'Other' && (
                  <textarea
                    value={cancelCustomReason}
                    onChange={e => setCancelCustomReason(e.target.value)}
                    placeholder="Please describe the reason..."
                    rows={3}
                    style={{ width: '100%', padding: '10px 14px', borderRadius: '8px', border: '1px solid var(--cream-dark)', fontSize: '13px', marginBottom: '16px', resize: 'vertical', boxSizing: 'border-box' }}
                  />
                )}
                <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                  <button onClick={() => setCancelBookingId(null)} className="btn" style={{ background: 'var(--cream)', color: 'var(--gray)' }}>Close</button>
                  <button onClick={doCancel} disabled={cancelling} className="btn" style={{ background: 'var(--red)', color: 'white' }}>
                    {cancelling ? 'Cancelling...' : 'Confirm Cancellation'}
                  </button>
                </div>
              </div>
            </div>
          );
        })()}

        {/* Report Issue Modal */}
        {reportModal && (() => {
          const submitReport = async () => {
            if (!reportSubject.trim() || !reportDescription.trim()) return alert('Please fill in all fields');
            setReporting(true);
            try {
              await api.post('/disputes', { booking_id: reportModal.booking_id, subject: reportSubject, description: reportDescription });
              alert('Issue reported — we will review and respond');
              setReportModal(null);
              setReportSubject('');
              setReportDescription('');
              api.get('/disputes').then(r => setDisputes(r.data)).catch(() => {});
            } catch (err) {
              alert(err.response?.data?.error || 'Failed to submit report');
            } finally { setReporting(false); }
          };
          return (
            <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => { setReportModal(null); setReportSubject(''); setReportDescription(''); }}>
              <div style={{ background: 'var(--white)', borderRadius: '16px', padding: '28px', maxWidth: '460px', width: '90%', maxHeight: '80vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
                <h3 style={{ fontSize: '18px', marginBottom: '4px', display: 'flex', alignItems: 'center', gap: '8px' }}><FiAlertTriangle color="#F59E0B" /> Report an Issue</h3>
                <p style={{ fontSize: '13px', color: 'var(--gray)', marginBottom: '6px' }}>Booking with <strong>{reportModal.vendor_name}</strong></p>
                <p style={{ fontSize: '12px', color: 'var(--gray)', marginBottom: '16px' }}>GGR will review your booking records, chat history, and payment status to help resolve the issue.</p>
                <input
                  value={reportSubject}
                  onChange={e => setReportSubject(e.target.value)}
                  placeholder="Subject (e.g. Host not responding)"
                  style={{ width: '100%', padding: '10px 14px', borderRadius: '8px', border: '1px solid var(--cream-dark)', fontSize: '13px', marginBottom: '12px', boxSizing: 'border-box' }}
                />
                <textarea
                  value={reportDescription}
                  onChange={e => setReportDescription(e.target.value)}
                  placeholder="Describe the issue in detail..."
                  rows={4}
                  style={{ width: '100%', padding: '10px 14px', borderRadius: '8px', border: '1px solid var(--cream-dark)', fontSize: '13px', marginBottom: '16px', resize: 'vertical', boxSizing: 'border-box' }}
                />
                <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                  <button onClick={() => { setReportModal(null); setReportSubject(''); setReportDescription(''); }} className="btn" style={{ background: 'var(--cream)', color: 'var(--gray)' }}>Close</button>
                  <button onClick={submitReport} disabled={reporting} className="btn" style={{ background: '#F59E0B', color: 'white' }}>
                    {reporting ? 'Submitting...' : 'Submit Report'}
                  </button>
                </div>
              </div>
            </div>
          );
        })()}

        {/* ═══ CHATS ═══ */}
        {tab === 'chats' && (
          <div style={{ display: 'grid', gridTemplateColumns: activeChat && !isMobile ? '280px 1fr' : '1fr', gap: '16px', height: isMobile ? 'auto' : 'calc(100vh - 180px)', minHeight: '500px' }}>
            {/* Conversation list - hide on mobile when chat is open */}
            <div className="card" style={{ padding: '0', overflow: 'hidden', display: activeChat && isMobile ? 'none' : 'block' }}>
              <div style={{ padding: '16px', borderBottom: '1px solid var(--cream-dark)', fontWeight: 600, fontSize: '14px' }}>Conversations ({conversations.length})</div>
              {conversations.length === 0 ? (
                <div style={{ padding: '40px 20px', textAlign: 'center', fontSize: '14px' }}>
                  <div style={{ color: 'var(--gray)', marginBottom: '16px' }}>No conversations yet. Browse events to find hosts looking for services like yours.</div>
                  <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', flexWrap: 'wrap' }}>
                    <button
                      onClick={() => openBrowseEvents()}
                      style={{
                        background: 'var(--rose)', color: '#fff', border: 'none',
                        borderRadius: '10px', padding: '10px 20px', cursor: 'pointer',
                        fontSize: '13px', fontWeight: 600, fontFamily: 'Inter, sans-serif',
                      }}
                    >Browse Events</button>
                    <button
                      onClick={() => setShowOutreachModal(true)}
                      style={{
                        background: 'var(--cream)', color: 'var(--dark)', border: '1px solid var(--cream-dark)',
                        borderRadius: '10px', padding: '10px 20px', cursor: 'pointer',
                        fontSize: '13px', fontWeight: 600, fontFamily: 'Inter, sans-serif',
                      }}
                    >Make Enquiry</button>
                  </div>
                </div>
              ) : (
                <div style={{ maxHeight: '450px', overflowY: 'auto' }}>
                  {conversations.map(c => (
                    <div key={c.id} onClick={() => openChat(c.id)} style={{
                      padding: '14px 16px', cursor: 'pointer', borderBottom: '1px solid var(--cream)',
                      background: activeChat?.id === c.id ? 'var(--cream)' : 'transparent',
                      transition: 'background 0.2s'
                    }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span style={{ fontWeight: 600, fontSize: '14px' }}>{c.other_name}</span>
                        {parseInt(c.unread_count) > 0 && <span style={{ background: 'var(--rose)', color: 'white', borderRadius: '10px', padding: '1px 8px', fontSize: '11px', fontWeight: 700 }}>{c.unread_count}</span>}
                      </div>
                      {c.event_title && <div style={{ fontSize: '12px', color: 'var(--gray)', marginTop: '3px', display: 'flex', alignItems: 'center', gap: '4px' }}><FiCalendar size={11} /><span>{c.event_title}</span></div>}
                      {c.subject && <div style={{ fontSize: '12px', color: 'var(--gray)', marginTop: '2px' }}>{c.subject}</div>}
                      {c.last_message && <div style={{ fontSize: '12px', color: 'var(--gray)', marginTop: '4px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c.last_message}</div>}
                    </div>
                  ))}
                </div>
              )}
            </div>
            {/* Chat area */}
            {activeChat && (
              <div className="card" style={{ padding: 0, display: 'flex', flexDirection: 'column', overflow: 'visible' }}>
                <div style={{ padding: '14px 20px', borderBottom: '1px solid var(--cream-dark)', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '10px' }}>
                  {isMobile && (
                    <button onClick={() => setActiveChat(null)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px', display: 'flex', alignItems: 'center', color: 'var(--gray)' }}><FiChevronLeft size={20} /></button>
                  )}
                  <span style={{ flex: 1 }}>Chat with {activeChat.client_id === user?.id ? 'Vendor' : conversations.find(c => c.id === activeChat.id)?.other_name || 'Client'}</span>
                  <button onClick={() => archiveConversation(conversations.find(c => c.id === activeChat.id))} title={conversations.find(c => c.id === activeChat.id)?.archived ? 'Unarchive' : 'Archive'} style={{ background: 'none', border: 'none', cursor: 'pointer', color: conversations.find(c => c.id === activeChat.id)?.archived ? 'var(--gold)' : 'var(--gray)', display: 'flex', alignItems: 'center', padding: '4px' }}>
                    <FiArchive size={14} />
                  </button>
                  <button onClick={() => deleteConversation(conversations.find(c => c.id === activeChat.id))} title="Delete" style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--gray)', display: 'flex', alignItems: 'center', padding: '4px' }}>
                    <FiTrash2 size={14} />
                  </button>
                  {isMobile && (
                    <button onClick={() => setActiveChat(null)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--gray)', display: 'flex', alignItems: 'center', padding: '4px' }}>
                      <FiX size={18} />
                    </button>
                  )}
                </div>
                {/* Event Context Panel for Vendor */}
                {eventChatData?.event && (
                  <div style={{ padding: '12px 16px', borderBottom: '1px solid var(--cream-dark)', background: 'linear-gradient(135deg, #FDF2F4, white)', fontSize: '13px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                      <span style={{ fontWeight: 700, fontSize: '14px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <FiInfo size={14} style={{ color: 'var(--rose)' }} /> Event Brief
                      </span>
                      <span style={{ padding: '2px 10px', borderRadius: '10px', fontSize: '10px', fontWeight: 600, textTransform: 'uppercase', background: 'var(--rose-light)', color: 'var(--rose)' }}>
                        {eventChatData.event.event_type}
                      </span>
                    </div>
                    <div style={{ fontSize: '15px', fontWeight: 700, marginBottom: '8px', color: 'var(--dark)' }}>{eventChatData.event.title}</div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: '6px', color: 'var(--gray)', fontSize: '12px' }}>
                      {eventChatData.event.event_date && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                          <FiCalendar size={12} style={{ flexShrink: 0, color: 'var(--rose)' }} />
                          <span>{new Date(eventChatData.event.event_date).toLocaleDateString('en-ZA', { day: 'numeric', month: 'short', year: 'numeric' })}</span>
                        </div>
                      )}
                      {eventChatData.event.event_time && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                          <FiClock size={12} style={{ flexShrink: 0, color: 'var(--rose)' }} />
                          <span>{eventChatData.event.event_time}{eventChatData.event.end_time ? ` - ${eventChatData.event.end_time}` : ''}{eventChatData.event.till_late ? ' (till late)' : ''}</span>
                        </div>
                      )}
                      {eventChatData.event.location && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                          <FiMapPin size={12} style={{ flexShrink: 0, color: 'var(--rose)' }} />
                          <span>{eventChatData.event.location}</span>
                        </div>
                      )}
                      {eventChatData.event.estimated_guests > 0 && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                          <FiUsers size={12} style={{ flexShrink: 0, color: 'var(--rose)' }} />
                          <span>{eventChatData.event.estimated_guests} guests</span>
                        </div>
                      )}
                      {eventChatData.event.dress_code && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                          <FiInfo size={12} style={{ flexShrink: 0, color: 'var(--rose)' }} />
                          <span>Dress: {eventChatData.event.dress_code}</span>
                        </div>
                      )}
                    </div>
                    {eventChatData.event.description && (
                      <div style={{ marginTop: '8px', fontSize: '12px', color: 'var(--gray)', lineHeight: 1.5, background: 'var(--white)', padding: '8px 10px', borderRadius: '8px', border: '1px solid var(--cream-dark)' }}>
                        {eventChatData.event.description}
                      </div>
                    )}
                    {/* Invitation Preview */}
                    {eventChatData.invitation && (
                      <div style={{ marginTop: '10px', padding: '10px', background: 'var(--white)', borderRadius: '8px', border: '1px solid var(--cream-dark)' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
                          <span style={{ fontWeight: 600, fontSize: '12px', display: 'flex', alignItems: 'center', gap: '5px' }}>
                            <FiFileText size={12} style={{ color: 'var(--rose)' }} /> Invitation
                          </span>
                          {eventChatData.invitation.share_link && (
                            <a href={`/invite/${eventChatData.invitation.share_link}`} target="_blank" rel="noopener noreferrer"
                              style={{ fontSize: '10px', color: 'var(--rose)', display: 'flex', alignItems: 'center', gap: '3px', textDecoration: 'none', fontWeight: 600 }}>
                              <FiExternalLink size={10} /> View
                            </a>
                          )}
                        </div>
                        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                          <div style={{ display: 'flex', gap: '3px' }}>
                            {eventChatData.invitation.colors && typeof eventChatData.invitation.colors === 'object' ? [
                              eventChatData.invitation.colors.bg,
                              eventChatData.invitation.colors.accent,
                              eventChatData.invitation.colors.text
                            ].filter(Boolean).map((c, i) => (
                              <div key={i} style={{ width: '16px', height: '16px', borderRadius: '50%', background: c, border: '1px solid rgba(0,0,0,0.1)' }} title={c} />
                            )) : null}
                          </div>
                          <span style={{ fontSize: '11px', color: 'var(--gray)', textTransform: 'capitalize' }}>
                            {eventChatData.invitation.theme || 'Custom'} theme
                            {eventChatData.invitation.invitation_heading ? ` · "${eventChatData.invitation.invitation_heading}"` : ''}
                          </span>
                        </div>
                        {eventChatData.invitation.visible_tabs && Array.isArray(eventChatData.invitation.visible_tabs) && eventChatData.invitation.visible_tabs.length > 0 && (
                          <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap', marginTop: '6px' }}>
                            {eventChatData.invitation.visible_tabs.map(tab => (
                              <span key={tab} style={{ padding: '2px 8px', borderRadius: '10px', fontSize: '10px', background: 'var(--cream)', color: 'var(--gray)', textTransform: 'capitalize' }}>{tab}</span>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                    {/* Timeline */}
                    {eventChatData.timeline && eventChatData.timeline.length > 0 && (
                      <div style={{ marginTop: '10px', padding: '10px', background: 'var(--white)', borderRadius: '8px', border: '1px solid var(--cream-dark)' }}>
                        <div style={{ fontWeight: 600, fontSize: '12px', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '5px' }}>
                          <FiClock size={12} style={{ color: 'var(--rose)' }} /> Timeline
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                          {eventChatData.timeline.map((item, i) => (
                            <div key={i} style={{ display: 'flex', gap: '8px', fontSize: '11px', alignItems: 'baseline' }}>
                              {item.item_date && (
                                <span style={{ fontWeight: 600, color: 'var(--rose)', whiteSpace: 'nowrap', minWidth: '75px', fontSize: '10px' }}>
                                  {new Date(item.item_date).toLocaleDateString('en-ZA', { day: 'numeric', month: 'short' })}
                                </span>
                              )}
                              <div>
                                <span style={{ fontWeight: 500 }}>{item.title}</span>
                                {item.description && <span style={{ color: 'var(--gray)', marginLeft: '4px' }}>— {item.description}</span>}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                )}
                <div style={{ flex: 1, overflowY: 'auto', padding: isMobile ? '10px' : '16px', display: 'flex', flexDirection: 'column', gap: '10px', background: 'linear-gradient(rgba(255,255,255,0.12), rgba(255,255,255,0.12)), url("/screenshot-bg-plain.png"), var(--cream)', backgroundSize: 'cover', backgroundPosition: 'center', minHeight: '200px' }}>
                  {chatMessages.map((m, i) => (
                    <div key={i} style={{ display: 'flex', flexDirection: m.sender_id === user?.id ? 'row-reverse' : 'row', gap: '8px' }}>
                      {m.message_type === 'rate_card' ? (
                        // Always render rate card — use data if available, fallback to content
                        (() => {
                          const rcd = m.rate_card_data || {};
                          const title = rcd.title || (m.content || '').replace('📋 Rate Card: ', '');
                          const items = rcd.items || [];
                          return (
                        <div style={{ maxWidth: '85%', borderRadius: '12px', overflow: 'hidden', background: 'var(--white)', border: '1px solid #e8e5df', boxShadow: '0 2px 16px rgba(0,0,0,0.06)' }}>
                          {/* Header */}
                          <div style={{ padding: '14px 16px', display: 'flex', alignItems: 'center', gap: '12px', borderBottom: '1px solid #f0ede6' }}>
                            {rcd.logo_url ? (
                              <img src={rcd.logo_url} alt="" style={{ width: '40px', height: '40px', borderRadius: '8px', objectFit: 'cover', border: '1px solid #f0ede6' }} />
                            ) : (
                              <div style={{ width: '40px', height: '40px', borderRadius: '8px', background: 'linear-gradient(135deg, var(--rose-deep), #f08c98)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px', fontWeight: 700, color: 'white' }}>{(rcd.business_name || 'V')[0]}</div>
                            )}
                            <div style={{ flex: 1 }}>
                              {rcd.business_name && <div style={{ fontWeight: 700, fontSize: '14px', color: 'var(--dark)' }}>{rcd.business_name}</div>}
                              <div style={{ fontSize: '12px', color: 'var(--gray)', fontWeight: 500 }}>{title}</div>
                            </div>
                            <div style={{ padding: '4px 10px', borderRadius: '20px', background: '#f0ede6', fontSize: '11px', fontWeight: 600, color: 'var(--gray)' }}>Sent</div>
                          </div>
                          {/* Body */}
                          {items.length > 0 ? (
                            <>
                              {items.map((item, j) => (
                                <div key={j} style={{ padding: '12px 16px', borderBottom: j < items.length - 1 ? '1px solid #f0ede6' : 'none', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '12px' }}>
                                  {item.image_url && (
                                    <img src={item.image_url} alt="" style={{ width: '48px', height: '48px', borderRadius: '8px', objectFit: 'cover', flexShrink: 0, border: '1px solid #f0ede6' }} onError={e => { e.target.style.display = 'none'; }} />
                                  )}
                                  <div style={{ flex: 1, minWidth: 0 }}>
                                    <div style={{ fontSize: '13px', fontWeight: 600, color: 'var(--dark)' }}>{item.service_name}</div>
                                    {item.description && <div style={{ fontSize: '11px', color: 'var(--gray)', marginTop: '3px', lineHeight: 1.4 }}>{item.description}</div>}
                                  </div>
                                  <div style={{ textAlign: 'right', flexShrink: 0 }}>
                                    <div style={{ fontWeight: 700, fontSize: '14px', color: '#1c1c1e' }}>R{Number(item.price).toLocaleString()}</div>
                                    <div style={{ fontSize: '10px', color: 'var(--gray)' }}>{item.unit || 'per item'}</div>
                                  </div>
                                </div>
                              ))}
                              {items.length > 1 && (
                                <div style={{ padding: '12px 16px', background: '#faf9f6', display: 'flex', justifyContent: 'space-between', fontWeight: 700, fontSize: '14px', borderTop: '2px solid #f0ede6' }}>
                                  <span>Package Total</span>
                                  <span style={{ color: 'var(--rose-deep)' }}>R{items.reduce((a, it) => a + Number(it.price || 0), 0).toLocaleString()}</span>
                                </div>
                              )}
                            </>
                          ) : (
                            <div style={{ padding: '16px' }}>
                              {rcd.description && <div style={{ fontSize: '12px', color: 'var(--gray)', marginBottom: '12px', lineHeight: 1.5 }}>{rcd.description}</div>}
                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                {rcd.image_url && (
                                  <img src={rcd.image_url} alt="" style={{ width: '56px', height: '56px', borderRadius: '10px', objectFit: 'cover', flexShrink: 0, border: '1px solid #f0ede6' }} onError={e => { e.target.style.display = 'none'; }} />
                                )}
                                <div style={{ textAlign: 'right', flex: 1 }}>
                                  {rcd.price != null ? (
                                    <div style={{ fontWeight: 700, fontSize: '22px', color: '#1c1c1e' }}>R{Number(rcd.price).toLocaleString()}</div>
                                  ) : rcd.description ? null : (
                                    <div style={{ fontSize: '13px', color: 'var(--gray)' }}>Rate card</div>
                                  )}
                                  <div style={{ fontSize: '12px', color: 'var(--gray)', fontWeight: 500 }}>{rcd.unit || 'per event'}</div>
                                </div>
                              </div>
                            </div>
                          )}
                          {/* Timestamp */}
                          <div style={{ padding: '6px 16px', fontSize: '10px', color: '#b0ada5', textAlign: 'right' }}>
                            {new Date(m.created_at).toLocaleTimeString('en-ZA', { hour: '2-digit', minute: '2-digit' })}
                          </div>
                        </div>
                          );
                        })()
                      ) : m.message_type === 'voice_note' ? (
                        <div style={{
                          maxWidth: '70%', padding: '10px 14px',
                          borderRadius: m.sender_id === user?.id ? '14px 14px 4px 14px' : '14px 14px 14px 4px',
                          background: m.sender_id === user?.id ? 'var(--dark)' : 'white',
                          color: m.sender_id === user?.id ? 'white' : 'var(--dark)',
                          boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
                        }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', minWidth: '200px' }}>
                            <FiMic size={16} style={{ color: 'var(--rose)', flexShrink: 0 }} />
                            <audio src={m.content} controls style={{ height: '36px', flex: 1, minWidth: 0 }} />
                          </div>
                        </div>
                      ) : m.message_type === 'payment_prompt' ? (
                        (() => {
                          let displayContent = m.content_filtered || m.content || '';
                          try {
                            const newlineIdx = displayContent.indexOf('\n');
                            const firstLine = newlineIdx >= 0 ? displayContent.substring(0, newlineIdx) : displayContent;
                            JSON.parse(firstLine); // test if valid JSON prefix
                            displayContent = newlineIdx >= 0 ? displayContent.substring(newlineIdx + 1) : '';
                          } catch {}
                          return (
                            <div style={{ maxWidth: '85%', borderRadius: '14px', overflow: 'hidden', background: 'var(--white)', border: '1px solid #d1fae5', boxShadow: '0 2px 16px rgba(16,185,129,0.08)' }}>
                              <div style={{ padding: '14px 16px', background: 'linear-gradient(135deg, #059669, #10B981)', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <FiCheckCircle size={18} style={{ color: 'white' }} />
                                <span style={{ fontWeight: 700, fontSize: '14px', color: 'white' }}>Booking Confirmed — Payment Prompt Sent</span>
                              </div>
                              <div style={{ padding: '16px', fontSize: '14px', lineHeight: 1.6, whiteSpace: 'pre-wrap', color: 'var(--dark)' }}>
                                {displayContent}
                              </div>
                              <div style={{ padding: '6px 16px', fontSize: '10px', color: '#b0ada5', textAlign: 'right' }}>
                                {new Date(m.created_at).toLocaleTimeString('en-ZA', { hour: '2-digit', minute: '2-digit' })}
                              </div>
                            </div>
                          );
                        })()
                      ) : (
                        <div style={{
                          maxWidth: '70%', padding: '10px 14px', borderRadius: m.sender_id === user?.id ? '14px 14px 4px 14px' : '14px 14px 14px 4px',
                          background: m.sender_id === user?.id ? 'var(--dark)' : 'white',
                          color: m.sender_id === user?.id ? 'white' : 'var(--dark)',
                          fontSize: '14px', lineHeight: 1.5,
                          boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
                        }}>
                          {m.is_filtered && <div style={{ fontSize: '11px', color: m.sender_id === user?.id ? 'rgba(255,255,255,0.5)' : 'var(--gray)', marginBottom: '4px', fontStyle: 'italic' }}>Contact info filtered for security</div>}
                          {editingMessageId === m.id ? (
                            <div>
                              <input
                                value={editContent}
                                onChange={e => setEditContent(e.target.value)}
                                onKeyDown={e => { if (e.key === 'Enter') { editMessage(m, editContent); setEditingMessageId(null); } if (e.key === 'Escape') setEditingMessageId(null); }}
                                style={{ width: '100%', padding: '6px 10px', borderRadius: '8px', border: '1px solid var(--cream-dark)', fontSize: '14px', background: 'var(--white)', color: 'var(--dark)' }}
                                autoFocus
                              />
                              <div style={{ display: 'flex', gap: '6px', marginTop: '6px', justifyContent: 'flex-end' }}>
                                <button onClick={() => setEditingMessageId(null)} style={{ background: 'none', border: '1px solid var(--cream-dark)', borderRadius: '6px', padding: '4px 10px', cursor: 'pointer', fontSize: '12px', color: 'var(--gray)' }}>Cancel</button>
                                <button onClick={() => { editMessage(m, editContent); setEditingMessageId(null); }} style={{ background: 'var(--dark)', color: 'white', border: 'none', borderRadius: '6px', padding: '4px 12px', cursor: 'pointer', fontSize: '12px', fontWeight: 600 }}>Save</button>
                              </div>
                            </div>
                          ) : (
                            <>
                              {m.content_filtered || m.content}
                              {m.edited_at && <span style={{ fontSize: '10px', opacity: 0.6, marginLeft: '4px' }}>(edited)</span>}
                            </>
                          )}
                          <div style={{ fontSize: '10px', opacity: 0.5, marginTop: '4px', display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'space-between' }}>
                            <span>{new Date(m.created_at).toLocaleTimeString('en-ZA', { hour: '2-digit', minute: '2-digit' })}</span>
                            {m.sender_id === user?.id && editingMessageId !== m.id && (
                              <button onClick={() => { setEditingMessageId(m.id); setEditContent(m.content || ''); }} title="Edit" style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '2px', display: 'flex', alignItems: 'center', opacity: 0.6 }}>
                                <FiEdit2 size={11} />
                              </button>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                  <div ref={chatEndRef} />
                </div>
                <div style={{ padding: isMobile ? '10px 8px' : '12px 16px', borderTop: '1px solid var(--cream-dark)', position: 'relative' }}>
                  {/* Rate Card Picker */}
                  {showRateCardPicker && rateCards.length > 0 && (
                    <div style={{ position: 'absolute', bottom: '100%', left: '16px', right: '16px', background: 'var(--white)', borderRadius: '12px', boxShadow: '0 -4px 24px rgba(0,0,0,0.12)', border: '1px solid var(--cream-dark)', maxHeight: '300px', overflowY: 'auto', zIndex: 10 }}>
                      <div style={{ padding: '12px 16px', borderBottom: '1px solid var(--cream)', fontWeight: 600, fontSize: '13px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span>Select Rate Card to Send</span>
                        <button onClick={() => setShowRateCardPicker(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--gray)' }}><FiX size={16} /></button>
                      </div>
                      {rateCards.map(card => (
                        <div key={card.id} onClick={() => sendRateCardMessage(card.id)} style={{ padding: '12px 16px', cursor: 'pointer', borderBottom: '1px solid var(--cream)', transition: 'background 0.15s', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                          onMouseEnter={e => e.currentTarget.style.background = 'var(--cream)'}
                          onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                          <div>
                            <div style={{ fontWeight: 600, fontSize: '14px' }}>{card.title}</div>
                            <div style={{ fontSize: '12px', color: 'var(--gray)' }}>
                              {card.card_type === 'package'
                                ? `${card.items?.length || 0} items · R${(card.items || []).reduce((a, i) => a + Number(i.price || 0), 0).toLocaleString()}`
                                : `R${Number(card.price || 0).toLocaleString()} — ${card.unit || 'per event'}`
                              }
                            </div>
                          </div>
                          <FiSend size={14} style={{ color: 'var(--rose)' }} />
                        </div>
                      ))}
                    </div>
                  )}
                  <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                    {isRecording ? (
                      <>
                        <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 16px', background: 'rgba(227,66,92,0.08)', borderRadius: '20px', border: '1px solid rgba(227,66,92,0.2)' }}>
                          <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: 'var(--rose)', animation: 'pulse 1s infinite' }} />
                          <span style={{ fontSize: '14px', color: 'var(--rose)', fontWeight: 600 }}>Recording... {Math.floor(recordingTime / 60)}:{String(recordingTime % 60).padStart(2, '0')}</span>
                        </div>
                        <button onClick={cancelRecording} style={{ borderRadius: '50%', width: '40px', height: '40px', padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'none', border: '1px solid var(--cream-dark)', cursor: 'pointer', color: 'var(--gray)', flexShrink: 0 }}><FiX size={16} /></button>
                        <button onClick={stopRecording} className="btn btn-primary btn-sm" style={{ borderRadius: '50%', width: '40px', height: '40px', padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><FiSend size={16} /></button>
                      </>
                    ) : (
                      <>
                        {rateCards.length > 0 && (
                          <button onClick={() => setShowRateCardPicker(!showRateCardPicker)} title="Send Rate Card" style={{ background: showRateCardPicker ? 'var(--rose)' : 'var(--cream)', color: showRateCardPicker ? 'white' : 'var(--gray)', border: 'none', borderRadius: '50%', width: '40px', height: '40px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s', flexShrink: 0 }}><FiCreditCard size={16} /></button>
                        )}
                        {/* Templates Button */}
                        <div style={{ position: 'relative' }}>
                          <button onClick={() => { if (templates.length === 0) loadTemplates(); setShowTemplates(!showTemplates); }} title="Message Templates" style={{ background: showTemplates ? 'var(--rose)' : 'var(--cream)', color: showTemplates ? 'white' : 'var(--gray)', border: 'none', borderRadius: '50%', width: '40px', height: '40px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s', flexShrink: 0 }}><FiMessageSquare size={16} /></button>
                          {showTemplates && (
                            <div style={{ position: 'absolute', bottom: '100%', right: 0, marginBottom: '8px', background: 'var(--white)', borderRadius: '12px', boxShadow: '0 -4px 24px rgba(0,0,0,0.12)', border: '1px solid var(--cream-dark)', width: '280px', maxHeight: '280px', overflowY: 'auto', zIndex: 10 }}>
                              <div style={{ padding: '10px 14px', borderBottom: '1px solid var(--cream)', fontWeight: 600, fontSize: '13px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <span>Quick Templates</span>
                                <button onClick={() => setShowTemplates(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--gray)' }}><FiX size={14} /></button>
                              </div>
                              {templates.map((tpl, i) => (
                                <div key={i} onClick={() => insertTemplate(tpl)} style={{ padding: '10px 14px', cursor: 'pointer', borderBottom: '1px solid var(--cream)', transition: 'background 0.15s' }}
                                  onMouseEnter={e => e.currentTarget.style.background = 'var(--cream)'}
                                  onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                                  <div style={{ fontWeight: 600, fontSize: '13px' }}>{tpl.label}</div>
                                  <div style={{ fontSize: '11px', color: 'var(--gray)', marginTop: '2px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{tpl.body.substring(0, 70)}{tpl.body.length > 70 ? '...' : ''}</div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                        {activeChat && (
                          <button onClick={() => { setQuotationForm({ title: '', description: '', delivery_type: 'free', delivery_fee: '', booking_fee: '', booking_fee_description: '', expiry_date: '', notes: '', items: [{ service_name: '', description: '', price: '', unit: 'per event' }] }); setShowQuotationModal(true); }} title="Create Quotation" style={{ background: 'var(--cream)', color: 'var(--gray)', border: 'none', borderRadius: '50%', width: '40px', height: '40px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s', flexShrink: 0 }}><FiFileText size={16} /></button>
                        )}
                        <input value={chatInput} onChange={e => setChatInput(e.target.value)} onKeyDown={e => e.key === 'Enter' && sendChatMessage()} placeholder="Type a message..." style={{ flex: 1, padding: '10px 16px', borderRadius: '20px', border: '1px solid var(--cream-dark)', fontSize: '14px', minWidth: 0, boxSizing: 'border-box' }} />
                        <button onClick={() => startRecording()} title="Record voice note" style={{ borderRadius: '50%', width: '40px', height: '40px', padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'none', border: '1px solid var(--cream-dark)', cursor: 'pointer', color: 'var(--gray)', flexShrink: 0 }}><FiMic size={16} /></button>
                        <button onClick={sendChatMessage} disabled={!chatInput.trim()} className="btn btn-primary btn-sm" style={{ borderRadius: '50%', width: '40px', height: '40px', padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><FiSend size={16} /></button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {/* ═══ PORTFOLIO ═══ */}
        {tab === 'portfolio' && (
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '12px' }}>
              <h3>{portfolio.length}/{maxPortfolio} Items</h3>
              {portfolio.length < maxPortfolio && (
                <div style={{ display: 'flex', gap: '8px' }}>
                  <label className="btn btn-primary btn-sm" style={{ cursor: 'pointer' }}>
                    <FiUpload /> Upload Image
                    <input type="file" accept="image/*" onChange={e => { if (e.target.files[0]) uploadPortfolio(e.target.files[0]); }} style={{ display: 'none' }} />
                  </label>
                  <label className="btn btn-secondary btn-sm" style={{ cursor: 'pointer' }}>
                    <FiUpload /> Upload Video
                    <input type="file" accept="video/*" onChange={e => { if (e.target.files[0]) uploadPortfolio(e.target.files[0]); }} style={{ display: 'none' }} />
                  </label>
                </div>
              )}
            </div>
            <p style={{ fontSize: '13px', color: 'var(--gray)', marginBottom: '16px' }}>Upload up to {maxPortfolio} images or videos to showcase your work. High-quality content attracts more clients.</p>
            {portfolio.length >= maxPortfolio && planTier !== 'premium' && (
              <div style={{ padding: '14px 18px', borderRadius: '12px', background: 'rgba(232,160,191,0.06)', border: '1px solid rgba(232,160,191,0.15)', marginBottom: '16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px' }}>
                <div>
                  <div style={{ fontWeight: 600, fontSize: '13px', color: 'var(--dark)', marginBottom: '2px' }}>Portfolio limit reached</div>
                  <div style={{ fontSize: '12px', color: 'var(--gray)' }}>Upgrade to {planTier === 'free' ? 'Pro (15 items) or Premium (unlimited)' : 'Premium (unlimited)'} for more portfolio space.</div>
                </div>
                <Link to="/upgrade?type=vendor" style={{ padding: '8px 18px', borderRadius: '10px', background: 'linear-gradient(135deg, var(--rose), var(--rose-deep))', color: '#fff', fontWeight: 700, fontSize: '12px', textDecoration: 'none', whiteSpace: 'nowrap' }}>Upgrade</Link>
              </div>
            )}
            {portfolio.length === 0 ? (
              <div className="card" style={{ textAlign: 'center', padding: '60px' }}>
                <FiImage size={48} style={{ color: 'var(--gray)', marginBottom: '16px', opacity: 0.3 }} />
                <h3 style={{ marginBottom: '8px' }}>No Portfolio Items</h3>
                <p style={{ color: 'var(--gray)', marginBottom: '24px' }}>Upload images and videos to showcase your work to potential clients.</p>
                <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                  <label className="btn btn-primary" style={{ cursor: 'pointer' }}>
                    <FiUpload /> Upload Image
                    <input type="file" accept="image/*" onChange={e => { if (e.target.files[0]) uploadPortfolio(e.target.files[0]); }} style={{ display: 'none' }} />
                  </label>
                  <label className="btn btn-secondary" style={{ cursor: 'pointer' }}>
                    <FiUpload /> Upload Video
                    <input type="file" accept="video/*" onChange={e => { if (e.target.files[0]) uploadPortfolio(e.target.files[0]); }} style={{ display: 'none' }} />
                  </label>
                </div>
              </div>
            ) : (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '16px' }}>
                {portfolio.map(img => (
                  <div key={img.id} style={{ position: 'relative', borderRadius: '12px', overflow: 'hidden', aspectRatio: '1' }}>
                    {img.media_type === 'video' ? (
                      <video src={img.image_url} style={{ width: '100%', height: '100%', objectFit: 'cover' }} controls />
                    ) : (
                      <img src={img.image_url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    )}
                    {img.media_type === 'video' && (
                      <div style={{ position: 'absolute', top: '8px', left: '8px', background: 'rgba(0,0,0,0.6)', color: 'white', borderRadius: '4px', padding: '2px 8px', fontSize: '10px', fontWeight: 600 }}>VIDEO</div>
                    )}
                    <button onClick={() => deletePortfolio(img.id)} style={{ position: 'absolute', top: '8px', right: '8px', background: 'rgba(0,0,0,0.6)', color: 'white', border: 'none', borderRadius: '50%', width: '32px', height: '32px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><FiTrash2 size={14} /></button>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* ═══ RATE CARDS ═══ */}
        {tab === 'ratecards' && (
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '12px' }}>
              <div>
                <h3 style={{ marginBottom: '4px' }}>Rate Cards ({rateCards.length})</h3>
                <p style={{ fontSize: '13px', color: 'var(--gray)' }}>Create single items or packages to share with clients.</p>
              </div>
              <button className="btn btn-primary btn-sm" disabled={rateCards.length >= 20} onClick={() => { setShowRateCardForm(true); setEditingRateCard(null); setRateCardForm(defaultRateCardForm); }}><FiPlus /> New Rate Card</button>
              {rateCards.length >= 20 && <span style={{ fontSize: '12px', color: 'var(--gray)' }}>Maximum 20 rate cards reached</span>}
            </div>

            {/* Rate Card Form */}
            {showRateCardForm && (
              <div className="card" style={{ padding: '24px', marginBottom: '20px', border: '2px solid var(--rose)' }}>
                <h4 style={{ marginBottom: '16px', fontSize: '16px' }}>{editingRateCard ? 'Edit Rate Card' : 'Create Rate Card'}</h4>

                {/* Type selector */}
                <div style={{ display: 'flex', gap: '8px', marginBottom: '20px' }}>
                  {[{ key: 'single', label: 'Single Item', desc: 'One product or service' }, { key: 'package', label: 'Package', desc: 'Multiple items bundled' }].map(t => (
                    <div key={t.key} onClick={() => setRateCardForm({ ...rateCardForm, card_type: t.key })}
                      style={{ flex: 1, padding: '14px', borderRadius: '10px', border: `2px solid ${rateCardForm.card_type === t.key ? 'var(--rose)' : 'var(--cream-dark)'}`, cursor: 'pointer', background: rateCardForm.card_type === t.key ? 'var(--rose-light)' : 'white', transition: 'all 0.15s' }}>
                      <div style={{ fontWeight: 600, fontSize: '13px', color: rateCardForm.card_type === t.key ? 'var(--rose)' : 'var(--dark)' }}>{t.label}</div>
                      <div style={{ fontSize: '11px', color: 'var(--gray)', marginTop: '2px' }}>{t.desc}</div>
                    </div>
                  ))}
                </div>

                {/* Common fields */}
                <div className="form-group"><label>{rateCardForm.card_type === 'single' ? 'Item Name *' : 'Package Name *'}</label><input value={rateCardForm.title} onChange={e => setRateCardForm({...rateCardForm, title: e.target.value})} placeholder={rateCardForm.card_type === 'single' ? 'e.g., Normal Plate' : 'e.g., Wedding Catering Package'} /></div>
                <div className="form-group"><label>Description</label><input value={rateCardForm.description} onChange={e => setRateCardForm({...rateCardForm, description: e.target.value})} placeholder="Brief description" /></div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                  <div className="form-group"><label>Category</label>
                    <select value={rateCardForm.category} onChange={e => setRateCardForm({...rateCardForm, category: e.target.value})}>
                      <option value="">Select</option>
                      {CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
                    </select>
                  </div>
                  {rateCardForm.card_type === 'single' && (
                    <div className="form-group"><label>Unit</label>
                      <select value={rateCardForm.unit} onChange={e => setRateCardForm({...rateCardForm, unit: e.target.value})}>
                        <option value="per event">per event</option>
                        <option value="per person">per person</option>
                        <option value="per hour">per hour</option>
                        <option value="per day">per day</option>
                        <option value="per item">per item</option>
                        <option value="package">package</option>
                      </select>
                    </div>
                  )}
                </div>

                {/* SINGLE ITEM: image + price */}
                {rateCardForm.card_type === 'single' && (
                  <div style={{ display: 'flex', gap: '16px', marginTop: '8px', alignItems: 'flex-start' }}>
                    <label style={{ width: '100px', height: '100px', borderRadius: '10px', border: '2px dashed var(--cream-dark)', background: rateCardForm.image_url ? 'none' : 'var(--cream)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', flexShrink: 0, overflow: 'hidden' }}>
                      {rateCardForm.image_url ? (
                        <img src={rateCardForm.image_url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }} />
                      ) : (
                        <div style={{ textAlign: 'center', color: 'var(--gray)' }}><FiImage size={22} /><div style={{ fontSize: '9px', marginTop: '4px' }}>Add Photo</div></div>
                      )}
                      <input type="file" accept="image/*" onChange={e => { if (e.target.files[0]) uploadRateCardMainImage(e.target.files[0]); }} style={{ display: 'none' }} />
                    </label>
                    <div style={{ flex: 1 }}>
                      <div className="form-group"><label>Price (R) *</label><input type="number" value={rateCardForm.price} onChange={e => setRateCardForm({...rateCardForm, price: e.target.value})} placeholder="e.g., 45" style={{ fontSize: '16px', fontWeight: 600 }} /></div>
                    </div>
                  </div>
                )}

                {/* PACKAGE: multiple items */}
                {rateCardForm.card_type === 'package' && (
                  <div style={{ marginTop: '8px' }}>
                    <label style={{ fontSize: '13px', fontWeight: 600, color: 'var(--dark)', marginBottom: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span>Package Items</span>
                      <button className="btn btn-sm btn-secondary" onClick={() => setRateCardForm({...rateCardForm, items: [...rateCardForm.items, { service_name: '', description: '', price: '', unit: 'per event', image_url: '' }]})} style={{ fontSize: '12px' }}><FiPlus size={12} /> Add Item</button>
                    </label>
                    <div style={{ display: 'grid', gap: '10px' }}>
                      {rateCardForm.items.map((item, idx) => (
                        <div key={idx} style={{ display: 'flex', gap: '10px', padding: '12px', background: 'var(--cream)', borderRadius: '10px', alignItems: 'flex-start' }}>
                          <label style={{ width: '70px', height: '70px', borderRadius: '8px', border: '2px dashed var(--cream-dark)', background: item.image_url ? 'none' : 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', flexShrink: 0, overflow: 'hidden' }}>
                            {item.image_url ? (
                              <img src={item.image_url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '6px' }} />
                            ) : (
                              <div style={{ textAlign: 'center', color: 'var(--gray)' }}><FiImage size={16} /><div style={{ fontSize: '8px', marginTop: '2px' }}>Photo</div></div>
                            )}
                            <input type="file" accept="image/*" onChange={e => { if (e.target.files[0]) uploadRateCardImage(e.target.files[0], idx); }} style={{ display: 'none' }} />
                          </label>
                          <div style={{ flex: 1, display: 'grid', gap: '6px' }}>
                            <input value={item.service_name} onChange={e => { const items = [...rateCardForm.items]; items[idx].service_name = e.target.value; setRateCardForm({...rateCardForm, items}); }} placeholder="Item name *" style={{ fontSize: '13px', fontWeight: 500 }} />
                            <input value={item.description} onChange={e => { const items = [...rateCardForm.items]; items[idx].description = e.target.value; setRateCardForm({...rateCardForm, items}); }} placeholder="Description" style={{ fontSize: '12px' }} />
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px' }}>
                              <input type="number" value={item.price} onChange={e => { const items = [...rateCardForm.items]; items[idx].price = e.target.value; setRateCardForm({...rateCardForm, items}); }} placeholder="Price (R) *" style={{ fontSize: '12px' }} />
                              <select value={item.unit} onChange={e => { const items = [...rateCardForm.items]; items[idx].unit = e.target.value; setRateCardForm({...rateCardForm, items}); }} style={{ fontSize: '12px' }}>
                                <option value="per event">per event</option><option value="per person">per person</option><option value="per hour">per hour</option><option value="per day">per day</option><option value="per item">per item</option><option value="package">package</option>
                              </select>
                            </div>
                          </div>
                          {rateCardForm.items.length > 1 && (
                            <button onClick={() => { const items = rateCardForm.items.filter((_, i) => i !== idx); setRateCardForm({...rateCardForm, items}); }} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--red)', padding: '4px' }}><FiTrash2 size={13} /></button>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Delivery Fee Section */}
                <div style={{ marginTop: '16px', padding: '14px', background: 'var(--cream)', borderRadius: '10px' }}>
                  <label style={{ fontSize: '13px', fontWeight: 600, color: 'var(--dark)', marginBottom: '10px', display: 'block' }}><FiTruck size={14} style={{ marginRight: '6px', verticalAlign: 'middle' }} /> Delivery Option</label>
                  <div style={{ display: 'flex', gap: '8px', marginBottom: '10px', flexWrap: 'wrap' }}>
                    {[{ key: 'free', label: 'Free Delivery', desc: 'No extra charge' }, { key: 'flat_fee', label: 'Flat Fee', desc: 'Fixed delivery charge' }, { key: 'come_to_provider', label: 'Come to Provider', desc: 'Host travels to you' }].map(opt => (
                      <div key={opt.key} onClick={() => setRateCardForm({ ...rateCardForm, delivery_type: opt.key })}
                        style={{ flex: '1 1 100px', minWidth: '100px', padding: '10px', borderRadius: '8px', border: `2px solid ${rateCardForm.delivery_type === opt.key ? 'var(--rose)' : 'var(--cream-dark)'}`, cursor: 'pointer', background: rateCardForm.delivery_type === opt.key ? 'var(--rose-light)' : 'white', transition: 'all 0.15s', textAlign: 'center' }}>
                        <div style={{ fontWeight: 600, fontSize: '11px', color: rateCardForm.delivery_type === opt.key ? 'var(--rose)' : 'var(--dark)' }}>{opt.label}</div>
                        <div style={{ fontSize: '10px', color: 'var(--gray)', marginTop: '2px' }}>{opt.desc}</div>
                      </div>
                    ))}
                  </div>
                  {rateCardForm.delivery_type === 'flat_fee' && (
                    <div className="form-group" style={{ marginBottom: 0 }}>
                      <label style={{ fontSize: '12px' }}>Delivery Fee (R)</label>
                      <input type="number" value={rateCardForm.delivery_fee} onChange={e => setRateCardForm({ ...rateCardForm, delivery_fee: e.target.value })} placeholder="e.g., 150" style={{ fontSize: '13px' }} />
                    </div>
                  )}
                </div>

                {/* Booking Fee Section */}
                <div style={{ marginTop: '16px', padding: '14px', background: 'var(--cream)', borderRadius: '10px' }}>
                  <label style={{ fontSize: '13px', fontWeight: 600, color: 'var(--dark)', marginBottom: '6px', display: 'block' }}><CoinIcon size={14} style={{ marginRight: '6px', verticalAlign: 'middle' }} /> Booking Fee (Optional)</label>
                  <p style={{ fontSize: '11px', color: 'var(--gray)', marginBottom: '10px' }}>A platform or service fee added on top of the rate card price. Displayed to hosts before they book.</p>
                  <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                    <div className="form-group" style={{ flex: '1 1 140px', marginBottom: 0 }}>
                      <label style={{ fontSize: '12px' }}>Fee Amount (R)</label>
                      <input type="number" value={rateCardForm.booking_fee} onChange={e => setRateCardForm({ ...rateCardForm, booking_fee: e.target.value })} placeholder="e.g., 150" style={{ fontSize: '13px' }} />
                    </div>
                    <div className="form-group" style={{ flex: '2 1 280px', marginBottom: 0 }}>
                      <label style={{ fontSize: '12px' }}>Description (optional)</label>
                      <input type="text" value={rateCardForm.booking_fee_description} onChange={e => setRateCardForm({ ...rateCardForm, booking_fee_description: e.target.value })} placeholder="e.g., Service fee" style={{ fontSize: '13px' }} />
                    </div>
                  </div>
                </div>

                <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
                  <button className="btn btn-secondary" onClick={() => { setShowRateCardForm(false); setEditingRateCard(null); }}>Cancel</button>
                  <button className="btn btn-primary" onClick={saveRateCard} disabled={savingRateCard}>
                    <FiSave /> {savingRateCard ? 'Saving...' : (editingRateCard ? 'Update' : 'Create')} Rate Card
                  </button>
                </div>
              </div>
            )}

            {/* Rate Cards List */}
            {rateCards.length === 0 && !showRateCardForm ? (
              <div className="card" style={{ textAlign: 'center', padding: '60px' }}>
                <FiCreditCard size={48} style={{ color: 'var(--gray)', marginBottom: '16px', opacity: 0.3 }} />
                <h3 style={{ marginBottom: '8px' }}>No Rate Cards Yet</h3>
                <p style={{ color: 'var(--gray)', marginBottom: '24px', fontSize: '14px' }}>Create rate cards with your services and pricing to quickly share with clients during chats.</p>
                <button className="btn btn-primary" onClick={() => { setShowRateCardForm(true); setRateCardForm(defaultRateCardForm); }}><FiPlus /> Create Your First Rate Card</button>
              </div>
            ) : (
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '14px' }}>
                {rateCards.map(card => {
                  const isSingle = card.card_type === 'single' || (!card.card_type && (!card.items || card.items.length === 0));
                  return isSingle ? (
                    /* ── SINGLE ITEM CARD ── compact inline card */
                    <div key={card.id} className="card" style={{ padding: '0', overflow: 'hidden', width: '200px', flexShrink: 0 }}>
                      {card.image_url ? (
                        <div style={{ width: '100%', height: '130px', overflow: 'hidden', background: 'var(--cream)' }}>
                          <img src={card.image_url} alt={card.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        </div>
                      ) : (
                        <div style={{ width: '100%', height: '50px', background: 'linear-gradient(135deg, var(--dark), #2a2a2e)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <FiCreditCard size={16} style={{ color: 'rgba(255,255,255,0.3)' }} />
                        </div>
                      )}
                      <div style={{ padding: '12px' }}>
                        <div style={{ fontWeight: 600, fontSize: '14px', marginBottom: '2px', color: 'var(--dark)' }}>{card.title}</div>
                        {card.description && <div style={{ fontSize: '11px', color: 'var(--gray)', lineHeight: '1.3', marginBottom: '6px', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{card.description}</div>}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <div style={{ fontWeight: 700, fontSize: '17px', color: 'var(--rose)' }}>R{Number(card.price || 0).toLocaleString()}</div>
                          <div style={{ fontSize: '10px', color: 'var(--gray)', background: 'var(--cream)', padding: '2px 6px', borderRadius: '4px' }}>{card.unit || 'per item'}</div>
                        </div>
                        {card.category && <div style={{ fontSize: '10px', color: 'var(--gray)', marginTop: '6px' }}>{card.category}</div>}
                      </div>
                      <div style={{ padding: '8px 12px', borderTop: '1px solid var(--cream)', display: 'flex', gap: '6px', justifyContent: 'flex-end' }}>
                        <button onClick={() => editRateCard(card)} style={{ background: 'none', border: '1px solid var(--cream-dark)', borderRadius: '6px', padding: '4px 10px', cursor: 'pointer', fontSize: '11px', color: 'var(--gray)', display: 'flex', alignItems: 'center', gap: '3px' }}><FiEdit size={11} /> Edit</button>
                        <button onClick={() => deleteRateCard(card.id)} style={{ background: 'none', border: '1px solid var(--cream-dark)', borderRadius: '6px', padding: '4px 8px', cursor: 'pointer', color: 'var(--gray)' }}><FiTrash2 size={11} /></button>
                      </div>
                    </div>
                  ) : (
                    /* ── PACKAGE CARD ── wider card with items */
                    <div key={card.id} className="card" style={{ padding: '0', overflow: 'hidden', width: '100%' }}>
                      <div style={{ padding: '12px 16px', background: 'linear-gradient(135deg, var(--dark), #2a2a2e)', color: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          {profile.logo_url ? (
                            <img src={profile.logo_url} alt="" style={{ width: '28px', height: '28px', borderRadius: '6px', objectFit: 'cover' }} />
                          ) : (
                            <div style={{ width: '28px', height: '28px', borderRadius: '6px', background: 'rgba(255,255,255,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', fontWeight: 700 }}>{(profile.business_name || 'V')[0]}</div>
                          )}
                          <div>
                            <div style={{ fontWeight: 600, fontSize: '14px' }}>{card.title}</div>
                            <div style={{ fontSize: '10px', opacity: 0.7 }}>{card.items?.length || 0} items{card.category ? ` · ${card.category}` : ''}</div>
                          </div>
                        </div>
                        <div style={{ display: 'flex', gap: '6px' }}>
                          <button onClick={() => editRateCard(card)} style={{ background: 'rgba(255,255,255,0.15)', border: 'none', borderRadius: '6px', padding: '5px 10px', cursor: 'pointer', color: 'white', fontSize: '11px', display: 'flex', alignItems: 'center', gap: '3px' }}><FiEdit size={11} /> Edit</button>
                          <button onClick={() => deleteRateCard(card.id)} style={{ background: 'rgba(255,255,255,0.1)', border: 'none', borderRadius: '6px', padding: '5px 8px', cursor: 'pointer', color: 'rgba(255,255,255,0.7)' }}><FiTrash2 size={11} /></button>
                        </div>
                      </div>
                      {card.description && <div style={{ padding: '8px 16px', fontSize: '12px', color: 'var(--gray)', borderBottom: '1px solid var(--cream)' }}>{card.description}</div>}
                      <div style={{ padding: '10px', display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                        {card.items?.map((item, i) => (
                          <div key={i} style={{ borderRadius: '8px', border: '1px solid var(--cream-dark)', overflow: 'hidden', background: 'var(--white)', width: '150px', flexShrink: 0 }}>
                            {item.image_url ? (
                              <div style={{ width: '100%', height: '90px', overflow: 'hidden', background: 'var(--cream)' }}>
                                <img src={item.image_url} alt={item.service_name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                              </div>
                            ) : (
                              <div style={{ width: '100%', height: '36px', background: 'var(--cream)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <FiImage size={14} style={{ color: 'var(--gray)', opacity: 0.3 }} />
                              </div>
                            )}
                            <div style={{ padding: '8px' }}>
                              <div style={{ fontWeight: 600, fontSize: '12px', color: 'var(--dark)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.service_name}</div>
                              {item.description && <div style={{ fontSize: '10px', color: 'var(--gray)', lineHeight: '1.2', display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical', overflow: 'hidden', marginTop: '1px' }}>{item.description}</div>}
                              <div style={{ fontWeight: 700, fontSize: '14px', color: 'var(--rose)', marginTop: '4px' }}>R{Number(item.price).toLocaleString()}</div>
                            </div>
                          </div>
                        ))}
                      </div>
                      {card.items?.length > 1 && (
                        <div style={{ padding: '8px 16px', background: 'var(--cream)', display: 'flex', justifyContent: 'space-between', fontWeight: 600, fontSize: '13px', borderTop: '1px solid var(--cream-dark)' }}>
                          <span>Total ({card.items.length} items)</span>
                          <span style={{ color: 'var(--rose)' }}>R{card.items.reduce((a, it) => a + Number(it.price || 0), 0).toLocaleString()}</span>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}

        {/* ═══ QUOTATION MODAL ═══ */}
        {showQuotationModal && (
          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }} onClick={(e) => { if (e.target === e.currentTarget) setShowQuotationModal(false); }}>
            <div className="card" style={{ width: '100%', maxWidth: '600px', maxHeight: '90vh', overflow: 'auto', padding: '24px', borderRadius: '16px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h3 style={{ margin: 0 }}>Create Quotation</h3>
                <button onClick={() => setShowQuotationModal(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--gray)', fontSize: '20px' }}><FiX /></button>
              </div>
              <p style={{ fontSize: '13px', color: 'var(--gray)', marginBottom: '20px' }}>Create a custom quotation for this host with your own pricing and terms.</p>

              {/* Title */}
              <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, marginBottom: '4px' }}>Quotation Title *</label>
              <input value={quotationForm.title} onChange={e => setQuotationForm(prev => ({ ...prev, title: e.target.value }))} placeholder="e.g. Wedding Photography Package" style={{ width: '100%', padding: '10px 14px', borderRadius: '8px', border: '1px solid var(--cream-dark)', fontSize: '14px', marginBottom: '16px', boxSizing: 'border-box' }} />

              {/* Description */}
              <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, marginBottom: '4px' }}>Description</label>
              <textarea value={quotationForm.description} onChange={e => setQuotationForm(prev => ({ ...prev, description: e.target.value }))} placeholder="Describe the quotation..." rows={3} style={{ width: '100%', padding: '10px 14px', borderRadius: '8px', border: '1px solid var(--cream-dark)', fontSize: '14px', marginBottom: '16px', resize: 'vertical', boxSizing: 'border-box' }} />

              {/* Items */}
              <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, marginBottom: '8px' }}>Items *</label>
              {quotationForm.items.map((item, i) => (
                <div key={i} style={{ display: 'flex', gap: '8px', marginBottom: '8px', flexWrap: 'wrap', alignItems: 'flex-end', padding: '12px', background: 'var(--cream)', borderRadius: '8px' }}>
                  <div style={{ flex: '2', minWidth: '100px' }}>
                    <div style={{ fontSize: '11px', color: 'var(--gray)', marginBottom: '2px' }}>Service</div>
                    <input value={item.service_name} onChange={e => { const items = [...quotationForm.items]; items[i].service_name = e.target.value; setQuotationForm(prev => ({ ...prev, items })); }} placeholder="e.g. Full-day coverage" style={{ width: '100%', padding: '8px 10px', borderRadius: '6px', border: '1px solid var(--cream-dark)', fontSize: '13px', boxSizing: 'border-box' }} />
                  </div>
                  <div style={{ flex: '1', minWidth: '60px' }}>
                    <div style={{ fontSize: '11px', color: 'var(--gray)', marginBottom: '2px' }}>Price (R)</div>
                    <input value={item.price} onChange={e => { const items = [...quotationForm.items]; items[i].price = e.target.value; setQuotationForm(prev => ({ ...prev, items })); }} type="number" placeholder="0" style={{ width: '100%', padding: '8px 10px', borderRadius: '6px', border: '1px solid var(--cream-dark)', fontSize: '13px', boxSizing: 'border-box' }} />
                  </div>
                  <div style={{ flex: '1', minWidth: '80px' }}>
                    <div style={{ fontSize: '11px', color: 'var(--gray)', marginBottom: '2px' }}>Unit</div>
                    <select value={item.unit} onChange={e => { const items = [...quotationForm.items]; items[i].unit = e.target.value; setQuotationForm(prev => ({ ...prev, items })); }} style={{ width: '100%', padding: '8px 10px', borderRadius: '6px', border: '1px solid var(--cream-dark)', fontSize: '13px', boxSizing: 'border-box' }}>
                      <option>per event</option><option>per hour</option><option>per person</option><option>per day</option><option>flat rate</option>
                    </select>
                  </div>
                  <button onClick={() => { const items = [...quotationForm.items]; items.splice(i, 1); setQuotationForm(prev => ({ ...prev, items: items.length ? items : [{ service_name: '', description: '', price: '', unit: 'per event' }] })); }} title="Remove item" style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--red)', padding: '4px', flexShrink: 0 }}><FiTrash2 size={14} /></button>
                </div>
              ))}
              <button onClick={() => setQuotationForm(prev => ({ ...prev, items: [...prev.items, { service_name: '', description: '', price: '', unit: 'per event' }] }))} style={{ background: 'none', border: '1px dashed var(--cream-dark)', borderRadius: '8px', padding: '8px', cursor: 'pointer', fontSize: '13px', color: 'var(--gray)', width: '100%', marginBottom: '16px' }}>+ Add Item</button>

              {/* Delivery */}
              <div style={{ display: 'flex', gap: '12px', marginBottom: '16px', flexWrap: 'wrap' }}>
                <div style={{ flex: '1', minWidth: '140px' }}>
                  <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, marginBottom: '4px' }}>Delivery</label>
                  <select value={quotationForm.delivery_type} onChange={e => setQuotationForm(prev => ({ ...prev, delivery_type: e.target.value }))} style={{ width: '100%', padding: '10px 14px', borderRadius: '8px', border: '1px solid var(--cream-dark)', fontSize: '14px', boxSizing: 'border-box' }}>
                    <option value="free">Free Delivery</option>
                    <option value="paid">Paid Delivery</option>
                    <option value="not_applicable">Not Applicable</option>
                  </select>
                </div>
                {quotationForm.delivery_type === 'paid' && (
                  <div style={{ flex: '1', minWidth: '100px' }}>
                    <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, marginBottom: '4px' }}>Delivery Fee (R)</label>
                    <input value={quotationForm.delivery_fee} onChange={e => setQuotationForm(prev => ({ ...prev, delivery_fee: e.target.value }))} type="number" placeholder="0" style={{ width: '100%', padding: '10px 14px', borderRadius: '8px', border: '1px solid var(--cream-dark)', fontSize: '14px', boxSizing: 'border-box' }} />
                  </div>
                )}
              </div>

              {/* Booking fee */}
              <div style={{ display: 'flex', gap: '12px', marginBottom: '16px', flexWrap: 'wrap' }}>
                <div style={{ flex: '1', minWidth: '100px' }}>
                  <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, marginBottom: '4px' }}>Booking Fee (R)</label>
                  <input value={quotationForm.booking_fee} onChange={e => setQuotationForm(prev => ({ ...prev, booking_fee: e.target.value }))} type="number" placeholder="0" style={{ width: '100%', padding: '10px 14px', borderRadius: '8px', border: '1px solid var(--cream-dark)', fontSize: '14px', boxSizing: 'border-box' }} />
                </div>
                <div style={{ flex: '2', minWidth: '180px' }}>
                  <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, marginBottom: '4px' }}>Booking Fee Description</label>
                  <input value={quotationForm.booking_fee_description} onChange={e => setQuotationForm(prev => ({ ...prev, booking_fee_description: e.target.value }))} placeholder="e.g. 50% deposit required" style={{ width: '100%', padding: '10px 14px', borderRadius: '8px', border: '1px solid var(--cream-dark)', fontSize: '14px', boxSizing: 'border-box' }} />
                </div>
              </div>

              {/* Expiry date */}
              <div style={{ marginBottom: '16px' }}>
                <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, marginBottom: '4px' }}>Expiry Date</label>
                <input type="date" value={quotationForm.expiry_date} onChange={e => setQuotationForm(prev => ({ ...prev, expiry_date: e.target.value }))} style={{ width: '100%', padding: '10px 14px', borderRadius: '8px', border: '1px solid var(--cream-dark)', fontSize: '14px', boxSizing: 'border-box' }} />
              </div>

              {/* Notes */}
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, marginBottom: '4px' }}>Notes</label>
                <textarea value={quotationForm.notes} onChange={e => setQuotationForm(prev => ({ ...prev, notes: e.target.value }))} placeholder="Any additional notes..." rows={2} style={{ width: '100%', padding: '10px 14px', borderRadius: '8px', border: '1px solid var(--cream-dark)', fontSize: '14px', resize: 'vertical', boxSizing: 'border-box' }} />
              </div>

              <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                <button onClick={() => setShowQuotationModal(false)} className="btn btn-secondary btn-sm">Cancel</button>
                <button onClick={saveQuotation} disabled={savingQuotation} className="btn btn-primary btn-sm" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  {savingQuotation ? 'Sending...' : <><FiSend size={14} /> Send Quotation</>}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ═══ WALLET ═══ */}
        {tab === 'wallet' && (
          <div>
            <div className="card" style={{ padding: '32px', marginBottom: '20px', background: 'linear-gradient(135deg, var(--dark), #2a2a2e)', color: 'white', borderRadius: '16px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ fontSize: '14px', opacity: 0.6, marginBottom: '4px' }}>Available Balance</div>
                {walletMeta.is_founding_vendor && <span style={{ background: 'linear-gradient(135deg, #F59E0B, #D97706)', color: '#fff', padding: '4px 12px', borderRadius: '20px', fontSize: '11px', fontWeight: 700, letterSpacing: '0.5px' }}>FOUNDING VENDOR</span>}
              </div>
              <div style={{ fontSize: '40px', fontWeight: 700 }}>R{stats.walletBalance.toLocaleString()}</div>
              <div style={{ display: 'flex', gap: '24px', marginTop: '16px', fontSize: '13px', opacity: 0.6, flexWrap: 'wrap' }}>
                <span>Total Earned: R{Number(wallet?.total_earned || 0).toLocaleString()}</span>
                <span>Total Withdrawn: R{Number(wallet?.total_withdrawn || 0).toLocaleString()}</span>
                <span>Commission: {walletMeta.in_free_zone ? '0% (Free Zone)' : walletMeta.plan === 'premium' ? '0%' : walletMeta.plan === 'pro' ? '3%' : '8%'}</span>
              </div>
              {/* Free threshold progress in wallet */}
              {walletMeta.in_free_zone && (
                <div style={{ marginTop: '20px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', opacity: 0.7, marginBottom: '6px' }}>
                    <span>Commission-free earnings</span>
                    <span>R{Number(walletMeta.gross_earnings || 0).toLocaleString()} / R{Number(walletMeta.free_threshold || 5000).toLocaleString()}</span>
                  </div>
                  <div style={{ background: 'rgba(255,255,255,0.15)', borderRadius: '6px', height: '8px', overflow: 'hidden' }}>
                    <div style={{ background: '#10B981', height: '100%', borderRadius: '6px', width: `${Math.min(100, ((walletMeta.gross_earnings || 0) / (walletMeta.free_threshold || 5000)) * 100)}%`, transition: 'width 0.5s ease' }} />
                  </div>
                  <div style={{ fontSize: '11px', opacity: 0.5, marginTop: '4px' }}>R{Number(walletMeta.free_remaining || 5000).toLocaleString()} remaining before 8% commission applies</div>
                </div>
              )}
              {stats.walletBalance > 0 && banking && (
                <div style={{ marginTop: '20px', display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
                  <input type="number" value={withdrawAmount} onChange={e => setWithdrawAmount(e.target.value)} placeholder="Amount (R)" style={{ padding: '10px 16px', borderRadius: '10px', border: 'none', width: '160px', fontSize: '14px' }} />
                  <button className="btn btn-sm" style={{ background: kycStatus === 'approved' && savedIdNumber ? 'var(--rose)' : 'var(--gray)', color: 'white' }} onClick={requestWithdrawal} disabled={!withdrawAmount || Number(withdrawAmount) <= 0 || kycStatus !== 'approved' || !savedIdNumber}>
                    {kycStatus !== 'approved' ? 'Verify ID to Withdraw' : !savedIdNumber ? 'Enter ID Number to Withdraw' : 'Withdraw'}
                  </button>
                  {kycStatus !== 'approved' && <span style={{ fontSize: '11px', opacity: 0.5 }}>ID document verification required for withdrawals</span>}
                  {kycStatus === 'approved' && !savedIdNumber && <span style={{ fontSize: '11px', opacity: 0.5 }}>SA ID number required — enter it below</span>}
                </div>
              )}
              {/* ID Verification */}
              {savedIdNumber ? (
                <div style={{ marginTop: '16px', padding: '10px 14px', background: 'rgba(16,185,129,0.1)', border: '1px solid rgba(16,185,129,0.2)', borderRadius: '10px', display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px' }}>
                  <FiCheck size={16} style={{ color: '#10B981' }} />
                  <span style={{ color: '#10B981', fontWeight: 600 }}>ID Verified</span>
                  <span style={{ opacity: 0.6 }}>****{savedIdNumber.slice(-4)}</span>
                </div>
              ) : (
                <div style={{ marginTop: '16px', padding: '14px', background: 'rgba(255,255,255,0.04)', borderRadius: '10px' }}>
                  <div style={{ fontSize: '13px', opacity: 0.7, marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <FiShield size={14} /> SA ID verification required for withdrawals
                  </div>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <input
                      type="text"
                      value={idNumber}
                      onChange={e => setIdNumber(e.target.value.replace(/\D/g, '').slice(0, 13))}
                      placeholder="Enter 13-digit SA ID number"
                      maxLength={13}
                      style={{ flex: 1, padding: '8px 12px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.1)', background: 'rgba(255,255,255,0.05)', color: '#fff', fontSize: '13px' }}
                    />
                    <button
                      onClick={saveIdNumber}
                      disabled={idNumber.length !== 13 || savingIdNumber}
                      style={{
                        padding: '8px 16px', borderRadius: '8px', border: 'none',
                        background: idNumber.length === 13 ? '#10B981' : 'rgba(255,255,255,0.1)',
                        color: idNumber.length === 13 ? '#fff' : 'var(--gray)',
                        fontSize: '13px', fontWeight: 600, cursor: idNumber.length === 13 ? 'pointer' : 'not-allowed',
                        whiteSpace: 'nowrap'
                      }}>
                      {savingIdNumber ? 'Verifying...' : 'Verify'}
                    </button>
                  </div>
                </div>
              )}
              {!banking && <p style={{ marginTop: '16px', fontSize: '13px', opacity: 0.7 }}>Add banking details to enable withdrawals <FiArrowRight style={{ verticalAlign: 'middle' }} /></p>}
            </div>

            {/* ═══ KYC DOCUMENT VERIFICATION ═══ */}
            <div className="card" style={{ padding: '24px', marginBottom: '20px', borderRadius: '16px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 700 }}>ID Document Verification</h3>
                {kycStatus === 'approved' && (
                  <span style={{ background: 'linear-gradient(135deg, #10B981, #059669)', color: '#fff', padding: '4px 14px', borderRadius: '20px', fontSize: '12px', fontWeight: 700, display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <FiCheck size={14} /> Verified
                  </span>
                )}
                {kycStatus === 'pending' && (
                  <span style={{ background: 'linear-gradient(135deg, #F59E0B, #D97706)', color: '#fff', padding: '4px 14px', borderRadius: '20px', fontSize: '12px', fontWeight: 700 }}>Under Review</span>
                )}
                {kycStatus === 'rejected' && (
                  <span style={{ background: 'linear-gradient(135deg, var(--red), #DC2626)', color: '#fff', padding: '4px 14px', borderRadius: '20px', fontSize: '12px', fontWeight: 700 }}>Rejected</span>
                )}
              </div>

              {kycStatus === 'approved' ? (
                <div style={{ padding: '16px', background: 'rgba(16,185,129,0.08)', border: '1px solid rgba(16,185,129,0.2)', borderRadius: '12px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                    <FiCheck size={20} style={{ color: '#10B981' }} />
                    <span style={{ fontWeight: 600, color: '#10B981', fontSize: '15px' }}>Your identity has been verified</span>
                  </div>
                  <p style={{ margin: 0, fontSize: '13px', opacity: 0.7 }}>{savedIdNumber ? 'You can now withdraw earnings from your wallet.' : 'One more step: enter your SA ID number below to enable withdrawals.'}</p>
                </div>
              ) : kycStatus === 'pending' ? (
                <div style={{ padding: '16px', background: 'rgba(245,158,11,0.08)', border: '1px solid rgba(245,158,11,0.2)', borderRadius: '12px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                    <FiClock size={20} style={{ color: '#F59E0B' }} />
                    <span style={{ fontWeight: 600, color: '#F59E0B', fontSize: '15px' }}>Documents under review</span>
                  </div>
                  <p style={{ margin: 0, fontSize: '13px', opacity: 0.7 }}>Our team is reviewing your documents. This usually takes 24–48 hours. Withdrawals will be enabled once approved.</p>
                </div>
              ) : kycStatus === 'rejected' ? (
                <div>
                  <div style={{ padding: '16px', background: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.2)', borderRadius: '12px', marginBottom: '16px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                      <FiX size={20} style={{ color: 'var(--red)' }} />
                      <span style={{ fontWeight: 600, color: 'var(--red)', fontSize: '15px' }}>Verification rejected</span>
                    </div>
                    {kycRejectionReason && <p style={{ margin: '0 0 12px 0', fontSize: '13px', opacity: 0.8 }}>Reason: {kycRejectionReason}</p>}
                    <p style={{ margin: 0, fontSize: '13px', opacity: 0.7 }}>Please upload a clear, valid document and try again.</p>
                  </div>
                  {/* Re-upload form (same as 'none' state below) */}
                  <div style={{ fontSize: '13px', opacity: 0.7, marginBottom: '10px', fontWeight: 600 }}>Re-upload Documents</div>
                  <div style={{ marginBottom: '14px' }}>
                    <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, marginBottom: '6px' }}>Document Type</label>
                    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                      {[
                        { value: 'id_book', label: 'ID Book' },
                        { value: 'smart_id', label: 'Smart ID Card' },
                        { value: 'driver_license', label: "Driver's License" },
                        { value: 'business_cert', label: 'CIPC Certificate' },
                      ].map(opt => (
                        <button
                          key={opt.value}
                          onClick={() => setKycDocType(opt.value)}
                          style={{
                            padding: '8px 14px', borderRadius: '8px', border: kycDocType === opt.value ? '2px solid var(--rose)' : '1px solid rgba(255,255,255,0.1)',
                            background: kycDocType === opt.value ? 'rgba(227,66,92,0.15)' : 'rgba(255,255,255,0.05)',
                            color: kycDocType === opt.value ? 'var(--rose)' : 'var(--gray)', fontSize: '12px', fontWeight: 600, cursor: 'pointer'
                          }}>
                          {opt.label}
                        </button>
                      ))}
                    </div>
                  </div>
                  <div style={{ marginBottom: '14px' }}>
                    <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, marginBottom: '6px' }}>
                      Front of Document {kycDocType === 'business_cert' ? '(Certificate)' : kycDocType === 'driver_license' ? '(License Card)' : '(Photo Page)'} *
                    </label>
                    <input
                      type="file"
                      accept="image/png,image/jpeg,image/jpg,application/pdf"
                      onChange={e => setKycFrontFile(e.target.files[0])}
                      style={{ width: '100%', padding: '8px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.1)', background: 'rgba(255,255,255,0.05)', color: '#fff', fontSize: '13px' }}
                    />
                    {kycFrontFile && <div style={{ fontSize: '11px', color: '#10B981', marginTop: '4px' }}>Selected: {kycFrontFile.name}</div>}
                  </div>
                  {kycDocType === 'id_book' && (
                    <div style={{ marginBottom: '14px' }}>
                      <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, marginBottom: '6px' }}>Back of ID Book (optional)</label>
                      <input
                        type="file"
                        accept="image/png,image/jpeg,image/jpg,application/pdf"
                        onChange={e => setKycBackFile(e.target.files[0])}
                        style={{ width: '100%', padding: '8px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.1)', background: 'rgba(255,255,255,0.05)', color: '#fff', fontSize: '13px' }}
                      />
                      {kycBackFile && <div style={{ fontSize: '11px', color: '#10B981', marginTop: '4px' }}>Selected: {kycBackFile.name}</div>}
                    </div>
                  )}
                  <button
                    onClick={submitKycDocuments}
                    disabled={!kycFrontFile || uploadingKyc}
                    style={{
                      width: '100%', padding: '12px', borderRadius: '10px', border: 'none',
                      background: kycFrontFile ? 'var(--rose)' : 'rgba(255,255,255,0.1)',
                      color: kycFrontFile ? '#fff' : 'var(--gray)',
                      fontSize: '14px', fontWeight: 700, cursor: kycFrontFile ? 'pointer' : 'not-allowed'
                    }}>
                    {uploadingKyc ? 'Uploading...' : 'Submit Documents for Review'}
                  </button>
                </div>
              ) : (
                /* kycStatus === 'none' — show upload form */
                <div>
                  <p style={{ margin: '0 0 16px 0', fontSize: '13px', opacity: 0.7 }}>
                    To withdraw earnings, we need to verify your identity. Upload a clear photo or scan of your ID document, driver's license, or business registration certificate.
                  </p>
                  <div style={{ marginBottom: '14px' }}>
                    <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, marginBottom: '6px' }}>Document Type</label>
                    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                      {[
                        { value: 'id_book', label: 'ID Book' },
                        { value: 'smart_id', label: 'Smart ID Card' },
                        { value: 'driver_license', label: "Driver's License" },
                        { value: 'business_cert', label: 'CIPC Certificate' },
                      ].map(opt => (
                        <button
                          key={opt.value}
                          onClick={() => setKycDocType(opt.value)}
                          style={{
                            padding: '8px 14px', borderRadius: '8px', border: kycDocType === opt.value ? '2px solid var(--rose)' : '1px solid rgba(255,255,255,0.1)',
                            background: kycDocType === opt.value ? 'rgba(227,66,92,0.15)' : 'rgba(255,255,255,0.05)',
                            color: kycDocType === opt.value ? 'var(--rose)' : 'var(--gray)', fontSize: '12px', fontWeight: 600, cursor: 'pointer'
                          }}>
                          {opt.label}
                        </button>
                      ))}
                    </div>
                  </div>
                  <div style={{ marginBottom: '14px' }}>
                    <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, marginBottom: '6px' }}>
                      Front of Document {kycDocType !== 'business_cert' ? '(Photo Page)' : '(Certificate)'} *
                    </label>
                    <input
                      type="file"
                      accept="image/png,image/jpeg,image/jpg,application/pdf"
                      onChange={e => setKycFrontFile(e.target.files[0])}
                      style={{ width: '100%', padding: '8px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.1)', background: 'rgba(255,255,255,0.05)', color: '#fff', fontSize: '13px' }}
                    />
                    {kycFrontFile && <div style={{ fontSize: '11px', color: '#10B981', marginTop: '4px' }}>Selected: {kycFrontFile.name}</div>}
                  </div>
                  {kycDocType === 'id_book' && (
                    <div style={{ marginBottom: '14px' }}>
                      <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, marginBottom: '6px' }}>Back of ID Book (optional)</label>
                      <input
                        type="file"
                        accept="image/png,image/jpeg,image/jpg,application/pdf"
                        onChange={e => setKycBackFile(e.target.files[0])}
                        style={{ width: '100%', padding: '8px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.1)', background: 'rgba(255,255,255,0.05)', color: '#fff', fontSize: '13px' }}
                      />
                      {kycBackFile && <div style={{ fontSize: '11px', color: '#10B981', marginTop: '4px' }}>Selected: {kycBackFile.name}</div>}
                    </div>
                  )}
                  <button
                    onClick={submitKycDocuments}
                    disabled={!kycFrontFile || uploadingKyc}
                    style={{
                      width: '100%', padding: '12px', borderRadius: '10px', border: 'none',
                      background: kycFrontFile ? 'var(--rose)' : 'rgba(255,255,255,0.1)',
                      color: kycFrontFile ? '#fff' : 'var(--gray)',
                      fontSize: '14px', fontWeight: 700, cursor: kycFrontFile ? 'pointer' : 'not-allowed'
                    }}>
                    {uploadingKyc ? 'Uploading...' : 'Submit Documents for Review'}
                  </button>
                </div>
              )}
            </div>

            {/* ═══ LOYALTY PROGRAM ═══ */}
            <div className="card" style={{ padding: '24px', marginBottom: '20px', borderRadius: '16px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 700 }}>Loyalty Program</h3>
                {walletMeta.loyalty?.tier && (
                  <span style={{
                    background: walletMeta.loyalty.tier === 'platinum' ? 'linear-gradient(135deg, #94A3B8, #64748B)' :
                                 walletMeta.loyalty.tier === 'gold' ? 'linear-gradient(135deg, #F59E0B, #D97706)' :
                                 'linear-gradient(135deg, #9CA3AF, #6B7280)',
                    color: '#fff', padding: '4px 14px', borderRadius: '20px', fontSize: '12px', fontWeight: 700,
                    textTransform: 'uppercase', letterSpacing: '0.5px'
                  }}>{walletMeta.loyalty.tier} TIER</span>
                )}
              </div>

              {/* Points display */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px', marginBottom: '16px' }}>
                <div style={{ background: '#f8f8f8', padding: '14px', borderRadius: '10px', textAlign: 'center' }}>
                  <div style={{ fontSize: '24px', fontWeight: 700, color: 'var(--rose)' }}>{Number(walletMeta.loyalty?.total_points || 0).toLocaleString()}</div>
                  <div style={{ fontSize: '11px', color: 'var(--gray)' }}>Available Points</div>
                </div>
                <div style={{ background: '#f8f8f8', padding: '14px', borderRadius: '10px', textAlign: 'center' }}>
                  <div style={{ fontSize: '24px', fontWeight: 700 }}>{Number(walletMeta.loyalty?.lifetime_points || 0).toLocaleString()}</div>
                  <div style={{ fontSize: '11px', color: 'var(--gray)' }}>Lifetime Points</div>
                </div>
                <div style={{ background: '#f8f8f8', padding: '14px', borderRadius: '10px', textAlign: 'center' }}>
                  <div style={{ fontSize: '14px', fontWeight: 700, color: walletMeta.plan === 'premium' ? 'var(--rose)' : walletMeta.plan === 'pro' ? '#F59E0B' : 'var(--gray)' }}>
                    {walletMeta.plan === 'premium' ? '3x' : walletMeta.plan === 'pro' ? '2x' : '1x'} Multiplier
                  </div>
                  <div style={{ fontSize: '11px', color: 'var(--gray)' }}>Your {walletMeta.plan === 'free' ? 'Starter' : walletMeta.plan === 'pro' ? 'Pro' : walletMeta.plan === 'premium' ? 'Premium' : 'Starter'} Plan</div>
                </div>
              </div>

              {/* Tier progress */}
              {walletMeta.loyalty?.next_tier && (
                <div style={{ background: 'var(--rose-light)', padding: '14px 18px', borderRadius: '10px', marginBottom: '12px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', marginBottom: '6px' }}>
                    <span style={{ fontWeight: 600 }}>Next: <span style={{ color: 'var(--rose)' }}>{walletMeta.loyalty.next_tier.toUpperCase()}</span> Tier</span>
                    <span>{Number(walletMeta.loyalty.total_points || 0).toLocaleString()} / {Number((walletMeta.loyalty.total_points || 0) + (walletMeta.loyalty.next_tier_points || 0)).toLocaleString()} pts</span>
                  </div>
                  <div style={{ background: '#f0e0e3', borderRadius: '6px', height: '8px', overflow: 'hidden' }}>
                    <div style={{
                      background: 'linear-gradient(90deg, var(--rose), #F59E0B)',
                      height: '100%', borderRadius: '6px',
                      width: `${Math.min(100, Math.max(0, ((walletMeta.loyalty.total_points || 0) / (2500)) * 100))}%`,
                      transition: 'width 0.5s ease'
                    }} />
                  </div>
                </div>
              )}

              {/* Tier rewards */}
              <div style={{ display: 'grid', gap: '8px' }}>
                {[
                  { tier: 'silver', pts: 250, reward: 'R250 Platform Credit', earned: (walletMeta.loyalty?.total_points || 0) >= 250 },
                  { tier: 'gold', pts: 750, reward: 'Featured Listing + R500 Credit', earned: (walletMeta.loyalty?.total_points || 0) >= 750 },
                  { tier: 'platinum', pts: 2500, reward: 'Top Vendor Badge + R1,500 Voucher', earned: (walletMeta.loyalty?.total_points || 0) >= 2500 },
                ].map(r => (
                  <div key={r.tier} style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    padding: '10px 14px', borderRadius: '10px',
                    background: r.earned ? '#F0FDF4' : 'var(--cream)',
                    border: r.earned ? '1px solid #BBF7D0' : '1px solid #eee',
                    opacity: r.earned ? 1 : 0.6
                  }}>
                    <div>
                      <div style={{ fontWeight: 600, fontSize: '14px', textTransform: 'capitalize' }}>{r.tier}</div>
                      <div style={{ fontSize: '12px', color: 'var(--gray)' }}>{r.pts.toLocaleString()} pts — {r.reward}</div>
                    </div>
                    {r.earned && (
                      <button
                        className="btn btn-sm"
                        style={{ background: 'var(--rose)', color: 'white', borderRadius: '20px', padding: '6px 16px' }}
                        onClick={() => redeemLoyalty(r.tier)}
                      >Redeem</button>
                    )}
                    {walletMeta.loyalty?.tier === r.tier && !r.earned && (
                      <span style={{ fontSize: '11px', color: 'var(--rose)', fontWeight: 600 }}>CLAIMED</span>
                    )}
                  </div>
                ))}
              </div>
              <div style={{ fontSize: '11px', color: 'var(--gray)', marginTop: '10px', textAlign: 'center' }}>
                Earn 1 pt per R100 payout (x{walletMeta.plan === 'premium' ? '3' : walletMeta.plan === 'pro' ? '2' : '1'} with your plan). Points never expire.
              </div>
            </div>

            <h3 style={{ marginBottom: '16px' }}>Recent Transactions</h3>
            {transactions.length === 0 ? (
              <div className="card" style={{ textAlign: 'center', padding: '40px', color: 'var(--gray)' }}>No transactions yet</div>
            ) : (
              <div style={{ display: 'grid', gap: '8px' }}>
                {transactions.map(t => (
                  <div key={t.id} className="card" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 20px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      <div style={{
                        width: '36px', height: '36px', borderRadius: '50%',
                        background: t.type === 'credit' ? 'rgba(16,185,129,0.1)' : 'rgba(255,107,107,0.1)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0
                      }}>
                        {t.type === 'credit'
                          ? <FiArrowDown size={16} color="#10B981" />
                          : <FiArrowUp size={16} color="#FF6B6B" />
                        }
                      </div>
                      <div>
                        <div style={{ fontSize: '14px', fontWeight: 500 }}>{t.description}</div>
                        <div style={{ fontSize: '12px', color: 'var(--gray)' }}>{new Date(t.created_at).toLocaleDateString('en-ZA')}</div>
                      </div>
                    </div>
                    <div style={{ fontWeight: 600, color: t.type === 'credit' ? 'var(--green)' : 'var(--rose)' }}>
                      {t.type === 'credit' ? '+' : '-'}R{Number(t.amount).toLocaleString()}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* ═══ BANKING ═══ */}
        {tab === 'banking' && (
          <div style={{ maxWidth: '500px' }}>
            <h3 style={{ marginBottom: '20px' }}>Banking Details</h3>
            <div className="card" style={{ padding: '32px' }}>
              <div className="form-group"><label>Bank</label>
                <select value={bankForm.bank_name || ''} onChange={e => setBankForm({...bankForm, bank_name: e.target.value})}>
                  <option value="">Select bank</option>
                  {SA_BANKS.map(b => <option key={b} value={b}>{b}</option>)}
                </select>
              </div>
              <div className="form-group"><label>Account Holder Name</label><input value={bankForm.account_holder || ''} onChange={e => setBankForm({...bankForm, account_holder: e.target.value})} placeholder="As it appears on your account" /></div>
              <div className="form-group"><label>Account Number</label><input value={bankForm.account_number || ''} onChange={e => setBankForm({...bankForm, account_number: e.target.value})} placeholder="Your account number" /></div>
              <div className="vendor-form-2col" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                <div className="form-group"><label>Branch Code</label><input value={bankForm.branch_code || ''} onChange={e => setBankForm({...bankForm, branch_code: e.target.value})} placeholder="e.g., 250655" /></div>
                <div className="form-group"><label>Account Type</label>
                  <select value={bankForm.account_type || 'cheque'} onChange={e => setBankForm({...bankForm, account_type: e.target.value})}>
                    <option value="cheque">Cheque/Current</option>
                    <option value="savings">Savings</option>
                  </select>
                </div>
              </div>
              <button className="btn btn-primary btn-full" onClick={saveBanking} disabled={!bankForm.bank_name || !bankForm.account_holder || !bankForm.account_number} style={{ marginTop: '12px' }}><FiSave /> Save Banking Details</button>
              {banking && <p style={{ textAlign: 'center', marginTop: '12px', fontSize: '13px', color: 'var(--green)' }}><FiCheck style={{ verticalAlign: 'middle' }} /> Banking details on file</p>}
            </div>
          </div>
        )}

        {/* ═══ PROFILE ═══ */}
        {tab === 'profile' && (
          <div style={{ maxWidth: '600px' }}>
            {/* Logo Upload */}
            <div className="card" style={{ padding: '24px', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '20px' }}>
              <div style={{ position: 'relative' }}>
                {profile.logo_url ? (
                  <img src={profile.logo_url} alt="Logo" style={{ width: '80px', height: '80px', borderRadius: '14px', objectFit: 'cover', border: '2px solid var(--cream-dark)' }} />
                ) : (
                  <div style={{ width: '80px', height: '80px', borderRadius: '14px', background: 'linear-gradient(135deg, var(--dark), #2a2a2e)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '28px', fontWeight: 700 }}>{(profile.business_name || 'V')[0]}</div>
                )}
              </div>
              <div style={{ flex: 1 }}>
                <h4 style={{ fontSize: '15px', marginBottom: '4px' }}>Business Logo</h4>
                <p style={{ fontSize: '12px', color: 'var(--gray)', marginBottom: '10px' }}>Appears on your rate cards and profile. Square image recommended.</p>
                <label className="btn btn-sm btn-secondary" style={{ cursor: 'pointer' }}>
                  <FiUpload size={12} /> {profile.logo_url ? 'Change Logo' : 'Upload Logo'}
                  <input type="file" accept="image/*" onChange={e => { if (e.target.files[0]) uploadLogo(e.target.files[0]); }} style={{ display: 'none' }} />
                </label>
              </div>
            </div>

            {/* Business Gallery */}
            <div className="card" style={{ padding: '24px', marginBottom: '16px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                <div>
                  <h4 style={{ fontSize: '15px', marginBottom: '2px' }}>Business Gallery</h4>
                  <p style={{ fontSize: '12px', color: 'var(--gray)' }}>
                    Upload up to {maxGallery} photos of your work, products, or venue ({(profile.business_gallery || []).length}/{maxGallery})
                  </p>
                </div>
                {(profile.business_gallery || []).length < maxGallery && (
                  <label className="btn btn-sm btn-secondary" style={{ cursor: 'pointer' }}>
                    <FiPlus size={12} /> Add Image
                    <input type="file" accept="image/*" onChange={e => { if (e.target.files[0]) uploadGalleryImage(e.target.files[0]); e.target.value = ''; }} style={{ display: 'none' }} />
                  </label>
                )}
              </div>
              {(profile.business_gallery || []).length > 0 ? (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(100px, 1fr))', gap: '12px' }}>
                  {(profile.business_gallery || []).map((url, i) => (
                    <div key={i} style={{ position: 'relative', width: '100%', aspectRatio: '1', borderRadius: '12px', overflow: 'hidden', border: '2px solid var(--cream-dark)' }}>
                      <img src={url} alt={`Gallery ${i + 1}`} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                      <button
                        onClick={() => removeGalleryImage(i)}
                        style={{
                          position: 'absolute', top: '4px', right: '4px',
                          width: '24px', height: '24px', borderRadius: '50%',
                          background: 'rgba(220, 38, 38, 0.9)', color: 'white', border: 'none',
                          display: 'flex', alignItems: 'center', justifyContent: 'center',
                          cursor: 'pointer', fontSize: '12px', lineHeight: 1
                        }}
                        title="Remove image"
                      ><FiX size={12} /></button>
                    </div>
                  ))}
                </div>
              ) : (
                <div style={{ padding: '32px 0', textAlign: 'center', color: 'var(--gray)', fontSize: '13px' }}>
                  <FiImage size={32} style={{ marginBottom: '8px', opacity: 0.4 }} />
                  <p>No gallery images yet. Add photos of your work to showcase your business.</p>
                </div>
              )}
            </div>

          <div className="card" style={{ padding: '32px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
              <h3>Business Profile</h3>
              {!editing ? (
                <button className="btn btn-sm btn-secondary" onClick={() => setEditing(true)}><FiEdit /> Edit</button>
              ) : (
                <button className="btn btn-sm btn-primary" onClick={updateProfile}><FiSave /> Save</button>
              )}
            </div>
            <div className="form-group"><label>Business Name</label><input value={profile.business_name || ''} onChange={e => setProfile({...profile, business_name: e.target.value})} disabled={!editing} /></div>
            <div className="form-group"><label>Category</label>
              <select value={(profile.business_category || '').startsWith('Other:') ? 'Other' : (profile.business_category || '')} onChange={e => setProfile({...profile, business_category: e.target.value})} disabled={!editing}>
                <option value="">Select</option>
                {CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>
            {(profile.business_category === 'Other' || (profile.business_category || '').startsWith('Other:')) && (
              <div className="form-group"><label>Please specify your category</label><input value={(profile.business_category || '').startsWith('Other:') ? profile.business_category.replace('Other: ', '') : (profile.other_category || '')} onChange={e => setProfile({...profile, business_category: `Other: ${e.target.value}`})} disabled={!editing} placeholder="e.g., Cakes & Baking, Event Equipment Hire, Stationery, etc." /></div>
            )}
            <div className="form-group"><label>Full Business Address</label><input value={profile.business_address || ''} onChange={e => setProfile({...profile, business_address: e.target.value})} disabled={!editing} placeholder="e.g., 123 Main Road, Braamfontein, Johannesburg, 2001" />
              <span style={{ fontSize: '11px', color: 'var(--gray)', marginTop: '4px', display: 'block' }}>Full physical address for verification</span>
            </div>
            <div className="form-group"><label>City / Area</label><input value={profile.business_location || ''} onChange={e => setProfile({...profile, business_location: e.target.value})} disabled={!editing} placeholder="e.g., Johannesburg, Gauteng" /></div>
            <div className="form-group" style={{ position: 'relative' }}><label>Areas You Serve</label>
              {editing ? (
                <>
                  <div onClick={() => setProfile(p => ({...p, _areasOpen: !p._areasOpen}))} style={{ padding: '10px 14px', border: '1px solid var(--cream-dark)', borderRadius: '10px', background: 'var(--white)', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', minHeight: '42px' }}>
                    <span style={{ fontSize: '14px', color: profile.service_areas ? 'var(--dark)' : 'var(--gray)' }}>
                      {profile.service_areas ? `${(profile.service_areas).split(',').length} area${(profile.service_areas).split(',').length > 1 ? 's' : ''} selected` : 'Select areas you serve'}
                    </span>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--gray)" strokeWidth="2"><path d={profile._areasOpen ? "M18 15l-6-6-6 6" : "M6 9l6 6 6-6"} /></svg>
                  </div>
                  {profile._areasOpen && (
                    <div style={{ position: 'absolute', zIndex: 50, top: '100%', left: 0, right: 0, marginTop: '4px', background: 'var(--white)', border: '1px solid var(--cream-dark)', borderRadius: '12px', boxShadow: '0 8px 32px rgba(0,0,0,0.12)', maxHeight: '360px', overflowY: 'auto', paddingBottom: '4px' }}>
                      {Object.entries(CITY_AREAS).map(([cityName, cityData]) => {
                        const isExpanded = cityGroupsExpanded.has(cityName);
                        const allCityAreas = cityData.areas;
                        const selected = (profile.service_areas || '').split(',').map(s => s.trim()).filter(Boolean);
                        const selectedInCity = allCityAreas.filter(a => selected.includes(a));
                        const allSelected = selectedInCity.length === allCityAreas.length;
                        return (
                          <div key={cityName}>
                            <div onClick={() => {
                              const next = new Set(cityGroupsExpanded);
                              if (isExpanded) next.delete(cityName);
                              else next.add(cityName);
                              setCityGroupsExpanded(next);
                            }} style={{ padding: '10px 14px', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', borderBottom: '1px solid var(--cream-dark)', background: 'var(--cream)', position: 'sticky', top: 0, zIndex: 1 }}>
                              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="var(--gray)" strokeWidth="2" style={{ transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)', transition: 'transform 0.15s', flexShrink: 0 }}><path d="M9 18l6-6-6-6"/></svg>
                              <div onClick={e => { e.stopPropagation();
                                const current = (profile.service_areas || '').split(',').map(s => s.trim()).filter(Boolean).filter(a => a !== 'Nationwide');
                                const updated = allSelected ? current.filter(a => !allCityAreas.includes(a)) : [...current, ...allCityAreas];
                                setProfile(p => ({...p, service_areas: updated.join(', ')}));
                              }} style={{ width: '18px', height: '18px', borderRadius: '3px', border: allSelected ? '2px solid var(--rose)' : (selectedInCity.length > 0 ? '2px solid var(--rose)' : '2px solid var(--cream-dark)'), background: allSelected ? 'var(--rose)' : (selectedInCity.length > 0 ? 'rgba(227,66,92,0.5)' : 'white'), display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                {allSelected && <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3"><path d="M20 6L9 17l-5-5"/></svg>}
                                {!allSelected && selectedInCity.length > 0 && <span style={{ fontSize: '8px', color: 'white', fontWeight: 700, lineHeight: 1 }}>{selectedInCity.length}</span>}
                              </div>
                              <div style={{ flex: 1 }}>
                                <span style={{ fontSize: '13px', fontWeight: 600, color: 'var(--dark)' }}>{cityName}</span>
                                <span style={{ fontSize: '10px', color: 'var(--gray)', marginLeft: '4px' }}>{cityData.province}</span>
                              </div>
                              <span style={{ fontSize: '10px', color: 'var(--gray)' }}>{selectedInCity.length}/{allCityAreas.length}</span>
                            </div>
                            {isExpanded && allCityAreas.map(area => {
                              const isAreaSelected = selected.includes(area);
                              return (
                                <div key={area} onClick={() => {
                                  const current = (profile.service_areas || '').split(',').map(s => s.trim()).filter(Boolean);
                                  const withoutNationwide = current.filter(a => a !== 'Nationwide');
                                  const updated = isAreaSelected ? withoutNationwide.filter(a => a !== area) : [...withoutNationwide, area];
                                  setProfile(p => ({...p, service_areas: updated.join(', ')}));
                                }} style={{ padding: '7px 14px 7px 44px', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', borderBottom: '1px solid var(--cream)', background: isAreaSelected ? 'rgba(227,66,92,0.03)' : 'white' }}>
                                  <div style={{ width: '16px', height: '16px', borderRadius: '3px', border: isAreaSelected ? '2px solid var(--rose)' : '2px solid var(--cream-dark)', background: isAreaSelected ? 'var(--rose)' : 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                    {isAreaSelected && <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3"><path d="M20 6L9 17l-5-5"/></svg>}
                                  </div>
                                  <span style={{ fontSize: '13px', color: isAreaSelected ? 'var(--rose)' : 'var(--dark)', fontWeight: isAreaSelected ? 500 : 400 }}>{area}</span>
                                </div>
                              );
                            })}
                          </div>
                        );
                      })}
                      <div style={{ borderTop: '2px solid var(--cream-dark)', marginTop: '4px' }}>
                        {(() => {
                          const selected = (profile.service_areas || '').split(',').map(s => s.trim()).filter(Boolean);
                          const isNationwide = selected.includes('Nationwide');
                          return (
                            <div onClick={() => {
                              const current = (profile.service_areas || '').split(',').map(s => s.trim()).filter(Boolean);
                              setProfile(p => ({...p, service_areas: isNationwide ? '' : 'Nationwide'}));
                            }} style={{ padding: '10px 14px', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', background: isNationwide ? 'rgba(227,66,92,0.05)' : 'white' }}>
                              <div style={{ width: '18px', height: '18px', borderRadius: '3px', border: isNationwide ? '2px solid var(--rose)' : '2px solid var(--cream-dark)', background: isNationwide ? 'var(--rose)' : 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                {isNationwide && <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3"><path d="M20 6L9 17l-5-5"/></svg>}
                              </div>
                              <span style={{ fontSize: '13px', fontWeight: 600, color: isNationwide ? 'var(--rose)' : 'var(--dark)' }}>Nationwide</span>
                              <span style={{ fontSize: '10px', color: 'var(--gray)', marginLeft: 'auto' }}>All areas</span>
                            </div>
                          );
                        })()}
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <input value={profile.service_areas || '—'} disabled style={{ background: 'var(--gray-light)' }} />
              )}
              {profile.service_areas && (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginTop: '8px' }}>
                  {(profile.service_areas || '').split(',').map(s => s.trim()).filter(Boolean).map(area => (
                    <span key={area} style={{ padding: '3px 10px', borderRadius: '12px', background: 'rgba(227,66,92,0.08)', color: 'var(--rose)', fontSize: '11px', fontWeight: 500, display: 'flex', alignItems: 'center', gap: '4px' }}>
                      {area}
                      {editing && <span onClick={() => {
                        const updated = (profile.service_areas || '').split(',').map(s => s.trim()).filter(a => a !== area).join(', ');
                        setProfile({...profile, service_areas: updated});
                      }} style={{ cursor: 'pointer', fontWeight: 700, fontSize: '13px', lineHeight: 1 }}>&times;</span>}
                    </span>
                  ))}
                </div>
              )}
            </div>
            <div className="form-group"><label>Event Types You Serve</label>
              {editing ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 14px', border: '1px solid var(--cream-dark)', borderRadius: '10px', cursor: 'pointer', background: profile.serves_all_events !== false ? 'rgba(227,66,92,0.04)' : 'white' }}>
                    <input type="checkbox" checked={profile.serves_all_events !== false} onChange={e => setProfile({...profile, serves_all_events: e.target.checked, served_event_types: e.target.checked ? [] : (profile.served_event_types || [])})} style={{ accentColor: 'var(--rose)' }} />
                    <span style={{ fontSize: '14px', fontWeight: 600 }}>I serve ALL event types</span>
                    <span style={{ fontSize: '11px', color: 'var(--gray)' }}>— Your business will appear for every event category</span>
                  </label>
                  {profile.serves_all_events === false && (
                    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', padding: '4px 0' }}>
                      {EVENT_TYPES.map(et => {
                        const selected = (profile.served_event_types || []).includes(et);
                        return (
                          <button type="button" key={et} onClick={() => {
                            const current = profile.served_event_types || [];
                            const updated = selected ? current.filter(e => e !== et) : [...current, et];
                            setProfile({...profile, served_event_types: updated});
                          }} style={{
                            padding: '6px 14px', borderRadius: '20px', border: '1px solid',
                            borderColor: selected ? 'var(--rose)' : 'var(--cream-dark)',
                            background: selected ? 'var(--rose)' : 'white',
                            color: selected ? 'white' : 'var(--dark)',
                            cursor: 'pointer', fontSize: '12px', fontWeight: selected ? 600 : 400,
                            transition: 'all 0.15s'
                          }}>
                            {selected && '✓ '}{et}
                          </button>
                        );
                      })}
                    </div>
                  )}
                </div>
              ) : (
                <div style={{ padding: '10px 0', fontSize: '14px', color: 'var(--dark)' }}>
                  {(profile.served_event_types || []).length === 0 || profile.serves_all_events !== false
                    ? 'All event types'
                    : (profile.served_event_types || []).join(', ')}
                </div>
              )}
            </div>
            <div className="form-group"><label>Price Range</label>
              <select value={profile._customPrice ? 'Custom' : (PRICE_RANGES.filter(r => r !== 'Custom').includes(profile.business_price_range) ? profile.business_price_range : (profile.business_price_range ? 'Custom' : ''))} onChange={e => { if (e.target.value === 'Custom') { setProfile({...profile, _customPrice: true, business_price_range: profile.business_price_range && !PRICE_RANGES.filter(r => r !== 'Custom').includes(profile.business_price_range) ? profile.business_price_range : ''}); } else { setProfile({...profile, business_price_range: e.target.value, _customPrice: false}); } }} disabled={!editing}>
                <option value="">Select</option>
                {PRICE_RANGES.map(r => <option key={r} value={r}>{r}</option>)}
              </select>
            </div>
            {(profile._customPrice || (profile.business_price_range && !PRICE_RANGES.filter(r => r !== 'Custom').includes(profile.business_price_range))) && (
              <div className="form-group"><label>Enter your price range</label><input value={profile.business_price_range || ''} onChange={e => setProfile({...profile, business_price_range: e.target.value})} disabled={!editing} placeholder="e.g., R50 - R200 per item, R150 per hour" /></div>
            )}
            <div className="form-group">
              <label>Description</label>
              <textarea value={profile.business_description || ''} onChange={e => setProfile({...profile, business_description: e.target.value})} disabled={!editing} rows={4} />
              {editing && (
                <button type="button" onClick={async () => {
                  if (!profile.business_name || !profile.business_category) {
                    alert('Please fill in your Business Name and Category first.');
                    return;
                  }
                  setProfile(p => ({...p, _gigiLoading: true}));
                  try {
                    const res = await api.post('/ai/vendor-description', { business_name: profile.business_name, business_category: profile.business_category, business_location: profile.business_location, business_price_range: profile.business_price_range });
                    setProfile(p => ({...p, business_description: cleanAiText(res.data.description), _gigiLoading: false}));
                  } catch { setProfile(p => ({...p, _gigiLoading: false})); }
                }} disabled={profile._gigiLoading} style={{ marginTop: '10px', width: '100%', padding: '10px 16px', background: 'linear-gradient(135deg, var(--rose), var(--rose-deep))', color: 'white', border: 'none', borderRadius: '10px', fontSize: '13px', fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', opacity: profile._gigiLoading ? 0.6 : 1, transition: 'all 0.2s' }}>
                  ✨ {profile._gigiLoading ? 'Gigi is writing your description...' : 'AI Generate Description — Let Gigi write it for you'}
                </button>
              )}
              <span style={{ fontSize: '11px', color: 'var(--gray)', marginTop: '6px', display: 'block', textAlign: 'center' }}>Optional — Gigi will craft a professional description based on your business details. You can edit it afterwards.</span>
            </div>

            <div style={{ borderTop: '1px solid #eee', paddingTop: '20px', marginTop: '8px' }}>
              <label style={{ fontSize: '14px', fontWeight: 600, marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>Social Media & Online Presence</label>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                <div className="form-group"><label style={{ display: 'flex', alignItems: 'center', gap: '6px' }}><svg width="14" height="14" viewBox="0 0 24 24" fill="#1877F2"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg> Facebook</label><input value={profile.social_facebook || ''} onChange={e => setProfile({...profile, social_facebook: e.target.value})} disabled={!editing} placeholder="facebook.com/yourbusiness" /></div>
                <div className="form-group"><label style={{ display: 'flex', alignItems: 'center', gap: '6px' }}><svg width="14" height="14" viewBox="0 0 24 24" fill="#E4405F"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg> Instagram</label><input value={profile.social_instagram || ''} onChange={e => setProfile({...profile, social_instagram: e.target.value})} disabled={!editing} placeholder="instagram.com/yourbusiness" /></div>
                <div className="form-group"><label style={{ display: 'flex', alignItems: 'center', gap: '6px' }}><svg width="14" height="14" viewBox="0 0 24 24" fill="#000"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.27 6.27 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.34-6.34V8.69a8.16 8.16 0 004.77 1.52V6.79a4.85 4.85 0 01-1.01-.1z"/></svg> TikTok</label><input value={profile.social_tiktok || ''} onChange={e => setProfile({...profile, social_tiktok: e.target.value})} disabled={!editing} placeholder="tiktok.com/@yourbusiness" /></div>
                <div className="form-group"><label style={{ display: 'flex', alignItems: 'center', gap: '6px' }}><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--gray)" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg> Website</label><input value={profile.social_website || ''} onChange={e => setProfile({...profile, social_website: e.target.value})} disabled={!editing} placeholder="www.yourbusiness.co.za" /></div>
              </div>
            </div>
          </div>

            {/* Quick Deactivate Link */}
            <div style={{ marginTop: '20px', padding: '16px 20px', borderRadius: '12px', border: '1px solid rgba(220,38,38,0.15)', background: 'rgba(220,38,38,0.02)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <span style={{ fontSize: '13px', color: 'var(--gray)' }}>Want to close your account?</span>
              {!showDeactivate ? (
                <button onClick={() => setShowDeactivate(true)} style={{ background: 'none', border: 'none', color: '#DC2626', fontSize: '13px', fontWeight: 600, cursor: 'pointer', textDecoration: 'underline' }}>Deactivate Account</button>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%', marginTop: '8px' }}>
                  <input type="password" value={deactivateConfirm.password} onChange={e => setDeactivateConfirm({ ...deactivateConfirm, password: e.target.value })} placeholder="Enter password to confirm" style={{ padding: '8px 12px', borderRadius: '8px', border: '1px solid #FCA5A5', fontSize: '13px' }} />
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <button className="btn btn-sm" onClick={() => { setShowDeactivate(false); setDeactivateConfirm({ password: '', reason: '' }); }} style={{ flex: 1, background: 'var(--gray-light)', color: 'var(--gray)', border: 'none', fontSize: '12px' }}>Cancel</button>
                    <button className="btn btn-sm" onClick={deactivateAccount} disabled={!deactivateConfirm.password} style={{ flex: 1, background: '#DC2626', color: 'white', border: 'none', fontSize: '12px' }}>Deactivate</button>
                  </div>
                </div>
              )}
            </div>

          </div>
        )}

        {/* ═══ CALENDAR ═══ */}
        {tab === 'calendar' && (() => {
          const year = calMonth.getFullYear();
          const month = calMonth.getMonth();
          const firstDay = new Date(year, month, 1).getDay();
          const daysInMonth = new Date(year, month + 1, 0).getDate();
          const today = new Date();
          today.setHours(0,0,0,0);
          const days = [];
          for (let i = 0; i < firstDay; i++) days.push(null);
          for (let d = 1; d <= daysInMonth; d++) days.push(d);

          const getScheduleForDate = (d) => {
            const dateStr = `${year}-${String(month+1).padStart(2,'0')}-${String(d).padStart(2,'0')}`;
            return schedule.find(s => s.date?.startsWith(dateStr));
          };

          const openDateDetail = (d) => {
            const dateStr = `${year}-${String(month+1).padStart(2,'0')}-${String(d).padStart(2,'0')}`;
            const sched = getScheduleForDate(d);
            setSelectedDate(dateStr);
            setDateDetail({
              status: sched?.status || '',
              title: sched?.title || '',
              notes: sched?.notes || '',
              checklist: sched?.checklist || [],
              booking_id: sched?.booking_id || null,
              start_time: sched?.start_time || '',
              end_time: sched?.end_time || '',
              all_day: !sched?.start_time && !sched?.end_time
            });
          };

          const toggleDate = async (d) => {
            const dateStr = `${year}-${String(month+1).padStart(2,'0')}-${String(d).padStart(2,'0')}`;
            const existing = getScheduleForDate(d);
            try {
              if (existing && existing.status === 'booked') {
                await api.delete(`/vendor/schedule/${dateStr}`);
                showToast('Date cleared');
                setSelectedDate(null); setDateDetail(null);
              } else if (existing && existing.status === 'available') {
                await api.post('/vendor/schedule', { date: dateStr, status: 'booked', title: existing.title || 'Booked', start_time: existing.start_time, end_time: existing.end_time });
                showToast('Marked as booked');
              } else {
                await api.post('/vendor/schedule', { date: dateStr, status: 'available', title: existing?.title || 'Available', start_time: existing?.start_time || null, end_time: existing?.end_time || null });
                showToast('Marked as available');
              }
              const r = await api.get('/vendor/schedule');
              setSchedule(r.data);
            } catch { showToast('Failed to update', 'error'); }
          };

          const saveDateDetail = async () => {
            if (!selectedDate || !dateDetail) return;
            try {
              await api.put(`/vendor/schedule/${selectedDate}`, {
                title: dateDetail.title,
                notes: dateDetail.notes,
                checklist: dateDetail.checklist,
                booking_id: dateDetail.booking_id || null,
                start_time: dateDetail.all_day ? null : (dateDetail.start_time || null),
                end_time: dateDetail.all_day ? null : (dateDetail.end_time || null)
              });
              const r = await api.get('/vendor/schedule');
              setSchedule(r.data);
              showToast('Saved!');
            } catch { showToast('Failed', 'error'); }
          };

          const addChecklistItem = () => {
            setDateDetail({ ...dateDetail, checklist: [...(dateDetail.checklist || []), { text: '', done: false }] });
          };
          const toggleCheckItem = (idx) => {
            const cl = [...(dateDetail.checklist || [])];
            cl[idx] = { ...cl[idx], done: !cl[idx].done };
            setDateDetail({ ...dateDetail, checklist: cl });
          };
          const updateCheckItem = (idx, text) => {
            const cl = [...(dateDetail.checklist || [])];
            cl[idx] = { ...cl[idx], text };
            setDateDetail({ ...dateDetail, checklist: cl });
          };
          const removeCheckItem = (idx) => {
            setDateDetail({ ...dateDetail, checklist: dateDetail.checklist.filter((_, i) => i !== idx) });
          };

          const prevMonth = () => setCalMonth(new Date(year, month - 1, 1));
          const nextMonth = () => setCalMonth(new Date(year, month + 1, 1));
          const monthName = calMonth.toLocaleString('en-ZA', { month: 'long', year: 'numeric' });

          const bookedCount = schedule.filter(s => s.status === 'booked').length;
          const availableCount = schedule.filter(s => s.status === 'available').length;

          // Find linked booking for selected date
          const linkedBooking = dateDetail?.booking_id ? bookings.find(b => b.id === dateDetail.booking_id) : null;

          return (
            <div>
              <div style={{ display: 'flex', gap: '16px', marginBottom: '24px', flexWrap: 'wrap' }}>
                <div className="card" style={{ flex: 1, minWidth: '160px', padding: '16px 20px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <div style={{ width: '40px', height: '40px', borderRadius: '10px', background: 'rgba(239,68,68,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div style={{ width: '12px', height: '12px', borderRadius: '3px', background: 'var(--red)' }} />
                  </div>
                  <div><div style={{ fontSize: '22px', fontWeight: 700 }}>{bookedCount}</div><div style={{ fontSize: '12px', color: 'var(--gray)' }}>Booked Days</div></div>
                </div>
                <div className="card" style={{ flex: 1, minWidth: '160px', padding: '16px 20px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <div style={{ width: '40px', height: '40px', borderRadius: '10px', background: 'rgba(34,197,94,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div style={{ width: '12px', height: '12px', borderRadius: '3px', background: '#22C55E' }} />
                  </div>
                  <div><div style={{ fontSize: '22px', fontWeight: 700 }}>{availableCount}</div><div style={{ fontSize: '12px', color: 'var(--gray)' }}>Available Days</div></div>
                </div>
              </div>

              <div className="vendor-calendar-grid" style={{ display: 'grid', gridTemplateColumns: selectedDate ? '1fr 340px' : '1fr', gap: '16px' }}>
                {/* Calendar Grid */}
                <div className="card" style={{ padding: '24px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <button onClick={prevMonth} style={{ background: 'var(--cream)', border: 'none', borderRadius: '8px', width: '36px', height: '36px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><FiChevronLeft /></button>
                    <h3 style={{ fontSize: '18px' }}>{monthName}</h3>
                    <button onClick={nextMonth} style={{ background: 'var(--cream)', border: 'none', borderRadius: '8px', width: '36px', height: '36px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><FiChevronRight /></button>
                  </div>

                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '4px', marginBottom: '8px' }}>
                    {['Sun','Mon','Tue','Wed','Thu','Fri','Sat'].map(d => (
                      <div key={d} style={{ textAlign: 'center', fontSize: '12px', fontWeight: 600, color: 'var(--gray)', padding: '8px 0' }}>{d}</div>
                    ))}
                  </div>

                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '4px' }}>
                    {days.map((d, i) => {
                      if (!d) return <div key={`e${i}`} />;
                      const sched = getScheduleForDate(d);
                      const dateObj = new Date(year, month, d);
                      const isPast = dateObj < today;
                      const isToday = dateObj.getTime() === today.getTime();
                      const dateStr = `${year}-${String(month+1).padStart(2,'0')}-${String(d).padStart(2,'0')}`;
                      const isSelected = selectedDate === dateStr;
                      const status = sched?.status;
                      const hasChecklist = sched?.checklist && sched.checklist.length > 0;

                      return (
                        <button key={d} onClick={() => { if (!isPast) { if (isSelected) { toggleDate(d); } else { openDateDetail(d); } } }}
                          onDoubleClick={() => !isPast && toggleDate(d)}
                          style={{
                            aspectRatio: '1', border: isSelected ? '2px solid var(--rose)' : isToday ? '2px solid var(--rose)' : '1px solid var(--cream-dark)',
                            borderRadius: '10px', cursor: isPast ? 'default' : 'pointer',
                            background: isSelected ? 'var(--rose-light)' : status === 'booked' ? '#FEE2E2' : status === 'available' ? '#DCFCE7' : 'var(--white)',
                            opacity: isPast ? 0.4 : 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                            gap: '2px', transition: 'all 0.15s', position: 'relative'
                          }}>
                          <span style={{ fontSize: '15px', fontWeight: isToday || isSelected ? 700 : 500, color: isSelected ? 'var(--rose)' : isToday ? 'var(--rose)' : 'var(--dark)' }}>{d}</span>
                          {status && <span style={{ fontSize: '8px', fontWeight: 600, color: status === 'booked' ? 'var(--red)' : 'var(--green)', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{status === 'booked' ? 'BOOKED' : 'FREE'}</span>}
                          {status === 'available' && sched?.start_time && <span style={{ fontSize: '7px', fontWeight: 500, color: 'var(--green)', lineHeight: 1 }}>{sched.start_time.slice(0,5)}</span>}
                          {hasChecklist && <div style={{ position: 'absolute', top: '3px', right: '3px', width: '6px', height: '6px', borderRadius: '50%', background: 'var(--blue)' }} />}
                        </button>
                      );
                    })}
                  </div>

                  <div style={{ marginTop: '16px', display: 'flex', gap: '12px', fontSize: '11px', color: 'var(--gray)', flexWrap: 'wrap' }}>
                    <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}><span style={{ width: '10px', height: '10px', borderRadius: '3px', background: '#DCFCE7' }} /> Available</span>
                    <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}><span style={{ width: '10px', height: '10px', borderRadius: '3px', background: '#FEE2E2' }} /> Booked</span>
                    <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}><span style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#3B82F6' }} /> Has checklist</span>
                    <span style={{ color: 'var(--gray)', opacity: 0.7 }}>Click date to view details · Click selected date to cycle status</span>
                  </div>
                </div>

                {/* Date Detail Panel */}
                {selectedDate && dateDetail && (
                  <div className="card" style={{ padding: '0', overflow: 'hidden', alignSelf: 'start' }}>
                    <div style={{ padding: '16px 20px', background: dateDetail.status === 'booked' ? '#FEE2E2' : dateDetail.status === 'available' ? '#DCFCE7' : 'var(--cream)', borderBottom: '1px solid var(--cream-dark)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div>
                        <div style={{ fontWeight: 700, fontSize: '15px' }}>{new Date(selectedDate + 'T00:00:00').toLocaleDateString('en-ZA', { weekday: 'long', day: 'numeric', month: 'long' })}</div>
                        <span style={{ fontSize: '11px', fontWeight: 600, color: dateDetail.status === 'booked' ? 'var(--red)' : dateDetail.status === 'available' ? 'var(--green)' : 'var(--gray)', textTransform: 'uppercase' }}>{dateDetail.status || 'Not set'}</span>
                      </div>
                      <button onClick={() => { setSelectedDate(null); setDateDetail(null); }} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--gray)' }}><FiX size={18} /></button>
                    </div>

                    <div style={{ padding: '16px 20px' }}>
                      {/* Title / Event name */}
                      <div className="form-group" style={{ marginBottom: '14px' }}>
                        <label style={{ fontSize: '12px', fontWeight: 600 }}>Event / Title</label>
                        <input value={dateDetail.title} onChange={e => setDateDetail({...dateDetail, title: e.target.value})} placeholder="e.g., Wedding - Smith Family" style={{ fontSize: '13px', padding: '8px 12px' }} />
                      </div>

                      {/* Link to booking */}
                      {bookings.filter(b => b.status === 'confirmed').length > 0 && (
                        <div className="form-group" style={{ marginBottom: '14px' }}>
                          <label style={{ fontSize: '12px', fontWeight: 600 }}>Link to Booking</label>
                          <select value={dateDetail.booking_id || ''} onChange={e => setDateDetail({...dateDetail, booking_id: e.target.value ? parseInt(e.target.value) : null})} style={{ fontSize: '13px', padding: '8px 12px' }}>
                            <option value="">None</option>
                            {bookings.filter(b => b.status === 'confirmed').map(b => (
                              <option key={b.id} value={b.id}>{b.event_title} - {b.host_name}</option>
                            ))}
                          </select>
                        </div>
                      )}

                      {/* Time slots */}
                      <div style={{ marginBottom: '14px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                          <label style={{ fontSize: '12px', fontWeight: 600 }}>Time</label>
                          <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', color: 'var(--gray)', cursor: 'pointer' }}>
                            <input type="checkbox" checked={dateDetail.all_day || false} onChange={e => setDateDetail({...dateDetail, all_day: e.target.checked})} style={{ width: '14px', height: '14px', cursor: 'pointer' }} />
                            Free All Day
                          </label>
                        </div>
                        {!dateDetail.all_day && (
                          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
                            <div>
                              <label style={{ fontSize: '10px', color: 'var(--gray)', marginBottom: '2px', display: 'block' }}>From</label>
                              <input type="time" value={dateDetail.start_time || ''} onChange={e => setDateDetail({...dateDetail, start_time: e.target.value})} style={{ fontSize: '13px', padding: '8px 12px', width: '100%', border: '1px solid var(--cream-dark)', borderRadius: '8px' }} />
                            </div>
                            <div>
                              <label style={{ fontSize: '10px', color: 'var(--gray)', marginBottom: '2px', display: 'block' }}>To</label>
                              <input type="time" value={dateDetail.end_time || ''} onChange={e => setDateDetail({...dateDetail, end_time: e.target.value})} style={{ fontSize: '13px', padding: '8px 12px', width: '100%', border: '1px solid var(--cream-dark)', borderRadius: '8px' }} />
                            </div>
                          </div>
                        )}
                      </div>

                      {/* Notes */}
                      <div className="form-group" style={{ marginBottom: '14px' }}>
                        <label style={{ fontSize: '12px', fontWeight: 600 }}>Notes</label>
                        <textarea value={dateDetail.notes} onChange={e => setDateDetail({...dateDetail, notes: e.target.value})} placeholder="Any notes for this day..." rows={2} style={{ fontSize: '13px', padding: '8px 12px' }} />
                      </div>

                      {/* Checklist */}
                      <div style={{ marginBottom: '14px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                          <label style={{ fontSize: '12px', fontWeight: 600 }}>Checklist</label>
                          <button onClick={addChecklistItem} style={{ background: 'none', border: 'none', color: 'var(--rose)', cursor: 'pointer', fontSize: '12px', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '4px' }}><FiPlus size={12} /> Add</button>
                        </div>
                        {(dateDetail.checklist || []).length === 0 ? (
                          <div style={{ fontSize: '12px', color: 'var(--gray)', padding: '12px', background: 'var(--cream)', borderRadius: '8px', textAlign: 'center' }}>No checklist items yet</div>
                        ) : (
                          <div style={{ display: 'grid', gap: '6px' }}>
                            {dateDetail.checklist.map((item, idx) => (
                              <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 8px', background: 'var(--cream)', borderRadius: '8px' }}>
                                <button onClick={() => toggleCheckItem(idx)} style={{ background: 'none', border: `2px solid ${item.done ? 'var(--green)' : 'var(--cream-dark)'}`, borderRadius: '4px', width: '18px', height: '18px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, background: item.done ? 'var(--green)' : 'var(--white)' }}>
                                  {item.done && <FiCheck size={12} style={{ color: 'white' }} />}
                                </button>
                                <input value={item.text} onChange={e => updateCheckItem(idx, e.target.value)} placeholder="Task..." style={{ flex: 1, border: 'none', background: 'transparent', fontSize: '13px', padding: '2px 0', textDecoration: item.done ? 'line-through' : 'none', color: item.done ? 'var(--gray)' : 'var(--dark)' }} />
                                <button onClick={() => removeCheckItem(idx)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--gray)', padding: '2px' }}><FiX size={12} /></button>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>

                      <div style={{ display: 'flex', gap: '8px' }}>
                        <button className="btn btn-primary btn-sm btn-full" onClick={saveDateDetail}><FiSave size={12} /> Save</button>
                        <button className="btn btn-sm" onClick={() => toggleDate(parseInt(selectedDate.split('-')[2]))} style={{ background: 'var(--cream)', color: 'var(--gray)', border: 'none', borderRadius: '8px', padding: '8px 12px', cursor: 'pointer', fontSize: '12px' }}>
                          {dateDetail.status === 'booked' ? 'Clear' : dateDetail.status === 'available' ? 'Mark Booked' : 'Mark Available'}
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        })()}

        {/* ═══ DELIVERIES ═══ */}
        {tab === 'deliveries' && (
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', flexWrap: 'wrap', gap: '8px' }}>
              <h3 style={{ fontSize: '18px', fontWeight: 600 }}>Delivery Tracking</h3>
              <span style={{ fontSize: '12px', color: 'var(--gray)' }}>{deliveries.length} active delivery{deliveries.length !== 1 ? 'ies' : ''}</span>
            </div>
            {bookings.filter(b => b.status === 'confirmed').length === 0 && deliveries.length === 0 ? (
              <div className="card" style={{ textAlign: 'center', padding: '60px', color: 'var(--gray)' }}>
                <div style={{ fontSize: '40px', marginBottom: '12px' }}>&#128666;</div>
                <h4 style={{ marginBottom: '6px', color: 'var(--dark)' }}>No deliveries yet</h4>
                <p style={{ fontSize: '13px' }}>Confirmed bookings will appear here so you can set up delivery tracking.</p>
              </div>
            ) : (
              <div style={{ display: 'grid', gap: '16px' }}>
                {/* Existing deliveries */}
                {deliveries.map(d => (
                  <div key={d.id} className="card" style={{ padding: '24px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '12px', marginBottom: '16px' }}>
                      <div>
                        <h4 style={{ marginBottom: '4px', fontSize: '17px' }}>{d.event_title || 'Delivery #' + d.id}</h4>
                        <div style={{ fontSize: '13px', color: 'var(--gray)' }}>Host: <strong>{d.host_name}</strong></div>
                      </div>
                      <span className={`tag ${d.status === 'completed' ? 'tag-green' : d.status === 'on_the_way' ? 'tag-blue' : d.status === 'arrived' ? 'tag-gold' : d.status === 'cancelled' ? 'tag-red' : ''}`} style={{ textTransform: 'capitalize' }}>{d.status.replace(/_/g, ' ')}</span>
                    </div>
                    {/* Status Flow */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0', marginBottom: '16px', flexWrap: 'wrap', justifyContent: 'center' }}>
                      {['preparation','on_the_way','arrived','completed'].map((s, i, arr) => {
                        const statusOrder = ['preparation','on_the_way','arrived','completed'];
                        const currentIdx = d.status === 'cancelled' ? -1 : statusOrder.indexOf(d.status);
                        const stepIdx = statusOrder.indexOf(s);
                        const isActive = stepIdx <= currentIdx;
                        const isCurrent = s === d.status;
                        const isCancelled = d.status === 'cancelled';
                        const labels = { preparation: 'Prep', on_the_way: 'On the Way', arrived: 'Arrived', completed: 'Done' };
                        const icons = { preparation: '\u{1F528}', on_the_way: '\u{1F698}', arrived: '\u{1F3C1}', completed: '\u{2705}' };
                        const isLast = i === arr.length - 1;
                        return (
                          <React.Fragment key={s}>
                            {i > 0 && (
                              <div style={{ width: '25px', height: '3px', borderRadius: '2px', background: isCancelled ? 'var(--cream-dark)' : stepIdx <= currentIdx ? 'var(--green)' : 'var(--cream-dark)', margin: '0 2px', flexShrink: 0 }} />
                            )}
                            <div style={{
                              display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px',
                              opacity: isCancelled ? 0.4 : isActive ? 1 : 0.4,
                              flex: '0 0 auto'
                            }}>
                              <div style={{
                                width: '40px', height: '40px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                background: isCurrent ? 'var(--green)' : isActive ? '#D1FAE5' : 'var(--cream)',
                                border: isCurrent ? '3px solid var(--green)' : '2px solid ' + (isActive ? 'var(--green)' : 'var(--cream-dark)'),
                                fontSize: '16px', transition: 'all 0.3s'
                              }}>
                                {icons[s]}
                              </div>
                              <span style={{ fontSize: '10px', fontWeight: isCurrent ? 700 : 400, color: isCurrent ? 'var(--green)' : 'var(--gray)', whiteSpace: 'nowrap' }}>{labels[s]}</span>
                            </div>
                          </React.Fragment>
                        );
                      })}
                    </div>
                    {/* Action Buttons */}
                    {d.status === 'cancelled' && (
                      <div style={{ padding: '8px 14px', background: '#FEE2E2', borderRadius: '8px', fontSize: '13px', color: '#991B1B', marginBottom: '12px' }}>
                        &#10060; This delivery has been cancelled.
                      </div>
                    )}
                    {d.status !== 'completed' && d.status !== 'cancelled' && (
                      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: '12px' }}>
                        {d.status === 'preparation' && (
                          <button className="btn btn-primary btn-sm" onClick={() => updateDeliveryStatus(d.id, 'on_the_way')} style={{ background: 'var(--blue)' }}>
                            &#128663; On the Way
                          </button>
                        )}
                        {d.status === 'on_the_way' && (
                          <button className="btn btn-primary btn-sm" onClick={() => updateDeliveryStatus(d.id, 'arrived')} style={{ background: 'var(--green)' }}>
                            &#127881; Arrived
                          </button>
                        )}
                        {d.status === 'arrived' && !d.confirmed_by_host && (
                          <div style={{ padding: '8px 14px', background: '#FEF3C7', borderRadius: '8px', fontSize: '13px', color: '#92400E', display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span>&#9203;</span> Waiting for host confirmation...
                          </div>
                        )}
                        {d.confirmed_by_host && (
                          <span className="tag tag-green" style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>&#10003; Confirmed by host</span>
                        )}
                      </div>
                    )}
                    {d.status === 'completed' && (
                      <div style={{ padding: '8px 14px', background: '#D1FAE5', borderRadius: '8px', fontSize: '13px', color: '#065F46', marginBottom: '12px' }}>
                        &#10003; Delivery completed and confirmed!
                      </div>
                    )}
                    {/* Availability Info */}
                    {d.availability_date && (
                      <div style={{ padding: '10px 14px', background: 'var(--cream)', borderRadius: '8px', fontSize: '13px', display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                        <span><strong>Date:</strong> {new Date(d.availability_date).toLocaleDateString('en-ZA', { day: 'numeric', month: 'short', year: 'numeric' })}</span>
                        {d.availability_start_time && <span><strong>From:</strong> {d.availability_start_time}</span>}
                        {d.availability_end_time && <span><strong>To:</strong> {d.availability_end_time}</span>}
                      </div>
                    )}
                    {d.notes && <p style={{ fontSize: '13px', color: 'var(--gray)', marginTop: '10px' }}><strong>Notes:</strong> {d.notes}</p>}
                  </div>
                ))}
                {/* Un-tracked confirmed bookings */}
                {bookings.filter(b => b.status === 'confirmed' && !deliveries.some(d => d.booking_id === b.id)).map(b => (
                  <div key={`new-${b.id}`} className="card" style={{ padding: '24px', border: '2px dashed var(--cream-dark)' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '12px', marginBottom: '12px' }}>
                      <div>
                        <h4 style={{ marginBottom: '4px', fontSize: '17px' }}>{b.event_title}</h4>
                        <div style={{ fontSize: '13px', color: 'var(--gray)' }}>Host: <strong>{b.host_name}</strong></div>
                      </div>
                      <span className="tag tag-green">Confirmed</span>
                    </div>
                    <div style={{ padding: '14px 16px', background: 'var(--cream)', borderRadius: '10px', marginBottom: '12px', fontSize: '13px' }}>
                      {b.event_date && <span style={{ marginRight: '16px' }}><strong>Event:</strong> {new Date(b.event_date).toLocaleDateString('en-ZA', { day: 'numeric', month: 'short', year: 'numeric' })}</span>}
                      {b.event_location && <span><strong>Location:</strong> {b.event_location}</span>}
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '10px', marginBottom: '12px' }}>
                      <div>
                        <label style={{ fontSize: '11px', color: 'var(--gray)', display: 'block', marginBottom: '4px' }}>Availability Date *</label>
                        <input type="date" style={{ width: '100%', padding: '8px 10px', borderRadius: '8px', border: '1px solid var(--cream-dark)', fontSize: '13px' }}
                          value={deliveryForm.booking_id === b.id ? deliveryForm.availability_date : ''}
                          onChange={e => setDeliveryForm({ ...deliveryForm, booking_id: b.id, availability_date: e.target.value })}
                        />
                      </div>
                      <div>
                        <label style={{ fontSize: '11px', color: 'var(--gray)', display: 'block', marginBottom: '4px' }}>From Time</label>
                        <input type="time" style={{ width: '100%', padding: '8px 10px', borderRadius: '8px', border: '1px solid var(--cream-dark)', fontSize: '13px' }}
                          value={deliveryForm.booking_id === b.id ? deliveryForm.availability_start_time : ''}
                          onChange={e => setDeliveryForm({ ...deliveryForm, booking_id: b.id, availability_start_time: e.target.value })}
                        />
                      </div>
                      <div>
                        <label style={{ fontSize: '11px', color: 'var(--gray)', display: 'block', marginBottom: '4px' }}>To Time</label>
                        <input type="time" style={{ width: '100%', padding: '8px 10px', borderRadius: '8px', border: '1px solid var(--cream-dark)', fontSize: '13px' }}
                          value={deliveryForm.booking_id === b.id ? deliveryForm.availability_end_time : ''}
                          onChange={e => setDeliveryForm({ ...deliveryForm, booking_id: b.id, availability_end_time: e.target.value })}
                        />
                      </div>
                    </div>
                    <div style={{ marginBottom: '12px' }}>
                      <label style={{ fontSize: '11px', color: 'var(--gray)', display: 'block', marginBottom: '4px' }}>Notes (optional)</label>
                      <textarea placeholder="E.g., I'll bring the equipment in a white van..." style={{ width: '100%', padding: '8px 10px', borderRadius: '8px', border: '1px solid var(--cream-dark)', fontSize: '13px', minHeight: '50px' }}
                        value={deliveryForm.booking_id === b.id ? deliveryForm.notes : ''}
                        onChange={e => setDeliveryForm({ ...deliveryForm, booking_id: b.id, notes: e.target.value })}
                      />
                    </div>
                    <button className="btn btn-primary btn-sm" onClick={() => saveDelivery(b.id, b.event_id, b.host_id)}>
                      &#128666; Set Up Delivery Tracking
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* ═══ REVIEWS ═══ */}
        {tab === 'reviews' && (
          <div>
            <div className="card" style={{ padding: '24px', marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '24px', flexWrap: 'wrap' }}>
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '48px', fontWeight: 700, color: 'var(--dark)', lineHeight: 1 }}>{Number(profile.avg_rating || 0).toFixed(1)}</div>
                <div style={{ display: 'flex', gap: '2px', justifyContent: 'center', margin: '8px 0' }}>
                  {[1,2,3,4,5].map(s => (
                    <FiStar key={s} size={18} style={{ color: s <= Math.round(profile.avg_rating || 0) ? '#F59E0B' : '#E5E7EB', fill: s <= Math.round(profile.avg_rating || 0) ? '#F59E0B' : 'none' }} />
                  ))}
                </div>
                <div style={{ fontSize: '13px', color: 'var(--gray)' }}>{profile.review_count || 0} reviews</div>
              </div>
              <div style={{ flex: 1, minWidth: '200px' }}>
                {[5,4,3,2,1].map(star => {
                  const count = reviews.filter(r => r.rating === star).length;
                  const pct = reviews.length > 0 ? (count / reviews.length * 100) : 0;
                  return (
                    <div key={star} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                      <span style={{ fontSize: '12px', color: 'var(--gray)', width: '12px' }}>{star}</span>
                      <FiStar size={12} style={{ color: '#F59E0B', fill: '#F59E0B', flexShrink: 0 }} />
                      <div style={{ flex: 1, height: '8px', background: 'var(--cream-dark)', borderRadius: '4px', overflow: 'hidden' }}>
                        <div style={{ width: `${pct}%`, height: '100%', background: '#F59E0B', borderRadius: '4px', transition: 'width 0.3s' }} />
                      </div>
                      <span style={{ fontSize: '12px', color: 'var(--gray)', width: '24px', textAlign: 'right' }}>{count}</span>
                    </div>
                  );
                })}
              </div>
            </div>

            {reviews.length === 0 ? (
              <div className="card" style={{ textAlign: 'center', padding: '60px', color: 'var(--gray)' }}>
                <FiStar size={40} style={{ opacity: 0.3, marginBottom: '16px' }} />
                <h3>No Reviews Yet</h3>
                <p style={{ fontSize: '14px', marginTop: '8px' }}>Reviews from clients will appear here after they rate your service.</p>
              </div>
            ) : (
              <div style={{ display: 'grid', gap: '12px' }}>
                {reviews.map(r => (
                  <div key={r.id} className="card" style={{ padding: '20px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '10px' }}>
                      <div>
                        <div style={{ fontWeight: 600, fontSize: '15px', marginBottom: '2px' }}>{r.reviewer_name}</div>
                        {r.event_type && <span className="tag" style={{ fontSize: '11px' }}>{r.event_type}</span>}
                      </div>
                      <div style={{ display: 'flex', gap: '2px' }}>
                        {[1,2,3,4,5].map(s => (
                          <FiStar key={s} size={14} style={{ color: s <= r.rating ? '#F59E0B' : '#E5E7EB', fill: s <= r.rating ? '#F59E0B' : 'none' }} />
                        ))}
                      </div>
                    </div>
                    {r.review_text && <p style={{ color: 'var(--gray)', fontSize: '14px', lineHeight: 1.6 }}>{r.review_text}</p>}
                    <div style={{ fontSize: '12px', color: 'var(--gray)', marginTop: '10px', opacity: 0.7 }}>{new Date(r.created_at).toLocaleDateString('en-ZA', { day: 'numeric', month: 'long', year: 'numeric' })}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* ═══ NOTIFICATIONS ═══ */}
        {tab === 'notifications' && (
          <div>
            {notifications.length === 0 ? (
              <div className="card" style={{ textAlign: 'center', padding: '60px', color: 'var(--gray)' }}>No notifications yet</div>
            ) : (
              <div style={{ display: 'grid', gap: '8px' }}>
                {notifications.map(n => (
                  <div key={n.id} onClick={() => { markNotificationsRead(); if (n.link) navigate(n.link); }} className="card" style={{ padding: '16px 20px', borderLeft: n.read ? 'none' : '3px solid var(--rose)', cursor: n.link ? 'pointer' : 'default' }}>
                    <div style={{ fontWeight: n.read ? 400 : 600, fontSize: '14px', marginBottom: '4px' }}>{n.title}</div>
                    <div style={{ fontSize: '13px', color: 'var(--gray)' }}>{n.message}</div>
                    <div style={{ fontSize: '11px', color: 'var(--gray)', marginTop: '6px' }}>{new Date(n.created_at).toLocaleString('en-ZA')}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* ═══ SETTINGS — vertical list layout ═══ */}
        {tab === 'settings' && (
          <div style={{ maxWidth: '480px' }}>
            {/* Header */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '16px 20px', marginBottom: '8px' }}>
              {settingsTab ? (
                <button onClick={() => setSettingsTab('')} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--dark)', padding: '4px', display: 'flex' }}>
                  <FiArrowLeft size={20} />
                </button>
              ) : (
                <div style={{ width: '28px' }} />
              )}
              <h3 style={{ fontSize: '18px', margin: 0, flex: 1 }}>
                {settingsTab === 'password' ? 'Change Password' :
                 settingsTab === 'notifications' ? 'Notifications' :
                 settingsTab === 'feedback' ? 'Feedback' :
                 settingsTab === 'support' ? 'Contact Support' :
                 settingsTab === 'deactivate' ? 'Deactivate Account' :
                 'Settings'}
              </h3>
              <div style={{ width: '28px' }} />
            </div>

            {/* ── Main list ── */}
            {!settingsTab && (
              <div className="card" style={{ padding: '8px 0' }}>
                <SettingsRow icon={<FiLock size={18} />} iconBg="rgba(59,130,246,0.1)" iconColor="#3B82F6" label="Password" onClick={() => setSettingsTab('password')} />

                {/* Notifications — opens sub-view with toggles */}
                <SettingsRow icon={<FiBell size={18} />} iconBg="rgba(245,158,11,0.1)" iconColor="#F59E0B" label="Notifications" onClick={() => setSettingsTab('notifications')} />

                <SettingsRow icon={<FiMessageSquare size={18} />} iconBg="rgba(16,185,129,0.1)" iconColor="#10B981" label="Feedback" onClick={() => setSettingsTab('feedback')} />
                <SettingsRow icon={<FiHelpCircle size={18} />} iconBg="rgba(139,92,246,0.1)" iconColor="#8B5CF6" label="Support" onClick={() => setSettingsTab('support')} isLast />

                {/* Danger zone */}
                <div style={{ padding: '24px 20px 8px' }}>
                  <div style={{ fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1.5px', color: 'var(--gray)', marginBottom: '8px' }}>Account</div>
                  <SettingsRow icon={<FiAlertCircle size={18} />} iconBg="rgba(220,38,38,0.1)" iconColor="#DC2626" label="Deactivate Account" onClick={() => setSettingsTab('deactivate')} danger isLast />
                </div>
              </div>
            )}


            {/* ── Password sub-view ── */}
            {settingsTab === 'password' && (
              <div className="card" style={{ padding: '24px' }}>
                <div className="form-group">
                  <label>Current Password</label>
                  <input type="password" value={passwordForm.current} onChange={e => setPasswordForm({ ...passwordForm, current: e.target.value })} placeholder="Enter current password" />
                </div>
                <div className="form-group">
                  <label>New Password</label>
                  <input type="password" value={passwordForm.new_password} onChange={e => setPasswordForm({ ...passwordForm, new_password: e.target.value })} placeholder="At least 6 characters" />
                </div>
                <div className="form-group">
                  <label>Confirm New Password</label>
                  <input type="password" value={passwordForm.confirm} onChange={e => setPasswordForm({ ...passwordForm, confirm: e.target.value })} placeholder="Re-enter new password" />
                </div>
                <button className="btn btn-primary" onClick={changePassword} disabled={!passwordForm.current || !passwordForm.new_password || !passwordForm.confirm}>
                  <FiLock size={16} /> Change Password
                </button>
              </div>
            )}

            {/* ── Notifications sub-view ── */}
            {settingsTab === 'notifications' && (
              <div className="card" style={{ padding: '24px' }}>
                {/* Push Notifications */}
                {pushSupported ? (
                  <div style={{ marginBottom: '24px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 0', borderBottom: '1px solid rgba(0,0,0,0.06)' }}>
                      <div>
                        <div style={{ fontSize: '15px', fontWeight: 500, color: 'var(--dark)' }}>Push Notifications</div>
                        <div style={{ fontSize: '13px', color: 'var(--gray)', marginTop: '2px' }}>
                          {pushPermission === 'denied'
                            ? 'Blocked in browser settings. Enable in site settings to receive notifications.'
                            : pushEnabled
                              ? 'Receive notifications even when the app is closed'
                              : 'Get notified about bookings, messages, and updates'}
                        </div>
                      </div>
                      {pushPermission === 'denied' ? (
                        <div style={{ fontSize: '11px', color: '#DC2626', fontWeight: 600, background: 'rgba(220,38,38,0.08)', padding: '6px 10px', borderRadius: '6px' }}>Blocked</div>
                      ) : (
                        <button
                          onClick={async () => {
                            const next = !pushEnabled;
                            setPushEnabled(next);
                            localStorage.setItem('ggr_push', next ? 'on' : 'off');
                            if (next) {
                              await subscribeToPush();
                            } else {
                              await unsubscribeFromPush();
                            }
                          }}
                          style={{
                            width: '48px', height: '28px', borderRadius: '14px', border: 'none',
                            background: pushEnabled ? '#E3425C' : 'rgba(0,0,0,0.15)',
                            cursor: 'pointer', position: 'relative', transition: 'background 0.2s',
                            flexShrink: 0,
                          }}
                        >
                          <span style={{
                            position: 'absolute', top: '3px', left: pushEnabled ? '23px' : '3px',
                            width: '22px', height: '22px', borderRadius: '50%', background: '#fff',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.2)', transition: 'left 0.2s',
                          }} />
                        </button>
                      )}
                    </div>
                  </div>
                ) : (
                  <div style={{ marginBottom: '24px', padding: '12px 16px', borderRadius: '10px', background: 'rgba(245,158,11,0.08)', border: '1px solid rgba(245,158,11,0.15)' }}>
                    <div style={{ fontSize: '13px', color: '#92400E', lineHeight: 1.5 }}>
                      Push notifications are not supported on this browser. Install the app or use Chrome/Edge for push notifications that work even when the app is closed.
                    </div>
                  </div>
                )}

                {/* Sound Alerts */}
                <div style={{ marginBottom: '24px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 0', borderBottom: '1px solid rgba(0,0,0,0.06)' }}>
                    <div>
                      <div style={{ fontSize: '15px', fontWeight: 500, color: 'var(--dark)' }}>Notification Sound</div>
                      <div style={{ fontSize: '13px', color: 'var(--gray)', marginTop: '2px' }}>Play a sound when new notifications arrive</div>
                    </div>
                    <button
                      onClick={() => {
                        const current = localStorage.getItem('ggr_sound');
                        const next = current === 'off' ? 'on' : 'off';
                        localStorage.setItem('ggr_sound', next);
                        setSoundOn(next !== 'off');
                      }}
                      style={{
                        width: '48px', height: '28px', borderRadius: '14px', border: 'none',
                        background: soundOn ? '#E3425C' : 'rgba(0,0,0,0.15)',
                        cursor: 'pointer', position: 'relative', transition: 'background 0.2s',
                        flexShrink: 0,
                      }}
                    >
                      <span style={{
                        position: 'absolute', top: '3px', left: soundOn ? '23px' : '3px',
                        width: '22px', height: '22px', borderRadius: '50%', background: '#fff',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.2)', transition: 'left 0.2s',
                      }} />
                    </button>
                  </div>
                </div>

                {/* Info */}
                <div style={{ padding: '16px', borderRadius: '12px', background: 'var(--cream)' }}>
                  <p style={{ fontSize: '13px', color: 'var(--gray)', margin: 0, lineHeight: 1.6 }}>
                    {pushEnabled && pushPermission === 'granted'
                      ? 'You\'ll receive push notifications even when the app is closed. Notifications also appear as a badge on the bell icon in the app.'
                      : 'Notifications appear as a badge count on the bell icon in the app header. Enable push notifications above to receive alerts even when the app is closed.'}
                  </p>
                </div>
              </div>
            )}

            {/* ── Feedback sub-view ── */}
            {settingsTab === 'feedback' && (
              <div className="card" style={{ padding: '24px' }}>
                <div className="form-group">
                  <label>Rating</label>
                  <div style={{ display: 'flex', gap: '6px' }}>
                    {[1,2,3,4,5].map(s => (
                      <button key={s} onClick={() => setFeedbackForm({ ...feedbackForm, rating: s })} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '2px' }}>
                        <FiStar size={24} color={s <= feedbackForm.rating ? '#F59E0B' : 'var(--gray)'} fill={s <= feedbackForm.rating ? '#F59E0B' : 'none'} />
                      </button>
                    ))}
                  </div>
                </div>
                <div className="form-group">
                  <label>Category</label>
                  <select value={feedbackForm.category} onChange={e => setFeedbackForm({ ...feedbackForm, category: e.target.value })} style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid rgba(0,0,0,0.12)', fontSize: '14px', background: 'var(--white)' }}>
                    <option value="general">General</option>
                    <option value="bug">Bug Report</option>
                    <option value="feature">Feature Request</option>
                    <option value="improvement">Improvement</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Your Feedback</label>
                  <textarea value={feedbackForm.message} onChange={e => setFeedbackForm({ ...feedbackForm, message: e.target.value })} placeholder="Tell us what you think, report a bug, or suggest an improvement..." rows={4} style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid rgba(0,0,0,0.12)', fontSize: '14px', resize: 'vertical', fontFamily: 'inherit' }} />
                </div>
                <button className="btn btn-primary" onClick={submitFeedback} disabled={!feedbackForm.message.trim()}><FiSend size={16} /> Submit Feedback</button>

                {feedbackList.length > 0 && (
                  <div style={{ marginTop: '24px', borderTop: '1px solid var(--cream-dark)', paddingTop: '20px' }}>
                    <h4 style={{ fontSize: '14px', marginBottom: '12px', color: 'var(--gray)' }}>Your Previous Feedback</h4>
                    {feedbackList.map((fb, i) => (
                      <div key={fb.id || i} style={{ padding: '14px', borderRadius: '10px', background: 'var(--cream)', marginBottom: '10px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
                          <div style={{ display: 'flex', gap: '2px' }}>
                            {[1,2,3,4,5].map(s => (
                              <FiStar key={s} size={14} color={s <= fb.rating ? '#F59E0B' : 'var(--gray)'} fill={s <= fb.rating ? '#F59E0B' : 'none'} />
                            ))}
                          </div>
                          <span style={{ fontSize: '11px', color: 'var(--gray)' }}>{fb.created_at ? new Date(fb.created_at).toLocaleDateString('en-ZA') : ''}</span>
                        </div>
                        <span style={{ textTransform: 'capitalize', fontSize: '11px', padding: '2px 8px', borderRadius: '4px', background: 'var(--white)', color: 'var(--gray)', marginBottom: '6px', display: 'inline-block' }}>{fb.category}</span>
                        <p style={{ margin: '6px 0 0', color: 'var(--dark)', lineHeight: 1.5 }}>{fb.message}</p>
                        {fb.admin_response && (
                          <div style={{ marginTop: '8px', padding: '10px 12px', background: 'var(--white)', borderRadius: '8px', borderLeft: '3px solid var(--rose)' }}>
                            <span style={{ fontSize: '11px', fontWeight: 600, color: 'var(--rose)' }}>Admin Response</span>
                            <p style={{ margin: '4px 0 0', fontSize: '13px', color: 'var(--dark)', lineHeight: 1.5 }}>{fb.admin_response}</p>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {/* ── Support sub-view ── */}
            {settingsTab === 'support' && (
              <div className="card" style={{ padding: '24px' }}>
                <p style={{ fontSize: '14px', color: 'var(--gray)', lineHeight: 1.6, marginBottom: '24px' }}>Need help? Reach out to our team through any of the channels below.</p>
                <div style={{ display: 'grid', gap: '12px' }}>
                  <a href="mailto:support@grandgatherregistry.co.za" style={{ display: 'flex', alignItems: 'center', gap: '14px', padding: '16px 20px', borderRadius: '12px', background: 'var(--cream)', textDecoration: 'none', color: 'var(--dark)' }}>
                    <div style={{ width: '40px', height: '40px', borderRadius: '10px', background: 'rgba(227,66,92,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                      <FiMail size={18} style={{ color: 'var(--rose)' }} />
                    </div>
                    <div>
                      <div style={{ fontWeight: 600, fontSize: '14px' }}>General Support</div>
                      <div style={{ fontSize: '12px', color: 'var(--gray)' }}>support@grandgatherregistry.co.za</div>
                    </div>
                  </a>
                  <a href="mailto:admin@grandgatherregistry.co.za?subject=Account%20Enquiry" style={{ display: 'flex', alignItems: 'center', gap: '14px', padding: '16px 20px', borderRadius: '12px', background: 'var(--cream)', textDecoration: 'none', color: 'var(--dark)' }}>
                    <div style={{ width: '40px', height: '40px', borderRadius: '10px', background: 'rgba(59,130,246,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                      <FiSend size={18} style={{ color: 'var(--blue)' }} />
                    </div>
                    <div>
                      <div style={{ fontWeight: 600, fontSize: '14px' }}>Admin / Account Enquiry</div>
                      <div style={{ fontSize: '12px', color: 'var(--gray)' }}>admin@grandgatherregistry.co.za</div>
                    </div>
                  </a>
                  <a href="https://wa.me/27613911942?text=Hi%2C%20I%20need%20help%20with%20my%20GGR%20account" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center', gap: '14px', padding: '16px 20px', borderRadius: '12px', background: 'var(--cream)', textDecoration: 'none', color: 'var(--dark)' }}>
                    <div style={{ width: '40px', height: '40px', borderRadius: '10px', background: 'rgba(37,211,102,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                      <FiMessageCircle size={18} style={{ color: '#25D366' }} />
                    </div>
                    <div>
                      <div style={{ fontWeight: 600, fontSize: '14px' }}>WhatsApp Support</div>
                      <div style={{ fontSize: '12px', color: 'var(--gray)' }}>+27 61 391 1942</div>
                    </div>
                  </a>
                </div>
              </div>
            )}

            {/* ── Deactivate sub-view ── */}
            {settingsTab === 'deactivate' && (
              <div className="card" style={{ padding: '24px' }}>
                <div style={{ padding: '20px', borderRadius: '12px', border: '2px solid var(--red)', background: 'var(--rose-light)' }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', marginBottom: '16px' }}>
                    <FiAlertCircle size={24} color="var(--red)" style={{ flexShrink: 0, marginTop: '2px' }} />
                    <div>
                      <h4 style={{ fontSize: '15px', marginBottom: '4px', color: 'var(--red)' }}>Deactivate Account</h4>
                      <p style={{ fontSize: '13px', color: 'var(--red)', lineHeight: 1.5, margin: 0 }}>This will permanently delete your account and vendor profile. Your data will be archived for reference, but you will need to register again to use the platform.</p>
                    </div>
                  </div>
                  <div className="form-group">
                    <label style={{ color: 'var(--red)' }}>Confirm Password</label>
                    <input type="password" value={deactivateConfirm.password} onChange={e => setDeactivateConfirm({ ...deactivateConfirm, password: e.target.value })} placeholder="Enter your password to confirm" />
                  </div>
                  <div className="form-group">
                    <label style={{ color: 'var(--red)' }}>Reason (Optional)</label>
                    <textarea value={deactivateConfirm.reason} onChange={e => setDeactivateConfirm({ ...deactivateConfirm, reason: e.target.value })} placeholder="Why are you leaving?" rows={3} style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid var(--red)', fontSize: '14px', resize: 'vertical', fontFamily: 'inherit' }} />
                  </div>
                  <button className="btn" onClick={deactivateAccount} style={{ background: 'var(--red)', color: 'white', border: 'none', display: 'inline-flex', alignItems: 'center', gap: '6px' }}><FiTrash2 size={16} /> Deactivate Account</button>
                </div>
              </div>
            )}
          </div>
        )}

      {/* ─── BROWSE EVENTS SLIDE-OUT PANEL ─── */}
      {showBrowseEvents && (
        <>
          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 500 }} onClick={() => setShowBrowseEvents(false)} />
          <div style={{ position: 'fixed', top: 0, right: 0, bottom: 0, width: isMobile ? '100%' : '420px', maxWidth: '100%', background: 'var(--white)', zIndex: 501, boxShadow: '-4px 0 24px rgba(0,0,0,0.15)', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            {/* Header */}
            <div style={{ padding: '16px 20px', borderBottom: '1px solid var(--cream-dark)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <FiCompass size={20} color="var(--rose)" />
                <h3 style={{ margin: 0, fontSize: '16px' }}>Browse Events</h3>
              </div>
              <button onClick={() => setShowBrowseEvents(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--gray)', padding: '4px' }}><FiX size={20} /></button>
            </div>
            {/* Filters */}
            <div style={{ padding: '12px 20px', borderBottom: '1px solid var(--cream)', display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              <select value={outreachFilters.event_type} onChange={e => applyOutreachFilters({ event_type: e.target.value })} style={{ padding: '6px 10px', borderRadius: '8px', border: '1px solid var(--cream-dark)', fontSize: '12px', background: 'var(--white)' }}>
                <option value="">All Types</option>
                {EVENT_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
              </select>
              <select value={outreachFilters.location} onChange={e => applyOutreachFilters({ location: e.target.value })} style={{ padding: '6px 10px', borderRadius: '8px', border: '1px solid var(--cream-dark)', fontSize: '12px', background: 'var(--white)', minWidth: '130px' }}>
                <option value="">All Locations</option>
                {SA_AREAS.slice(0, 20).map(a => <option key={a} value={a}>{a}</option>)}
              </select>
              <input type="date" value={outreachFilters.date_from} onChange={e => applyOutreachFilters({ date_from: e.target.value })} style={{ padding: '6px 10px', borderRadius: '8px', border: '1px solid var(--cream-dark)', fontSize: '12px' }} placeholder="From" />
              <input type="date" value={outreachFilters.date_to} onChange={e => applyOutreachFilters({ date_to: e.target.value })} style={{ padding: '6px 10px', borderRadius: '8px', border: '1px solid var(--cream-dark)', fontSize: '12px' }} placeholder="To" />
            </div>
            {/* Event Cards */}
            <div style={{ flex: 1, overflowY: 'auto', padding: '16px 20px' }}>
              {outreachEventsLoading ? (
                <div style={{ textAlign: 'center', padding: '40px' }}><LoadingScreen /></div>
              ) : outreachEvents.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '40px', color: 'var(--gray)' }}>
                  <FiCalendar size={40} style={{ opacity: 0.3, marginBottom: '12px' }} />
                  <p style={{ fontSize: '14px' }}>No matching events found. Check back later or widen your filters.</p>
                </div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  {outreachEvents.map(event => (
                    <div key={event.id} style={{ padding: '14px 16px', borderRadius: '12px', border: '1px solid var(--cream-dark)', background: 'var(--white)', transition: 'box-shadow 0.15s' }}
                      onMouseEnter={e => e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.08)'}
                      onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '12px' }}>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <h4 style={{ margin: '0 0 4px', fontSize: '14px', fontWeight: 600 }}>{event.title}</h4>
                          <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginBottom: '6px' }}>
                            <span style={{ fontSize: '11px', padding: '2px 8px', borderRadius: '10px', background: 'rgba(227,66,92,0.1)', color: 'var(--rose)', fontWeight: 600 }}>{event.event_type}</span>
                            <span style={{ fontSize: '11px', padding: '2px 8px', borderRadius: '10px', background: 'var(--cream)', color: 'var(--gray)', display: 'flex', alignItems: 'center', gap: '3px' }}><FiCalendar size={10} />{event.event_date}</span>
                          </div>
                          <div style={{ fontSize: '12px', color: 'var(--gray)', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                            {event.event_location && <span style={{ display: 'flex', alignItems: 'center', gap: '3px' }}><FiMapPin size={10} />{event.event_location}</span>}
                            {event.estimated_guests > 0 && <span style={{ display: 'flex', alignItems: 'center', gap: '3px' }}><FiUsers size={10} />{event.estimated_guests} guests</span>}
                          </div>
                        </div>
                        <button onClick={() => openOutreachModal(event)} style={{ padding: '7px 14px', borderRadius: '8px', background: 'linear-gradient(135deg, var(--rose), var(--rose-deep))', color: '#fff', border: 'none', fontSize: '12px', fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap', flexShrink: 0 }}>Send Rate Card</button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </>
      )}

      {/* ═══ COMMUNITY BOARD ═══ */}
      {showCommunity && (
        <div className="card" style={{ padding: '24px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <div>
              <h3 style={{ margin: 0, fontSize: isMobile ? '18px' : '20px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <FiUsers size={20} style={{ color: 'var(--rose)' }} /> Vendor Community
              </h3>
              <p style={{ margin: '4px 0 0', fontSize: '13px', color: 'var(--gray)' }}>Connect, share tips, and collaborate with fellow vendors</p>
            </div>
            <button onClick={() => setShowCommunity(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--gray)' }}><FiX size={20} /></button>
          </div>
          {/* New Post */}
          <div style={{ background: 'var(--cream)', borderRadius: '12px', padding: '16px', marginBottom: '20px' }}>
            <textarea
              value={newPostContent}
              onChange={e => setNewPostContent(e.target.value)}
              placeholder="Share something with the vendor community..."
              style={{ width: '100%', minHeight: '80px', padding: '12px', borderRadius: '10px', border: '1px solid var(--cream-dark)', fontSize: '14px', resize: 'vertical', boxSizing: 'border-box', fontFamily: 'inherit', background: 'var(--white)' }}
            />
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
              <button
                onClick={submitCommunityPost}
                disabled={!newPostContent.trim() || postingCommunity}
                className="btn btn-primary btn-sm"
                style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
              >
                <FiSend size={14} /> {postingCommunity ? 'Posting...' : 'Post'}
              </button>
            </div>
          </div>
          {/* Posts Feed */}
          {communityLoading ? (
            <div style={{ textAlign: 'center', padding: '40px', color: 'var(--gray)' }}>Loading community posts...</div>
          ) : communityPosts.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px', color: 'var(--gray)' }}>
              <FiUsers size={40} style={{ opacity: 0.3, marginBottom: '12px' }} />
              <p style={{ margin: 0, fontSize: '14px' }}>No community posts yet. Be the first to share!</p>
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {communityPosts.map(post => (
                <div key={post.id} style={{ background: 'var(--white)', borderRadius: '12px', padding: '16px', border: '1px solid var(--cream-dark)' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                    {post.avatar ? (
                      <img src={post.avatar} alt="" style={{ width: '36px', height: '36px', borderRadius: '50%', objectFit: 'cover', border: '2px solid rgba(227,66,92,0.15)' }} />
                    ) : (
                      <div style={{ width: '36px', height: '36px', borderRadius: '50%', background: 'linear-gradient(135deg, var(--rose), var(--rose-deep))', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 700, fontSize: '14px', flexShrink: 0 }}>
                        {(post.name || 'V')[0]}
                      </div>
                    )}
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: 600, fontSize: '14px' }}>{post.business_name || post.name}</div>
                      <div style={{ fontSize: '11px', color: 'var(--gray)', display: 'flex', gap: '6px' }}>
                        {post.business_category && <span style={{ padding: '1px 6px', borderRadius: '6px', background: 'var(--cream)', fontSize: '10px' }}>{post.business_category}</span>}
                        <span>{new Date(post.created_at).toLocaleDateString('en-ZA', { day: 'numeric', month: 'short', year: 'numeric' })} at {new Date(post.created_at).toLocaleTimeString('en-ZA', { hour: '2-digit', minute: '2-digit' })}</span>
                      </div>
                    </div>
                    {post.vendor_id === user?.id && (
                      <button onClick={() => { if (window.confirm('Delete this post?')) deleteCommunityPost(post.id); }} title="Delete" style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--gray)', padding: '4px' }}><FiTrash2 size={14} /></button>
                    )}
                  </div>
                  <div style={{ fontSize: '14px', lineHeight: 1.6, color: 'var(--dark)', whiteSpace: 'pre-wrap' }}>{post.content}</div>
                  {post.image_url && (
                    <img src={post.image_url} alt="" style={{ maxWidth: '100%', borderRadius: '8px', marginTop: '10px', maxHeight: '300px', objectFit: 'cover' }} />
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* ─── OUTREACH COMPOSE MODAL ─── */}
      {showOutreachModal && selectedEvent && (
        <>
          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 600 }} onClick={() => setShowOutreachModal(false)} />
          <div style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: isMobile ? '95%' : '480px', maxWidth: '95%', background: 'var(--white)', borderRadius: '16px', zIndex: 601, boxShadow: '0 8px 40px rgba(0,0,0,0.2)', overflow: 'hidden', maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}>
            <div style={{ padding: '16px 20px', borderBottom: '1px solid var(--cream-dark)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h3 style={{ margin: 0, fontSize: '16px' }}>Send Outreach Message</h3>
              <button onClick={() => setShowOutreachModal(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--gray)' }}><FiX size={20} /></button>
            </div>
            <div style={{ padding: '20px', overflowY: 'auto', flex: 1 }}>
              <div style={{ marginBottom: '12px', fontSize: '13px', color: 'var(--gray)' }}>
                To: <strong>{selectedEvent.host_name}</strong> — {selectedEvent.title} ({selectedEvent.event_type} · {selectedEvent.event_date})
              </div>
              <textarea value={outreachMessage} onChange={e => setOutreachMessage(e.target.value)} style={{ width: '100%', minHeight: '100px', padding: '12px', borderRadius: '10px', border: '1px solid var(--cream-dark)', fontSize: '14px', resize: 'vertical', boxSizing: 'border-box', fontFamily: 'inherit' }} />
              {rateCards.length > 0 && (
                <div style={{ marginTop: '12px' }}>
                  <label style={{ fontSize: '12px', fontWeight: 600, marginBottom: '6px', display: 'block' }}>Attach Rate Card</label>
                  <select value={outreachRateCardId || ''} onChange={e => setOutreachRateCardId(e.target.value ? Number(e.target.value) : null)} style={{ width: '100%', padding: '8px 12px', borderRadius: '8px', border: '1px solid var(--cream-dark)', fontSize: '13px' }}>
                    <option value="">No rate card</option>
                    {rateCards.map(card => (
                      <option key={card.id} value={card.id}>{card.title} — {card.card_type === 'package' ? `${card.items?.length || 0} items` : `R${Number(card.price || 0).toLocaleString()}`}</option>
                    ))}
                  </select>
                </div>
              )}
            </div>
            <div style={{ padding: '16px 20px', borderTop: '1px solid var(--cream-dark)', display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
              <button onClick={() => setShowOutreachModal(false)} style={{ padding: '8px 20px', borderRadius: '8px', background: 'var(--cream)', border: '1px solid var(--cream-dark)', cursor: 'pointer', fontSize: '13px' }}>Cancel</button>
              <button onClick={sendOutreach} disabled={sendingOutreach || !outreachMessage.trim()} style={{ padding: '8px 24px', borderRadius: '8px', background: 'linear-gradient(135deg, var(--rose), var(--rose-deep))', color: 'white', border: 'none', fontSize: '13px', fontWeight: 600, cursor: sendingOutreach ? 'default' : 'pointer', opacity: sendingOutreach ? 0.7 : 1 }}>
                {sendingOutreach ? 'Sending...' : 'Send'}
              </button>
            </div>
          </div>
        </>
      )}

      <GigiBot
        mode="vendor"
        userName={user?.name}
        context={{ tab }}
        vendorContext={{
          unreadChats,
          pendingBookings: stats.pending,
          bookings: stats.bookings,
          portfolioCount: stats.portfolioCount,
          walletBalance: stats.walletBalance,
          chatCount: stats.chatCount,
          hasBanking: !!banking,
          businessName: profile.business_name,
          businessCategory: profile.business_category,
          businessLocation: profile.business_location,
          priceRange: profile.business_price_range,
        }}
        onAction={(type, payload) => {
          if (type === 'vendor_reply_reminder') setTab('chats');
          else if (type === 'vendor_booking_reminder') setTab('bookings');
          else if (type === 'vendor_portfolio_tip') setTab('portfolio');
          else if (type === 'vendor_banking_tip') setTab('banking');
          else if (type === 'vendor_wallet_tip') setTab('wallet');
          else if (type === 'vendor_browse_events') openBrowseEvents();
          else if (type === 'vendor_community') openCommunity();
          else if (type === 'vendor_outreach_event' && payload?.event) openOutreachModal(payload.event);
          else if (type === 'vendor_outreach') setTab('chats');
        }}
      />
        </div>
      </div>
    </div>
  );
}
